import React__default, { createElement, Component, useContext, useState, useEffect, PureComponent } from 'react';
import { format, isSameDay, subDays, isSameWeek, isSameYear, isAfter, differenceInMinutes } from 'date-fns';
import { debounce, uniq, concat, reduce, throttle } from 'lodash';
import { CircleLoader, Avatar, Modal, Button, SimpleModal, ModalContent, FancyModal, FancyContent } from '@deal/components';
import { createClient, FirebaseMessageReceiptType, FirebaseMessageChannel } from '@deal/chat-firebase-client';
export { FirebaseConversation, FirebaseMessage, FirebaseMessagePart, FirebaseUser } from '@deal/chat-firebase-client';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import hoistNonReactStatic from 'hoist-non-react-statics';
import Waypoint from 'react-waypoint';
import Measure from 'react-measure';
import classnames from 'classnames';
import Scrolllock, { TouchScrollable } from 'react-scrolllock';
import Linkify from 'linkify-it';
import VideoUrlParser from 'js-video-url-parser';
import ReactPlayer from 'react-player';
import cropUrl from 'crop-url';
import { Link as Link$1 } from 'react-router-dom';
import TextArea from 'react-autosize-textarea';
import makeAsyncScriptLoader from 'react-async-script';
import isEqual from 'lodash/isEqual';
import ReactDOM from 'react-dom';
import { Transition, animated } from 'react-spring';
import times from 'lodash/times';
import json2mq from 'json2mq';
import Tenor from 'react-tenor';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var styles = {"loader":"styles_loader__WKA0s flex flex-auto items-center justify-center"};

var Loader = function Loader(props) {
  return React__default.createElement("div", {
    className: styles.loader
  }, React__default.createElement(CircleLoader, __assign({}, props)));
};

var AcceptEscalationResultStatus;

(function (AcceptEscalationResultStatus) {
  AcceptEscalationResultStatus["ACCEPTED"] = "ACCEPTED";
  AcceptEscalationResultStatus["ALREADY_CLAIMED"] = "ALREADY_CLAIMED";
  AcceptEscalationResultStatus["ESCALATION_CLOSED"] = "ESCALATION_CLOSED";
})(AcceptEscalationResultStatus || (AcceptEscalationResultStatus = {}));

var AcceptRequestMode;

(function (AcceptRequestMode) {
  AcceptRequestMode["ALWAYS"] = "ALWAYS";
  AcceptRequestMode["WHEN_ACTIVATED"] = "WHEN_ACTIVATED";
  AcceptRequestMode["WHEN_ACTIVATED_AND_AS_BACKUP"] = "WHEN_ACTIVATED_AND_AS_BACKUP";
})(AcceptRequestMode || (AcceptRequestMode = {}));

var AirportType;

(function (AirportType) {
  AirportType["LARGE_AIRPORT"] = "LARGE_AIRPORT";
  AirportType["MEDIUM_AIRPORT"] = "MEDIUM_AIRPORT";
  AirportType["SMALL_AIRPORT"] = "SMALL_AIRPORT";
})(AirportType || (AirportType = {}));

var AttributedHtmlTextViewModelAttributeType;

(function (AttributedHtmlTextViewModelAttributeType) {
  /** Denotes this attribute is an image view model */
  AttributedHtmlTextViewModelAttributeType["IMAGE"] = "IMAGE";
})(AttributedHtmlTextViewModelAttributeType || (AttributedHtmlTextViewModelAttributeType = {}));
/** There is a 1:1 correlation between AttributeType and a GraphQL type.
 * The corresponding GraphQL type declaration name is ("AttributeValue" + pascalCaseOf(AttributeType))
 */


var AttributeType;

(function (AttributeType) {
  AttributeType["INTEGER"] = "INTEGER";
  AttributeType["INTEGER_RANGE"] = "INTEGER_RANGE";
  AttributeType["DECIMAL"] = "DECIMAL";
  AttributeType["DECIMAL_RANGE"] = "DECIMAL_RANGE";
  AttributeType["TEXT"] = "TEXT";
  AttributeType["ENUMERATION"] = "ENUMERATION";
  AttributeType["LOCAL_DATE"] = "LOCAL_DATE";
  AttributeType["LOCAL_DATE_RANGE"] = "LOCAL_DATE_RANGE";
  AttributeType["LOCAL_TIME"] = "LOCAL_TIME";
  AttributeType["LOCAL_TIME_RANGE"] = "LOCAL_TIME_RANGE";
  AttributeType["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
  AttributeType["LOCAL_DATE_TIME_RANGE"] = "LOCAL_DATE_TIME_RANGE";
  AttributeType["ZONE_ID"] = "ZONE_ID";
})(AttributeType || (AttributeType = {}));

var AttributeValidationType;

(function (AttributeValidationType) {
  /** Text value must conform to a regular expression
   * Validates TEXT attribute types
   */
  AttributeValidationType["REGEX"] = "REGEX";
  /** Ensure the amount of attribute values falls between a specified range.
   * Validates all attribute types.
   */

  AttributeValidationType["VALUE_AMOUNT"] = "VALUE_AMOUNT";
})(AttributeValidationType || (AttributeValidationType = {}));

var AuthenticationMethod;

(function (AuthenticationMethod) {
  AuthenticationMethod["NO_PASSWORD"] = "NO_PASSWORD";
  AuthenticationMethod["PASSWORD"] = "PASSWORD";
  AuthenticationMethod["CHALLENGE"] = "CHALLENGE";
  AuthenticationMethod["LOGIN_TOKEN"] = "LOGIN_TOKEN";
  AuthenticationMethod["EXTERNAL_OAUTH"] = "EXTERNAL_OAUTH";
})(AuthenticationMethod || (AuthenticationMethod = {}));

var AuthenticationResult;

(function (AuthenticationResult) {
  AuthenticationResult["SUCCESS"] = "SUCCESS";
  AuthenticationResult["FAILURE"] = "FAILURE";
  AuthenticationResult["CHALLENGE"] = "CHALLENGE";
})(AuthenticationResult || (AuthenticationResult = {}));

var BroadcastOfferType;

(function (BroadcastOfferType) {
  BroadcastOfferType["PRODUCT"] = "PRODUCT";
  BroadcastOfferType["SERVICE"] = "SERVICE";
})(BroadcastOfferType || (BroadcastOfferType = {}));

var BusinessUserActivityType;

(function (BusinessUserActivityType) {
  BusinessUserActivityType["START_RECEIVING_LEADS"] = "START_RECEIVING_LEADS";
  BusinessUserActivityType["STOP_RECEIVING_LEADS"] = "STOP_RECEIVING_LEADS";
  BusinessUserActivityType["START_ON_CALL"] = "START_ON_CALL";
  BusinessUserActivityType["STOP_ON_CALL"] = "STOP_ON_CALL";
})(BusinessUserActivityType || (BusinessUserActivityType = {}));

var BusinessUserState;

(function (BusinessUserState) {
  BusinessUserState["ACTIVE"] = "ACTIVE";
  BusinessUserState["DEACTIVATED"] = "DEACTIVATED";
  BusinessUserState["PENDING"] = "PENDING";
})(BusinessUserState || (BusinessUserState = {}));

var CallStatus;

(function (CallStatus) {
  CallStatus["QUEUED"] = "QUEUED";
  CallStatus["INITIATED"] = "INITIATED";
  CallStatus["RINGING"] = "RINGING";
  CallStatus["IN_PROGRESS"] = "IN_PROGRESS";
  CallStatus["COMPLETED"] = "COMPLETED";
  CallStatus["BUSY"] = "BUSY";
  CallStatus["NO_ANSWER"] = "NO_ANSWER";
  CallStatus["CANCELLED"] = "CANCELLED";
  CallStatus["FAILED"] = "FAILED";
  CallStatus["OTHER"] = "OTHER";
})(CallStatus || (CallStatus = {}));

var CallType;

(function (CallType) {
  CallType["EXPERT_TO_CONSUMER"] = "EXPERT_TO_CONSUMER";
  CallType["CONSUMER_TO_EXPERT"] = "CONSUMER_TO_EXPERT";
})(CallType || (CallType = {}));

var CardFieldValidationStatus;

(function (CardFieldValidationStatus) {
  CardFieldValidationStatus["PASS"] = "PASS";
  CardFieldValidationStatus["FAIL"] = "FAIL";
  CardFieldValidationStatus["UNAVAILABLE"] = "UNAVAILABLE";
  CardFieldValidationStatus["UNCHECKED"] = "UNCHECKED";
})(CardFieldValidationStatus || (CardFieldValidationStatus = {}));

var CardFundingType;

(function (CardFundingType) {
  CardFundingType["UNKNOWN"] = "UNKNOWN";
  CardFundingType["CREDIT"] = "CREDIT";
  CardFundingType["DEBIT"] = "DEBIT";
  CardFundingType["PREPAID"] = "PREPAID";
})(CardFundingType || (CardFundingType = {}));

var CartSyncUseCase;

(function (CartSyncUseCase) {
  /** Syncing to display the cart */
  CartSyncUseCase["CART_VIEW"] = "CART_VIEW";
  /** Syncing to display during the checkout flow */

  CartSyncUseCase["CHECKOUT"] = "CHECKOUT";
})(CartSyncUseCase || (CartSyncUseCase = {}));

var CategorySource;

(function (CategorySource) {
  CategorySource["DEAL"] = "DEAL";
  CategorySource["GOOGLE_PRODUCT"] = "GOOGLE_PRODUCT";
  CategorySource["YELP"] = "YELP";
})(CategorySource || (CategorySource = {}));

var CategoryType;

(function (CategoryType) {
  CategoryType["PRODUCT"] = "PRODUCT";
  CategoryType["SERVICE"] = "SERVICE";
})(CategoryType || (CategoryType = {}));

var ChallengeType;

(function (ChallengeType) {
  ChallengeType["OTP"] = "OTP";
  ChallengeType["PASSWORD"] = "PASSWORD";
})(ChallengeType || (ChallengeType = {}));

var ChannelType;

(function (ChannelType) {
  ChannelType["EMAIL"] = "EMAIL";
  ChannelType["SMS"] = "SMS";
  ChannelType["INAPP"] = "INAPP";
  ChannelType["FACEBOOK"] = "FACEBOOK";
  ChannelType["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
  ChannelType["SLACK"] = "SLACK";
})(ChannelType || (ChannelType = {}));

var ConsumerInitialLeadAction;

(function (ConsumerInitialLeadAction) {
  ConsumerInitialLeadAction["BROWSE"] = "BROWSE";
  ConsumerInitialLeadAction["CHAT"] = "CHAT";
})(ConsumerInitialLeadAction || (ConsumerInitialLeadAction = {}));

var ConsumerReviewSource;

(function (ConsumerReviewSource) {
  ConsumerReviewSource["CURATED"] = "CURATED";
  ConsumerReviewSource["SHOPPER_APPROVED"] = "SHOPPER_APPROVED";
})(ConsumerReviewSource || (ConsumerReviewSource = {}));

var ConsumerSellableReactionRating;

(function (ConsumerSellableReactionRating) {
  ConsumerSellableReactionRating["SKIP"] = "SKIP";
  ConsumerSellableReactionRating["DISLIKE"] = "DISLIKE";
  ConsumerSellableReactionRating["LIKE"] = "LIKE";
  ConsumerSellableReactionRating["LOVE"] = "LOVE";
})(ConsumerSellableReactionRating || (ConsumerSellableReactionRating = {}));

var ConsumerSellableReactionReason;

(function (ConsumerSellableReactionReason) {
  ConsumerSellableReactionReason["PRICE"] = "PRICE";
  ConsumerSellableReactionReason["BRAND"] = "BRAND";
  ConsumerSellableReactionReason["STYLE"] = "STYLE";
  ConsumerSellableReactionReason["FEATURES"] = "FEATURES";
})(ConsumerSellableReactionReason || (ConsumerSellableReactionReason = {}));

var ContactType;

(function (ContactType) {
  ContactType["PHONE"] = "PHONE";
  ContactType["EMAIL"] = "EMAIL";
  ContactType["FACEBOOK"] = "FACEBOOK";
  ContactType["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
})(ContactType || (ContactType = {}));

var DatePathFlowQuestionType;

(function (DatePathFlowQuestionType) {
  DatePathFlowQuestionType["DATE"] = "DATE";
  DatePathFlowQuestionType["DATE_TIME"] = "DATE_TIME";
})(DatePathFlowQuestionType || (DatePathFlowQuestionType = {}));

var DateRangeFilterField;

(function (DateRangeFilterField) {
  DateRangeFilterField["LAST_PAID_DATE"] = "LAST_PAID_DATE";
  DateRangeFilterField["CREATED_DATE"] = "CREATED_DATE";
  DateRangeFilterField["LAST_ACTIVITY_DATE"] = "LAST_ACTIVITY_DATE";
  DateRangeFilterField["ORDER_PAID_DATE"] = "ORDER_PAID_DATE";
  DateRangeFilterField["STARTED_DATE"] = "STARTED_DATE";
  DateRangeFilterField["COMPLETED_DATE"] = "COMPLETED_DATE";
})(DateRangeFilterField || (DateRangeFilterField = {}));

var DateRangePathFlowQuestionType;

(function (DateRangePathFlowQuestionType) {
  DateRangePathFlowQuestionType["DATE"] = "DATE";
  DateRangePathFlowQuestionType["DATE_TIME"] = "DATE_TIME";
})(DateRangePathFlowQuestionType || (DateRangePathFlowQuestionType = {}));

var DealState;

(function (DealState) {
  DealState["ACTIVE"] = "ACTIVE";
  DealState["INACTIVE"] = "INACTIVE";
})(DealState || (DealState = {}));

var DealTermsType;

(function (DealTermsType) {
  DealTermsType["PRODUCT"] = "PRODUCT";
  DealTermsType["SERVICE"] = "SERVICE";
})(DealTermsType || (DealTermsType = {}));

var DepartmentNavigationLabelStyle;

(function (DepartmentNavigationLabelStyle) {
  DepartmentNavigationLabelStyle["BOLD"] = "BOLD";
})(DepartmentNavigationLabelStyle || (DepartmentNavigationLabelStyle = {}));

var DepartmentNavigationResponsiveFullSizeOptions;

(function (DepartmentNavigationResponsiveFullSizeOptions) {
  DepartmentNavigationResponsiveFullSizeOptions["SHOW"] = "SHOW";
})(DepartmentNavigationResponsiveFullSizeOptions || (DepartmentNavigationResponsiveFullSizeOptions = {}));

var DepartmentNavigationResponsiveSmallSizeOptions;

(function (DepartmentNavigationResponsiveSmallSizeOptions) {
  /** Show element in persistent element attached to the chrome. */
  DepartmentNavigationResponsiveSmallSizeOptions["SHOW_IN_PERSISTENT_HEADER"] = "SHOW_IN_PERSISTENT_HEADER";
  /** Show element in flyout panel that expands from the side of the page */

  DepartmentNavigationResponsiveSmallSizeOptions["SHOW_IN_FLYOUT_PANEL"] = "SHOW_IN_FLYOUT_PANEL";
})(DepartmentNavigationResponsiveSmallSizeOptions || (DepartmentNavigationResponsiveSmallSizeOptions = {}));
/** Best effort enumeration of available departments for easy type safe comparisons.
 * There is no guarantee all departments will have a department type. The departments that are not assigned an
 * explicit type will be assigned `OTHER`.
 */


var DepartmentType;

(function (DepartmentType) {
  DepartmentType["WINTER_SPORTS"] = "WINTER_SPORTS";
  DepartmentType["YACHT_CHARTERS"] = "YACHT_CHARTERS";
  DepartmentType["JET_CHARTERS"] = "JET_CHARTERS";
  DepartmentType["CYCLING"] = "CYCLING";
  DepartmentType["GOLF"] = "GOLF";
  DepartmentType["JEWELRY"] = "JEWELRY";
  DepartmentType["CURATED_INTERNAL"] = "CURATED_INTERNAL";
  DepartmentType["OTHER"] = "OTHER";
})(DepartmentType || (DepartmentType = {}));

var EditableUserSourceType;

(function (EditableUserSourceType) {
  EditableUserSourceType["ORGANIC"] = "ORGANIC";
  EditableUserSourceType["INVESTOR"] = "INVESTOR";
})(EditableUserSourceType || (EditableUserSourceType = {}));

var ExpertApplicationFolderItemChangeType;

(function (ExpertApplicationFolderItemChangeType) {
  ExpertApplicationFolderItemChangeType["ADD"] = "ADD";
  ExpertApplicationFolderItemChangeType["REMOVE"] = "REMOVE";
  ExpertApplicationFolderItemChangeType["UPDATE"] = "UPDATE";
})(ExpertApplicationFolderItemChangeType || (ExpertApplicationFolderItemChangeType = {}));

var ExpertApplicationFolderType;

(function (ExpertApplicationFolderType) {
  ExpertApplicationFolderType["PIPELINE"] = "PIPELINE";
  ExpertApplicationFolderType["FOLDERS"] = "FOLDERS";
})(ExpertApplicationFolderType || (ExpertApplicationFolderType = {}));

var ExpertApplicationRating;

(function (ExpertApplicationRating) {
  ExpertApplicationRating["YES"] = "YES";
  ExpertApplicationRating["NO"] = "NO";
})(ExpertApplicationRating || (ExpertApplicationRating = {}));

var ExpertApplicationSearchSort;

(function (ExpertApplicationSearchSort) {
  ExpertApplicationSearchSort["DEFAULT"] = "DEFAULT";
  ExpertApplicationSearchSort["APPLICATION_SUBMITTED_AT"] = "APPLICATION_SUBMITTED_AT";
})(ExpertApplicationSearchSort || (ExpertApplicationSearchSort = {}));

var ExpertApplicationState;

(function (ExpertApplicationState) {
  ExpertApplicationState["REJECTED"] = "REJECTED";
  ExpertApplicationState["ONBOARDED"] = "ONBOARDED";
  ExpertApplicationState["SCHEDULING"] = "SCHEDULING";
  ExpertApplicationState["ONBOARDING"] = "ONBOARDING";
  ExpertApplicationState["APPROVED"] = "APPROVED";
  ExpertApplicationState["PENDING"] = "PENDING";
})(ExpertApplicationState || (ExpertApplicationState = {}));

var ExpertApplicationSubscriptionChangeType;

(function (ExpertApplicationSubscriptionChangeType) {
  ExpertApplicationSubscriptionChangeType["ADD"] = "ADD";
  ExpertApplicationSubscriptionChangeType["REMOVE"] = "REMOVE";
})(ExpertApplicationSubscriptionChangeType || (ExpertApplicationSubscriptionChangeType = {}));

var ExpertApplicationTaskState;

(function (ExpertApplicationTaskState) {
  ExpertApplicationTaskState["NOT_STARTED"] = "NOT_STARTED";
  ExpertApplicationTaskState["IN_PROGRESS"] = "IN_PROGRESS";
  ExpertApplicationTaskState["ERROR"] = "ERROR";
  ExpertApplicationTaskState["COMPLETED"] = "COMPLETED";
})(ExpertApplicationTaskState || (ExpertApplicationTaskState = {}));

var ExpertApplicationTaskType;

(function (ExpertApplicationTaskType) {
  ExpertApplicationTaskType["CALL_APPLICANT"] = "CALL_APPLICANT";
  ExpertApplicationTaskType["APPROVE_PROFILE"] = "APPROVE_PROFILE";
  ExpertApplicationTaskType["SIGN_CONTRACT"] = "SIGN_CONTRACT";
  ExpertApplicationTaskType["SETUP_PAYROLL"] = "SETUP_PAYROLL";
  ExpertApplicationTaskType["COMPLETE_TRAINING"] = "COMPLETE_TRAINING";
  ExpertApplicationTaskType["SETUP_7SHIFT"] = "SETUP_7SHIFT";
  ExpertApplicationTaskType["SETUP_SLACK"] = "SETUP_SLACK";
  ExpertApplicationTaskType["COMPLETE_HOMEWORK"] = "COMPLETE_HOMEWORK";
  ExpertApplicationTaskType["ADD_AVAILABILITY"] = "ADD_AVAILABILITY";
  ExpertApplicationTaskType["SCHEDULE_SHIFT"] = "SCHEDULE_SHIFT";
  ExpertApplicationTaskType["COMPLETE_FIRST_SHIFT"] = "COMPLETE_FIRST_SHIFT";
})(ExpertApplicationTaskType || (ExpertApplicationTaskType = {}));

var ExpertCuratedItemPriceOverrideReasonType;

(function (ExpertCuratedItemPriceOverrideReasonType) {
  ExpertCuratedItemPriceOverrideReasonType["PRICE_MATCH"] = "PRICE_MATCH";
  ExpertCuratedItemPriceOverrideReasonType["SPECIAL_DISCOUNT"] = "SPECIAL_DISCOUNT";
  ExpertCuratedItemPriceOverrideReasonType["OTHER"] = "OTHER";
})(ExpertCuratedItemPriceOverrideReasonType || (ExpertCuratedItemPriceOverrideReasonType = {}));

var ExpertCuratedItemRemovedReason;

(function (ExpertCuratedItemRemovedReason) {
  /** Internal reason used when an item is replaced/updated */
  ExpertCuratedItemRemovedReason["REPLACED"] = "REPLACED";
  /** Should be provided by experts to indicate they removed the item (no further reason is required for them) */

  ExpertCuratedItemRemovedReason["REMOVED_BY_EXPERT"] = "REMOVED_BY_EXPERT";
  /** Default reason that should be used if the user isn't prompted for the remaining reasons */

  ExpertCuratedItemRemovedReason["NOT_INTERESTED"] = "NOT_INTERESTED";
  ExpertCuratedItemRemovedReason["TOO_EXPENSIVE"] = "TOO_EXPENSIVE";
  ExpertCuratedItemRemovedReason["LOW_QUALITY"] = "LOW_QUALITY";
  ExpertCuratedItemRemovedReason["UGLY"] = "UGLY";
  ExpertCuratedItemRemovedReason["DONT_NEED"] = "DONT_NEED";
  ExpertCuratedItemRemovedReason["BOUGHT_ELSEWHERE"] = "BOUGHT_ELSEWHERE";
  ExpertCuratedItemRemovedReason["OTHER"] = "OTHER";
})(ExpertCuratedItemRemovedReason || (ExpertCuratedItemRemovedReason = {}));

var ExpertCuratedItemSort;

(function (ExpertCuratedItemSort) {
  /** Use the default sorting; this is the default, and should always be used in the consumer use case. */
  ExpertCuratedItemSort["DEFAULT"] = "DEFAULT";
  /** Sort only by createdAt which guarantees consistent sorting when the expert is modifying expert curated items
   * (e.g.: changing the tags, which typically changes sort order)
   */

  ExpertCuratedItemSort["CREATED_AT"] = "CREATED_AT";
})(ExpertCuratedItemSort || (ExpertCuratedItemSort = {}));
/** Basic filters based on state. When multiple filters are applied, they are OR-ed together. */


var ExpertCuratedItemStateFilter;

(function (ExpertCuratedItemStateFilter) {
  /** Include items that are in draft state (only valid for experts) */
  ExpertCuratedItemStateFilter["DRAFT"] = "DRAFT";
  /** Include items that are active (not in draft state, not removed) */

  ExpertCuratedItemStateFilter["ACTIVE"] = "ACTIVE";
  /** Include items that are removed */

  ExpertCuratedItemStateFilter["REMOVED"] = "REMOVED";
  /** Include items that not removed */

  ExpertCuratedItemStateFilter["NOT_REMOVED"] = "NOT_REMOVED";
})(ExpertCuratedItemStateFilter || (ExpertCuratedItemStateFilter = {}));

var ExpertCuratedItemTagType;

(function (ExpertCuratedItemTagType) {
  ExpertCuratedItemTagType["SPECIAL_OFFER"] = "SPECIAL_OFFER";
  ExpertCuratedItemTagType["THE_ALTERNATIVE"] = "THE_ALTERNATIVE";
  ExpertCuratedItemTagType["SALE_PRICE"] = "SALE_PRICE";
  ExpertCuratedItemTagType["EXPERT_PICK"] = "EXPERT_PICK";
  ExpertCuratedItemTagType["BUDGET_PICK"] = "BUDGET_PICK";
  ExpertCuratedItemTagType["CUSTOM"] = "CUSTOM";
  ExpertCuratedItemTagType["OTHER"] = "OTHER";
})(ExpertCuratedItemTagType || (ExpertCuratedItemTagType = {}));

var ExpertCuratedOrderClosedReason;

(function (ExpertCuratedOrderClosedReason) {
  ExpertCuratedOrderClosedReason["MANUAL"] = "MANUAL";
  ExpertCuratedOrderClosedReason["REPLACED"] = "REPLACED";
})(ExpertCuratedOrderClosedReason || (ExpertCuratedOrderClosedReason = {}));

var ExpertCuratedOrderSelectErrorCode;

(function (ExpertCuratedOrderSelectErrorCode) {
  /** Expert curated order is not in an active state. This may be due to the curated order being replaced, or manually
   * closed. If being replaced, {@link #getActiveReplacement()} will have the updated curated order.
   */
  ExpertCuratedOrderSelectErrorCode["NOT_ACTIVE"] = "NOT_ACTIVE";
})(ExpertCuratedOrderSelectErrorCode || (ExpertCuratedOrderSelectErrorCode = {}));

var ExpertCuratedOrderServiceLocationErrorCode;

(function (ExpertCuratedOrderServiceLocationErrorCode) {
  /** An invalid address was supplied. */
  ExpertCuratedOrderServiceLocationErrorCode["INVALID_ADDRESS"] = "INVALID_ADDRESS";
})(ExpertCuratedOrderServiceLocationErrorCode || (ExpertCuratedOrderServiceLocationErrorCode = {}));

var ExpertCuratedOrdersForLeadQueryCustomFilter;

(function (ExpertCuratedOrdersForLeadQueryCustomFilter) {
  /** Show custom and not custom */
  ExpertCuratedOrdersForLeadQueryCustomFilter["INCLUDE"] = "INCLUDE";
  /** Only show custom */

  ExpertCuratedOrdersForLeadQueryCustomFilter["ONLY"] = "ONLY";
  /** Show no custom; only non custom */

  ExpertCuratedOrdersForLeadQueryCustomFilter["NONE"] = "NONE";
})(ExpertCuratedOrdersForLeadQueryCustomFilter || (ExpertCuratedOrdersForLeadQueryCustomFilter = {}));

var ExpertCuratedOrdersForLeadQueryDraftFilter;

(function (ExpertCuratedOrdersForLeadQueryDraftFilter) {
  /** Show all drafts and non drafts */
  ExpertCuratedOrdersForLeadQueryDraftFilter["INCLUDE"] = "INCLUDE";
  /** Show drafts that are newly created (not from replacing an existing curated order) and non drafts */

  ExpertCuratedOrdersForLeadQueryDraftFilter["INCLUDE_CREATED_DRAFT"] = "INCLUDE_CREATED_DRAFT";
  /** Only show drafts (and no non drafts) */

  ExpertCuratedOrdersForLeadQueryDraftFilter["ONLY"] = "ONLY";
  /** Show no drafts; only non drafts */

  ExpertCuratedOrdersForLeadQueryDraftFilter["NONE"] = "NONE";
})(ExpertCuratedOrdersForLeadQueryDraftFilter || (ExpertCuratedOrdersForLeadQueryDraftFilter = {}));

var ExpertCuratedOrderState;

(function (ExpertCuratedOrderState) {
  ExpertCuratedOrderState["DRAFT"] = "DRAFT";
  ExpertCuratedOrderState["ACTIVE"] = "ACTIVE";
  ExpertCuratedOrderState["CLOSED"] = "CLOSED";
  ExpertCuratedOrderState["EXPIRED"] = "EXPIRED";
})(ExpertCuratedOrderState || (ExpertCuratedOrderState = {}));

var ExpertGender;

(function (ExpertGender) {
  ExpertGender["MALE"] = "MALE";
  ExpertGender["FEMALE"] = "FEMALE";
  ExpertGender["OTHER"] = "OTHER";
})(ExpertGender || (ExpertGender = {}));

var ExpertLeadFolderGroupType;

(function (ExpertLeadFolderGroupType) {
  ExpertLeadFolderGroupType["INBOX"] = "INBOX";
  ExpertLeadFolderGroupType["INBOX_ASSISTANT"] = "INBOX_ASSISTANT";
  ExpertLeadFolderGroupType["SALES_PIPELINE"] = "SALES_PIPELINE";
  ExpertLeadFolderGroupType["FOLDERS"] = "FOLDERS";
})(ExpertLeadFolderGroupType || (ExpertLeadFolderGroupType = {}));

var ExpertLeadFolderItemChangeType;

(function (ExpertLeadFolderItemChangeType) {
  ExpertLeadFolderItemChangeType["ADD"] = "ADD";
  ExpertLeadFolderItemChangeType["REMOVE"] = "REMOVE";
  ExpertLeadFolderItemChangeType["UPDATE"] = "UPDATE";
})(ExpertLeadFolderItemChangeType || (ExpertLeadFolderItemChangeType = {}));

var ExpertNewMessageNotificationMode;

(function (ExpertNewMessageNotificationMode) {
  ExpertNewMessageNotificationMode["NONE"] = "NONE";
  ExpertNewMessageNotificationMode["ALWAYS"] = "ALWAYS";
  ExpertNewMessageNotificationMode["WHEN_NOT_ACTIVATED"] = "WHEN_NOT_ACTIVATED";
})(ExpertNewMessageNotificationMode || (ExpertNewMessageNotificationMode = {}));

var ExpertNotificationType;

(function (ExpertNotificationType) {
  ExpertNotificationType["LEAD_ESCALATION"] = "LEAD_ESCALATION";
})(ExpertNotificationType || (ExpertNotificationType = {}));

var ExpertPerformanceRating;

(function (ExpertPerformanceRating) {
  ExpertPerformanceRating["NEW"] = "NEW";
  ExpertPerformanceRating["PLATINUM"] = "PLATINUM";
  ExpertPerformanceRating["GOLD"] = "GOLD";
  ExpertPerformanceRating["SILVER"] = "SILVER";
  ExpertPerformanceRating["BRONZE"] = "BRONZE";
})(ExpertPerformanceRating || (ExpertPerformanceRating = {}));

var ExpertProfileState;

(function (ExpertProfileState) {
  ExpertProfileState["DRAFT"] = "DRAFT";
  ExpertProfileState["SUBMITTED"] = "SUBMITTED";
  ExpertProfileState["PUBLISHED"] = "PUBLISHED";
})(ExpertProfileState || (ExpertProfileState = {}));

var ExpertRecommendationStrategy;

(function (ExpertRecommendationStrategy) {
  ExpertRecommendationStrategy["LEAST_WORKLOAD"] = "LEAST_WORKLOAD";
  ExpertRecommendationStrategy["PERFORMANCE_WEIGHTED"] = "PERFORMANCE_WEIGHTED";
})(ExpertRecommendationStrategy || (ExpertRecommendationStrategy = {}));

var ExpertSearchSort;

(function (ExpertSearchSort) {
  ExpertSearchSort["DEFAULT"] = "DEFAULT";
  ExpertSearchSort["PERFORMANCE"] = "PERFORMANCE";
})(ExpertSearchSort || (ExpertSearchSort = {}));

var ExternalAdPlatform;

(function (ExternalAdPlatform) {
  ExternalAdPlatform["FACEBOOK"] = "FACEBOOK";
  ExternalAdPlatform["GOOGLE"] = "GOOGLE";
})(ExternalAdPlatform || (ExternalAdPlatform = {}));

var ExternalAdStatus;

(function (ExternalAdStatus) {
  ExternalAdStatus["ACTIVE"] = "ACTIVE";
  ExternalAdStatus["PAUSED"] = "PAUSED";
  ExternalAdStatus["DELETED"] = "DELETED";
})(ExternalAdStatus || (ExternalAdStatus = {}));

var ExternalProfileType;

(function (ExternalProfileType) {
  ExternalProfileType["FACEBOOK_MESSENGER"] = "FACEBOOK_MESSENGER";
  ExternalProfileType["PIPL"] = "PIPL";
})(ExternalProfileType || (ExternalProfileType = {}));

var ExternalVideoIdType;

(function (ExternalVideoIdType) {
  ExternalVideoIdType["YOUTUBE"] = "YOUTUBE";
  ExternalVideoIdType["VIMEO"] = "VIMEO";
})(ExternalVideoIdType || (ExternalVideoIdType = {}));

var FacetImageType;

(function (FacetImageType) {
  /** Facets that are shown as Icons on the UI */
  FacetImageType["ICON"] = "ICON";
  /** BACKGROUND */

  FacetImageType["BACKGROUND"] = "BACKGROUND";
})(FacetImageType || (FacetImageType = {}));

var FlightPlanEditErrorCode;

(function (FlightPlanEditErrorCode) {
  FlightPlanEditErrorCode["EMPTY_LEGS"] = "EMPTY_LEGS";
  FlightPlanEditErrorCode["NO_SUCH_LEG"] = "NO_SUCH_LEG";
  FlightPlanEditErrorCode["MISSING_AIRPORT"] = "MISSING_AIRPORT";
  FlightPlanEditErrorCode["SAME_AIRPORT"] = "SAME_AIRPORT";
  FlightPlanEditErrorCode["OVERLAPPING_LEGS"] = "OVERLAPPING_LEGS";
  FlightPlanEditErrorCode["NOT_DRAFT"] = "NOT_DRAFT";
})(FlightPlanEditErrorCode || (FlightPlanEditErrorCode = {}));

var FlightPlanState;

(function (FlightPlanState) {
  FlightPlanState["DRAFT"] = "DRAFT";
  FlightPlanState["ACTIVE"] = "ACTIVE";
})(FlightPlanState || (FlightPlanState = {}));

var FrontendTaskStatus;

(function (FrontendTaskStatus) {
  FrontendTaskStatus["CREATED"] = "CREATED";
  FrontendTaskStatus["PROCESSING"] = "PROCESSING";
  FrontendTaskStatus["COMPLETED"] = "COMPLETED";
  FrontendTaskStatus["ABORTED"] = "ABORTED";
})(FrontendTaskStatus || (FrontendTaskStatus = {}));

var HandleType;

(function (HandleType) {
  HandleType["EMAIL"] = "EMAIL";
  HandleType["PHONE"] = "PHONE";
})(HandleType || (HandleType = {}));

var IdPathFlowQuestionType;

(function (IdPathFlowQuestionType) {
  IdPathFlowQuestionType["MEDIA_ID_IMAGE_UPLOAD"] = "MEDIA_ID_IMAGE_UPLOAD";
  IdPathFlowQuestionType["EXPERT_ID_SELECTION"] = "EXPERT_ID_SELECTION";
  IdPathFlowQuestionType["PRODUCTS_TYPEAHEAD"] = "PRODUCTS_TYPEAHEAD";
  IdPathFlowQuestionType["FLIGHT_PLAN"] = "FLIGHT_PLAN";
})(IdPathFlowQuestionType || (IdPathFlowQuestionType = {}));

var InputTextPathFlowQuestionFieldType;

(function (InputTextPathFlowQuestionFieldType) {
  /** Typeahead for airports only */
  InputTextPathFlowQuestionFieldType["AIRPORT_TYPEAHEAD"] = "AIRPORT_TYPEAHEAD";
  /** Single line "telephone" with SMS text context */

  InputTextPathFlowQuestionFieldType["SMS_TEXT"] = "SMS_TEXT";
  /** Facebook user expectedReference */

  InputTextPathFlowQuestionFieldType["FACEBOOK_USER_REF"] = "FACEBOOK_USER_REF";
  /** FCM Token */

  InputTextPathFlowQuestionFieldType["FCM_TOKEN"] = "FCM_TOKEN";
  /** Single line text entry */

  InputTextPathFlowQuestionFieldType["INPUT_FIELD"] = "INPUT_FIELD";
  /** Multi-line text area */

  InputTextPathFlowQuestionFieldType["TEXT_AREA"] = "TEXT_AREA";
  /** Single line entry (numeric only) */

  InputTextPathFlowQuestionFieldType["NUMERIC"] = "NUMERIC";
  /** Single line "telephone"-like entry (numeric only) */

  InputTextPathFlowQuestionFieldType["TELEPHONE"] = "TELEPHONE";
  /** Single line "telephone" with its own submit action */

  InputTextPathFlowQuestionFieldType["TELEPHONE_SUBMIT"] = "TELEPHONE_SUBMIT";
  /** Single line "email"-like entry (shows @ sign) */

  InputTextPathFlowQuestionFieldType["EMAIL"] = "EMAIL";
  /** Text which is provided programmatically, thus should be hidden from the user */

  InputTextPathFlowQuestionFieldType["HIDDEN"] = "HIDDEN";
})(InputTextPathFlowQuestionFieldType || (InputTextPathFlowQuestionFieldType = {}));

var InputTextPathFlowQuestionValidationType;

(function (InputTextPathFlowQuestionValidationType) {
  InputTextPathFlowQuestionValidationType["LENGTH"] = "LENGTH";
  InputTextPathFlowQuestionValidationType["REGEX"] = "REGEX";
  InputTextPathFlowQuestionValidationType["PHONE_NUMBER"] = "PHONE_NUMBER";
})(InputTextPathFlowQuestionValidationType || (InputTextPathFlowQuestionValidationType = {}));

var InterstitialPathFlowPageMetadataType;

(function (InterstitialPathFlowPageMetadataType) {
  InterstitialPathFlowPageMetadataType["ALMOST_DONE"] = "ALMOST_DONE";
  InterstitialPathFlowPageMetadataType["BROWSE_EXPERTS"] = "BROWSE_EXPERTS";
  InterstitialPathFlowPageMetadataType["CALCULATING"] = "CALCULATING";
  InterstitialPathFlowPageMetadataType["CONNECTING_TO_OPERATOR"] = "CONNECTING_TO_OPERATOR";
  InterstitialPathFlowPageMetadataType["FINDING_MERCHANTS"] = "FINDING_MERCHANTS";
  /** GENERIC_WITH_BUTTON interstitial uses a button to submit */

  InterstitialPathFlowPageMetadataType["GENERIC_WITH_BUTTON"] = "GENERIC_WITH_BUTTON";
  /** GENERIC_WITH_TITLE interstitial that uses timer to submit */

  InterstitialPathFlowPageMetadataType["GENERIC_WITH_TITLE"] = "GENERIC_WITH_TITLE";
  InterstitialPathFlowPageMetadataType["HIGH_SECURITY"] = "HIGH_SECURITY";
  InterstitialPathFlowPageMetadataType["LOADING_QUESTIONS"] = "LOADING_QUESTIONS";
  InterstitialPathFlowPageMetadataType["SNOWBOARD_INT_LEARN"] = "SNOWBOARD_INT_LEARN";
  InterstitialPathFlowPageMetadataType["WELCOME"] = "WELCOME";
  InterstitialPathFlowPageMetadataType["GIVE_US_A_SEC"] = "GIVE_US_A_SEC";
  InterstitialPathFlowPageMetadataType["REQUEST_PUSH_NOTIFICATION_PERMISSION"] = "REQUEST_PUSH_NOTIFICATION_PERMISSION";
})(InterstitialPathFlowPageMetadataType || (InterstitialPathFlowPageMetadataType = {}));

var LeadActivityType;

(function (LeadActivityType) {
  LeadActivityType["DELEGATE_EXPERT_CHANGED"] = "DELEGATE_EXPERT_CHANGED";
  LeadActivityType["SNOOZE_CHANGED"] = "SNOOZE_CHANGED";
  LeadActivityType["WOKE_UP_FROM_SNOOZE"] = "WOKE_UP_FROM_SNOOZE";
  LeadActivityType["REASSIGNED"] = "REASSIGNED";
  LeadActivityType["ARCHIVED"] = "ARCHIVED";
  LeadActivityType["CONSUMER_FIRST_MESSAGE_SENT"] = "CONSUMER_FIRST_MESSAGE_SENT";
  LeadActivityType["CONSUMER_CALLED"] = "CONSUMER_CALLED";
  LeadActivityType["CONSUMER_PAYMENT_FAILED"] = "CONSUMER_PAYMENT_FAILED";
  LeadActivityType["CONSUMER_PAYMENT_SUCCEEDED"] = "CONSUMER_PAYMENT_SUCCEEDED";
  LeadActivityType["CONSUMER_ORDER_PAID"] = "CONSUMER_ORDER_PAID";
  LeadActivityType["CONSUMER_REVIEW_ADDED"] = "CONSUMER_REVIEW_ADDED";
  LeadActivityType["ESCALATION_STARTED"] = "ESCALATION_STARTED";
  LeadActivityType["ESCALATION_CHANGED"] = "ESCALATION_CHANGED";
  LeadActivityType["QUALITY_CONVERSATION_ESTABLISHED"] = "QUALITY_CONVERSATION_ESTABLISHED";
})(LeadActivityType || (LeadActivityType = {}));

var LeadCampaignState;

(function (LeadCampaignState) {
  LeadCampaignState["DRAFT"] = "DRAFT";
  LeadCampaignState["SCHEDULED"] = "SCHEDULED";
  LeadCampaignState["COMPLETED"] = "COMPLETED";
})(LeadCampaignState || (LeadCampaignState = {}));

var LeadEscalationLevel;

(function (LeadEscalationLevel) {
  LeadEscalationLevel["NOT_STARTED"] = "NOT_STARTED";
  LeadEscalationLevel["ONLINE_TEAM_MEMBERS"] = "ONLINE_TEAM_MEMBERS";
  LeadEscalationLevel["ALL_TEAM_MEMBERS"] = "ALL_TEAM_MEMBERS";
  LeadEscalationLevel["SUPPORT"] = "SUPPORT";
  LeadEscalationLevel["ONLINE_EXPERTS"] = "ONLINE_EXPERTS";
  LeadEscalationLevel["ALL_EXPERTS"] = "ALL_EXPERTS";
  LeadEscalationLevel["ON_CALL_EXPERTS"] = "ON_CALL_EXPERTS";
})(LeadEscalationLevel || (LeadEscalationLevel = {}));

var LeadEscalationStatus;

(function (LeadEscalationStatus) {
  LeadEscalationStatus["OPEN"] = "OPEN";
  LeadEscalationStatus["CLOSED"] = "CLOSED";
})(LeadEscalationStatus || (LeadEscalationStatus = {}));

var LeadEscalationType;

(function (LeadEscalationType) {
  LeadEscalationType["CONSUMER_WAITING_RESPONSE"] = "CONSUMER_WAITING_RESPONSE";
})(LeadEscalationType || (LeadEscalationType = {}));

var LeadExpertRole;

(function (LeadExpertRole) {
  LeadExpertRole["PRIMARY"] = "PRIMARY";
  LeadExpertRole["DELEGATE"] = "DELEGATE";
})(LeadExpertRole || (LeadExpertRole = {}));

var LeadParticipantType;

(function (LeadParticipantType) {
  LeadParticipantType["EXPERT"] = "EXPERT";
  LeadParticipantType["DELEGATE_EXPERT"] = "DELEGATE_EXPERT";
  LeadParticipantType["CONSUMER"] = "CONSUMER";
  LeadParticipantType["ASSISTANT"] = "ASSISTANT";
  LeadParticipantType["DEAL_BOT"] = "DEAL_BOT";
})(LeadParticipantType || (LeadParticipantType = {}));

var LeadReassignmentReason;

(function (LeadReassignmentReason) {
  LeadReassignmentReason["EXPERT_DEACTIVATED"] = "EXPERT_DEACTIVATED";
  LeadReassignmentReason["OTHER"] = "OTHER";
})(LeadReassignmentReason || (LeadReassignmentReason = {}));

var LeadSortOrder;

(function (LeadSortOrder) {
  LeadSortOrder["ACTIVITY_DATE"] = "ACTIVITY_DATE";
  LeadSortOrder["CREATION_DATE"] = "CREATION_DATE";
})(LeadSortOrder || (LeadSortOrder = {}));

var ListPathFlowQuestionRenderStyle;

(function (ListPathFlowQuestionRenderStyle) {
  /** The default/stock rendering style that is guaranteed to fit in with the rest of the components, and will have the
   * best support in combining different options that impact rendering. Unless a path with a specific UI treatment is
   * being tested, using DEFAULT is strongly recommended.
   */
  ListPathFlowQuestionRenderStyle["DEFAULT"] = "DEFAULT";
  /** If images should be rendered as full width (bleeds into edges of select container) */

  ListPathFlowQuestionRenderStyle["FULL_WIDTH_IMAGES"] = "FULL_WIDTH_IMAGES";
  /** If text should be rendered as an overlay of the image in the background */

  ListPathFlowQuestionRenderStyle["OVERLAY_IMAGE"] = "OVERLAY_IMAGE";
  /** Use a simpler radio style select that doesn't render the full cards */

  ListPathFlowQuestionRenderStyle["SIMPLE_RADIO"] = "SIMPLE_RADIO";
})(ListPathFlowQuestionRenderStyle || (ListPathFlowQuestionRenderStyle = {}));

var ListPathFlowQuestionType;

(function (ListPathFlowQuestionType) {
  ListPathFlowQuestionType["SINGLE_SELECT_LIST"] = "SINGLE_SELECT_LIST";
  ListPathFlowQuestionType["MULTI_SELECT_LIST"] = "MULTI_SELECT_LIST";
  ListPathFlowQuestionType["DROP_DOWN"] = "DROP_DOWN";
  ListPathFlowQuestionType["MULTI_SELECT_PILLS"] = "MULTI_SELECT_PILLS";
})(ListPathFlowQuestionType || (ListPathFlowQuestionType = {}));

var MessageBodyType;

(function (MessageBodyType) {
  MessageBodyType["TEXT"] = "TEXT";
  MessageBodyType["FILE"] = "FILE";
  MessageBodyType["AUDIO"] = "AUDIO";
  MessageBodyType["VIDEO"] = "VIDEO";
  MessageBodyType["IMAGE"] = "IMAGE";
  MessageBodyType["MULTI_MEDIA"] = "MULTI_MEDIA";
  MessageBodyType["OFFER"] = "OFFER";
  MessageBodyType["DEAL"] = "DEAL";
  MessageBodyType["VIDEO_CHAT_REQUESTED"] = "VIDEO_CHAT_REQUESTED";
  MessageBodyType["VIDEO_CHAT_DECLINED"] = "VIDEO_CHAT_DECLINED";
  MessageBodyType["OTHER"] = "OTHER";
})(MessageBodyType || (MessageBodyType = {}));

var MessageRichCardType;

(function (MessageRichCardType) {
  MessageRichCardType["ONBOARDING_REQUEST_CONFIRMATION"] = "ONBOARDING_REQUEST_CONFIRMATION";
  MessageRichCardType["ONBOARDING_HOW_CURATED_WORKS"] = "ONBOARDING_HOW_CURATED_WORKS";
  MessageRichCardType["ONBOARDING_EXPERT_JOINED"] = "ONBOARDING_EXPERT_JOINED";
  MessageRichCardType["NEW_CUSTOM_CURATED_ORDER"] = "NEW_CUSTOM_CURATED_ORDER";
  MessageRichCardType["NEW_BOOKABLE_CURATED_ORDER"] = "NEW_BOOKABLE_CURATED_ORDER";
  MessageRichCardType["NEW_EXPERT_CURATED_ORDER_LIST"] = "NEW_EXPERT_CURATED_ORDER_LIST";
  MessageRichCardType["CONSUMER_INTERESTED_IN_CURATED_ORDER"] = "CONSUMER_INTERESTED_IN_CURATED_ORDER";
  MessageRichCardType["NEW_EXPERT_CURATED_ITEMS"] = "NEW_EXPERT_CURATED_ITEMS";
  MessageRichCardType["NEW_SYSTEM_CURATED_ITEMS"] = "NEW_SYSTEM_CURATED_ITEMS";
  MessageRichCardType["UPDATED_EXPERT_CURATED_ITEMS"] = "UPDATED_EXPERT_CURATED_ITEMS";
  MessageRichCardType["FEEDBACK_REQUEST_FROM_EXPERT"] = "FEEDBACK_REQUEST_FROM_EXPERT";
  MessageRichCardType["REFERRAL_REQUEST_FROM_EXPERT"] = "REFERRAL_REQUEST_FROM_EXPERT";
  MessageRichCardType["SYSTEM_CURATED_ITEM_SURVEY"] = "SYSTEM_CURATED_ITEM_SURVEY";
  MessageRichCardType["SIMPLE_CURATED_ORDER"] = "SIMPLE_CURATED_ORDER";
  MessageRichCardType["CONTACT_COLLECTION_REQUEST"] = "CONTACT_COLLECTION_REQUEST";
})(MessageRichCardType || (MessageRichCardType = {}));

var MessageUnsubscribeTag;

(function (MessageUnsubscribeTag) {
  MessageUnsubscribeTag["CURATION"] = "CURATION";
  MessageUnsubscribeTag["ONBOARDING"] = "ONBOARDING";
  MessageUnsubscribeTag["MESSAGE_NOTIFICATION"] = "MESSAGE_NOTIFICATION";
  MessageUnsubscribeTag["POST_PURCHASE"] = "POST_PURCHASE";
  MessageUnsubscribeTag["ABANDONED_ORDER"] = "ABANDONED_ORDER";
  MessageUnsubscribeTag["PATH_ONBOARDING"] = "PATH_ONBOARDING";
  MessageUnsubscribeTag["REFERRAL"] = "REFERRAL";
})(MessageUnsubscribeTag || (MessageUnsubscribeTag = {}));

var MessagingChannelType;

(function (MessagingChannelType) {
  MessagingChannelType["SMS"] = "SMS";
  MessagingChannelType["EMAIL"] = "EMAIL";
  MessagingChannelType["FACEBOOK"] = "FACEBOOK";
  MessagingChannelType["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
})(MessagingChannelType || (MessagingChannelType = {}));

var MessagingUserType;

(function (MessagingUserType) {
  MessagingUserType["USER"] = "USER";
  MessagingUserType["MERCHANT"] = "MERCHANT";
  MessagingUserType["BUSINESS_USER"] = "BUSINESS_USER";
  MessagingUserType["OPERATOR"] = "OPERATOR";
  MessagingUserType["DEAL_BOT"] = "DEAL_BOT";
  MessagingUserType["ONBOARDING_SPECIALIST"] = "ONBOARDING_SPECIALIST";
})(MessagingUserType || (MessagingUserType = {}));

var MonetaryAmountDenominationType;

(function (MonetaryAmountDenominationType) {
  /** Return amount in the default denomination (e.g.: dollars and cents, e.g.: "12.34" for $12.34 */
  MonetaryAmountDenominationType["DEFAULT"] = "DEFAULT";
  /** Return amount in the smallest denomination for the given currency (e.g.: "1234" for $12.34) */

  MonetaryAmountDenominationType["SMALLEST"] = "SMALLEST";
})(MonetaryAmountDenominationType || (MonetaryAmountDenominationType = {}));

var NumericPathFlowQuestionDisplayType;

(function (NumericPathFlowQuestionDisplayType) {
  NumericPathFlowQuestionDisplayType["HEIGHT_IN_INCHES"] = "HEIGHT_IN_INCHES";
  NumericPathFlowQuestionDisplayType["STAR_RATING"] = "STAR_RATING";
})(NumericPathFlowQuestionDisplayType || (NumericPathFlowQuestionDisplayType = {}));

var NumericPathFlowQuestionUnitType;

(function (NumericPathFlowQuestionUnitType) {
  NumericPathFlowQuestionUnitType["INCHES"] = "INCHES";
  NumericPathFlowQuestionUnitType["FEET"] = "FEET";
  NumericPathFlowQuestionUnitType["POUNDS"] = "POUNDS";
  NumericPathFlowQuestionUnitType["CENTIMETERS"] = "CENTIMETERS";
  NumericPathFlowQuestionUnitType["KILOGRAMS"] = "KILOGRAMS";
})(NumericPathFlowQuestionUnitType || (NumericPathFlowQuestionUnitType = {}));

var NumericPathFlowQuestionValueType;

(function (NumericPathFlowQuestionValueType) {
  NumericPathFlowQuestionValueType["INTEGER"] = "INTEGER";
  NumericPathFlowQuestionValueType["DECIMAL"] = "DECIMAL";
})(NumericPathFlowQuestionValueType || (NumericPathFlowQuestionValueType = {}));

var NumericRangeDisplayFacetType;

(function (NumericRangeDisplayFacetType) {
  /** Render the number as is */
  NumericRangeDisplayFacetType["DEFAULT"] = "DEFAULT";
  /** Render the number (represented in cents) as USD currency */

  NumericRangeDisplayFacetType["USD_CURRENCY"] = "USD_CURRENCY";
})(NumericRangeDisplayFacetType || (NumericRangeDisplayFacetType = {}));

var OAuthType;

(function (OAuthType) {
  OAuthType["FACEBOOK"] = "FACEBOOK";
  OAuthType["GOOGLE"] = "GOOGLE";
})(OAuthType || (OAuthType = {}));

var OfferState;

(function (OfferState) {
  OfferState["INITIAL"] = "INITIAL";
  OfferState["GENERATED"] = "GENERATED";
  OfferState["ACCEPTED"] = "ACCEPTED";
  OfferState["EXPIRED"] = "EXPIRED";
  OfferState["WITHDRAWN"] = "WITHDRAWN";
})(OfferState || (OfferState = {}));
/** =============
 * Ops UI permission
 * =============
 */


var OperatorPermission;

(function (OperatorPermission) {
  OperatorPermission["UI_OPS_MANAGE_CATALOG"] = "UI_OPS_MANAGE_CATALOG";
  OperatorPermission["UI_OPS_MANAGE_LEADS"] = "UI_OPS_MANAGE_LEADS";
  OperatorPermission["UI_OPS_MANAGE_CONSUMERS"] = "UI_OPS_MANAGE_CONSUMERS";
  OperatorPermission["UI_OPS_MANAGE_MERCHANTS"] = "UI_OPS_MANAGE_MERCHANTS";
  OperatorPermission["UI_OPS_MANAGE_EXPERTS"] = "UI_OPS_MANAGE_EXPERTS";
  OperatorPermission["UI_OPS_DEVTOOLS"] = "UI_OPS_DEVTOOLS";
  OperatorPermission["UI_OPS_MANAGE_ALL_ORDERS"] = "UI_OPS_MANAGE_ALL_ORDERS";
  OperatorPermission["UI_OPS_MANAGE_ASSIGNED_ORDERS"] = "UI_OPS_MANAGE_ASSIGNED_ORDERS";
  OperatorPermission["UI_OPS_RESEARCH_ORDER_FULFILLMENT"] = "UI_OPS_RESEARCH_ORDER_FULFILLMENT";
  OperatorPermission["UI_OPS_FULFILL_ORDERS"] = "UI_OPS_FULFILL_ORDERS";
  OperatorPermission["UI_OPS_TEST_TRIGGER"] = "UI_OPS_TEST_TRIGGER";
  OperatorPermission["UI_OPS_ASSISTANT"] = "UI_OPS_ASSISTANT";
})(OperatorPermission || (OperatorPermission = {}));

var OperatorRole;

(function (OperatorRole) {
  OperatorRole["OPERATOR"] = "OPERATOR";
  OperatorRole["RESEARCHER"] = "RESEARCHER";
  OperatorRole["CATALOG_MANAGER"] = "CATALOG_MANAGER";
  OperatorRole["ONBOARDING_SPECIALIST"] = "ONBOARDING_SPECIALIST";
  OperatorRole["LEAD_SUPPORT"] = "LEAD_SUPPORT";
  OperatorRole["ORDER_SUPPORT"] = "ORDER_SUPPORT";
  OperatorRole["SUPER_ADMIN"] = "SUPER_ADMIN";
  OperatorRole["ADMIN"] = "ADMIN";
})(OperatorRole || (OperatorRole = {}));

var OrderChargeableStatusType;

(function (OrderChargeableStatusType) {
  /** The order can be charged */
  OrderChargeableStatusType["CAN_CHARGE"] = "CAN_CHARGE";
  /** The order has already been charged. */

  OrderChargeableStatusType["ALREADY_CHARGED"] = "ALREADY_CHARGED";
  /** The order is empty. */

  OrderChargeableStatusType["EMPTY"] = "EMPTY";
  /** The order requires a shipping address, but none was provided. Not relevant for OrderChargeableUseCase.CHECKOUT */

  OrderChargeableStatusType["NO_SHIPPING_ADDRESS"] = "NO_SHIPPING_ADDRESS";
  /** The order requires a service address, but none was set by the expert. Orders should never reach the customer in
   * this state as the address should be set by the expert beforehand.
   */

  OrderChargeableStatusType["NO_SERVICE_LOCATION"] = "NO_SERVICE_LOCATION";
  /** The order is expired; the user must reach out to the expert to renew the order. */

  OrderChargeableStatusType["EXPIRED"] = "EXPIRED";
  /** The order requires a minimum amount (e.g.: Orders shipped to Australia need to have at least $125 in the cart)
   * Use the `message` property on `OrderChargeableStatus` to display a message containing the exact amount the user
   * needs.
   */

  OrderChargeableStatusType["BELOW_MINIMUM_AMOUNT"] = "BELOW_MINIMUM_AMOUNT";
  /** The order is in a preview state (only available for viewing); the user must reach out to the expert to receive
   * a new purchase-able order.
   */

  OrderChargeableStatusType["IN_PREVIEW"] = "IN_PREVIEW";
})(OrderChargeableStatusType || (OrderChargeableStatusType = {}));

var OrderChargeableUseCase;

(function (OrderChargeableUseCase) {
  /** Checking if the checkout process can be started */
  OrderChargeableUseCase["CHECKOUT"] = "CHECKOUT";
  /** Checking if the order can be purchased (payment provided to stripe/paypal/etc, and order charged) */

  OrderChargeableUseCase["PURCHASE"] = "PURCHASE";
})(OrderChargeableUseCase || (OrderChargeableUseCase = {}));

var OrderCostComponent;

(function (OrderCostComponent) {
  /** Includes the price for AD_HOC, SELLABLE, and BASE_PRICE source types (the core price of what's being purchased) */
  OrderCostComponent["CORE"] = "CORE";
  /** Tip paid to Deal.com experts */

  OrderCostComponent["EXPERT_TIP"] = "EXPERT_TIP";
  /** Fixed gratuity (e.g.: mandatory crew gratuity for charters) */

  OrderCostComponent["GRATUITY"] = "GRATUITY";
  /** Shipping */

  OrderCostComponent["SHIPMENT"] = "SHIPMENT";
  /** Tax */

  OrderCostComponent["TAX_ADJUSTMENTS"] = "TAX_ADJUSTMENTS";
  /** Discounts through promotions */

  OrderCostComponent["DISCOUNT_ADJUSTMENTS"] = "DISCOUNT_ADJUSTMENTS";
})(OrderCostComponent || (OrderCostComponent = {}));

var OrderEscalationSearchSort;

(function (OrderEscalationSearchSort) {
  OrderEscalationSearchSort["CREATED_AT"] = "CREATED_AT";
  OrderEscalationSearchSort["STATUS"] = "STATUS";
  OrderEscalationSearchSort["ORDER_ID"] = "ORDER_ID";
  OrderEscalationSearchSort["USER_ID"] = "USER_ID";
  OrderEscalationSearchSort["PAID_AT"] = "PAID_AT";
})(OrderEscalationSearchSort || (OrderEscalationSearchSort = {}));

var OrderEscalationStatus;

(function (OrderEscalationStatus) {
  OrderEscalationStatus["NEW"] = "NEW";
  OrderEscalationStatus["IN_PROGRESS"] = "IN_PROGRESS";
  OrderEscalationStatus["COMPLETED"] = "COMPLETED";
})(OrderEscalationStatus || (OrderEscalationStatus = {}));

var OrderEscalationType;

(function (OrderEscalationType) {
  OrderEscalationType["ITEM_UNAVAILABLE"] = "ITEM_UNAVAILABLE";
  OrderEscalationType["MISSING_SPECS"] = "MISSING_SPECS";
  OrderEscalationType["ORDER_ADJUSTMENT"] = "ORDER_ADJUSTMENT";
  OrderEscalationType["CANCELLATION"] = "CANCELLATION";
  OrderEscalationType["RETURN"] = "RETURN";
  OrderEscalationType["EXCHANGE"] = "EXCHANGE";
  OrderEscalationType["MISSING_ITEM"] = "MISSING_ITEM";
})(OrderEscalationType || (OrderEscalationType = {}));

var OrderFulfillmentState;

(function (OrderFulfillmentState) {
  OrderFulfillmentState["NEW"] = "NEW";
  OrderFulfillmentState["CLAIMED"] = "CLAIMED";
  OrderFulfillmentState["READY"] = "READY";
  OrderFulfillmentState["FULFILLED"] = "FULFILLED";
})(OrderFulfillmentState || (OrderFulfillmentState = {}));

var OrderLabel;

(function (OrderLabel) {
  OrderLabel["UNCLAIMED"] = "UNCLAIMED";
  OrderLabel["TRACKING_NEEDED"] = "TRACKING_NEEDED";
  OrderLabel["TRACKING_OVERDUE"] = "TRACKING_OVERDUE";
})(OrderLabel || (OrderLabel = {}));

var OrderLineItemGroupPriceStrategy;

(function (OrderLineItemGroupPriceStrategy) {
  /** This line item has no price, and is strictly added as a grouping line item with the children having prices. */
  OrderLineItemGroupPriceStrategy["IGNORE_SELF_DEFAULT_CHILDREN"] = "IGNORE_SELF_DEFAULT_CHILDREN";
  /** This line item has a price, with the child line item prices being ignored / not respected. */

  OrderLineItemGroupPriceStrategy["ONLY_SELF_IGNORE_CHILDREN"] = "ONLY_SELF_IGNORE_CHILDREN";
})(OrderLineItemGroupPriceStrategy || (OrderLineItemGroupPriceStrategy = {}));

var OrderLineItemGroupTaxStrategy;

(function (OrderLineItemGroupTaxStrategy) {
  /** All line items will retain their default tax calculation. */
  OrderLineItemGroupTaxStrategy["DEFAULT"] = "DEFAULT";
  /** All line items that are children of the current line item will use the current line item's tax calculation.
   * This is useful when the grouping parent line item is a service (e.g.: charters) that are taxed using the service
   * location - not the shipping address. This strategy will use that same calculation (service location) for all child
   * line items (e.g.: ensure that add-on food line item is taxed like the charter).
   */

  OrderLineItemGroupTaxStrategy["PROPAGATE_SELF_TO_CHILDREN"] = "PROPAGATE_SELF_TO_CHILDREN";
})(OrderLineItemGroupTaxStrategy || (OrderLineItemGroupTaxStrategy = {}));

var OrderLineItemSourceType;

(function (OrderLineItemSourceType) {
  /** No additional metadata; ad-hoc line item */
  OrderLineItemSourceType["AD_HOC"] = "AD_HOC";
  /** Line item is linked to a sellable */

  OrderLineItemSourceType["SELLABLE"] = "SELLABLE";
  /** Line item is a child line item, indicating the base price of the parent (primarily used for services) */

  OrderLineItemSourceType["BASE_PRICE"] = "BASE_PRICE";
  /** Line item represents a tip to Deal.com experts */

  OrderLineItemSourceType["EXPERT_TIP"] = "EXPERT_TIP";
  /** Fixed gratuity */

  OrderLineItemSourceType["GRATUITY"] = "GRATUITY";
  /** Shipment cost line item */

  OrderLineItemSourceType["SHIPMENT"] = "SHIPMENT";
})(OrderLineItemSourceType || (OrderLineItemSourceType = {}));

var OrderLineItemState;

(function (OrderLineItemState) {
  OrderLineItemState["CLAIMED"] = "CLAIMED";
  OrderLineItemState["NEW"] = "NEW";
  OrderLineItemState["PAID"] = "PAID";
  OrderLineItemState["PENDING_SHIPPING"] = "PENDING_SHIPPING";
  OrderLineItemState["READY"] = "READY";
  OrderLineItemState["RECEIVED"] = "RECEIVED";
  OrderLineItemState["RETURN_PENDING_SHIPPING"] = "RETURN_PENDING_SHIPPING";
  OrderLineItemState["RETURN_REQUESTED"] = "RETURN_REQUESTED";
  OrderLineItemState["RETURN_RECEIVED"] = "RETURN_RECEIVED";
  OrderLineItemState["RETURN_SHIPPED"] = "RETURN_SHIPPED";
  OrderLineItemState["SHIPPED"] = "SHIPPED";
  OrderLineItemState["UNAVAILABLE"] = "UNAVAILABLE";
  OrderLineItemState["CUSTOMIZING"] = "CUSTOMIZING";
})(OrderLineItemState || (OrderLineItemState = {}));

var OrderPreSubmitAction;

(function (OrderPreSubmitAction) {
  OrderPreSubmitAction["CHECKOUT_STARTED"] = "CHECKOUT_STARTED";
  OrderPreSubmitAction["ADD_TO_CART"] = "ADD_TO_CART";
  OrderPreSubmitAction["PAYMENT_INFO_ENTERED"] = "PAYMENT_INFO_ENTERED";
})(OrderPreSubmitAction || (OrderPreSubmitAction = {}));

var OrderSearchSort;

(function (OrderSearchSort) {
  OrderSearchSort["PAID_AT"] = "PAID_AT";
  OrderSearchSort["CREATED_AT"] = "CREATED_AT";
  OrderSearchSort["EFFECTIVE_ORDER_DATE"] = "EFFECTIVE_ORDER_DATE";
  OrderSearchSort["EFFECTIVE_ORDER_DATE_ASC"] = "EFFECTIVE_ORDER_DATE_ASC";
})(OrderSearchSort || (OrderSearchSort = {}));

var OrderState;

(function (OrderState) {
  OrderState["CART"] = "CART";
  OrderState["CREATED"] = "CREATED";
  OrderState["SUBMITTED"] = "SUBMITTED";
  OrderState["CONSUMER_PAYMENT_PENDING"] = "CONSUMER_PAYMENT_PENDING";
  OrderState["CONSUMER_PAYMENT_COMPLETED"] = "CONSUMER_PAYMENT_COMPLETED";
  OrderState["CONSUMER_PAYMENT_FAILED"] = "CONSUMER_PAYMENT_FAILED";
  OrderState["CONSUMER_PAYMENT_PARTIAL"] = "CONSUMER_PAYMENT_PARTIAL";
  OrderState["CONSUMER_OVERPAID"] = "CONSUMER_OVERPAID";
  OrderState["CONSUMER_PAYMENT_REFUNDED"] = "CONSUMER_PAYMENT_REFUNDED";
  OrderState["CONSUMER_PAYMENT_CANCELED"] = "CONSUMER_PAYMENT_CANCELED";
  OrderState["SHIPPED"] = "SHIPPED";
  OrderState["READY"] = "READY";
  OrderState["RECEIVED"] = "RECEIVED";
})(OrderState || (OrderState = {}));

var PathFlowOnCompleteRedirectLocation;

(function (PathFlowOnCompleteRedirectLocation) {
  /** Reload the current page, this is used for paths that happen in-place */
  PathFlowOnCompleteRedirectLocation["RELOAD_CURRENT_PAGE"] = "RELOAD_CURRENT_PAGE";
  /** Browse deals by category. Only valid for paths completed with a lead. */

  PathFlowOnCompleteRedirectLocation["BROWSE_CATEGORY"] = "BROWSE_CATEGORY";
  /** Expert profile page with selection screen. Only valid for paths completed with a lead. */

  PathFlowOnCompleteRedirectLocation["EXPERT_PROFILE"] = "EXPERT_PROFILE";
  /** Default inbox page */

  PathFlowOnCompleteRedirectLocation["INBOX"] = "INBOX";
  /** Custom themed inbox page that's has a theme which matches PathFlowThemeType.CHAT_LIKE */

  PathFlowOnCompleteRedirectLocation["INBOX_CHAT_LIKE_THEME"] = "INBOX_CHAT_LIKE_THEME";
  /** Redirect to login page */

  PathFlowOnCompleteRedirectLocation["LOGIN"] = "LOGIN";
  /** Redirect to the completion page after an application is submitted */

  PathFlowOnCompleteRedirectLocation["APPLY_FINISH"] = "APPLY_FINISH";
  /** Redirect to selected department page */

  PathFlowOnCompleteRedirectLocation["DEPARTMENT_PAGE"] = "DEPARTMENT_PAGE";
})(PathFlowOnCompleteRedirectLocation || (PathFlowOnCompleteRedirectLocation = {}));

var PathFlowPageMetadataType;

(function (PathFlowPageMetadataType) {
  PathFlowPageMetadataType["INTERSTITIAL"] = "INTERSTITIAL";
  PathFlowPageMetadataType["CUSTOM"] = "CUSTOM";
  /** Below are deprecated */

  PathFlowPageMetadataType["LOADING_QUESTIONS"] = "LOADING_QUESTIONS";
  PathFlowPageMetadataType["CONNECTING_TO_OPERATOR"] = "CONNECTING_TO_OPERATOR";
  PathFlowPageMetadataType["FINDING_MERCHANTS"] = "FINDING_MERCHANTS";
  PathFlowPageMetadataType["HIGH_SECURITY"] = "HIGH_SECURITY";
  PathFlowPageMetadataType["WELCOME"] = "WELCOME";
})(PathFlowPageMetadataType || (PathFlowPageMetadataType = {}));

var PathFlowThemeType;

(function (PathFlowThemeType) {
  PathFlowThemeType["DEFAULT"] = "DEFAULT";
  PathFlowThemeType["SNOWBOARD"] = "SNOWBOARD";
  PathFlowThemeType["CHAT_LIKE"] = "CHAT_LIKE";
})(PathFlowThemeType || (PathFlowThemeType = {}));

var PathValidationErrorTag;

(function (PathValidationErrorTag) {
  /** If this error is produced, the client must have the user login, or change the contact information being used to proceed */
  PathValidationErrorTag["REQUIRES_LOGIN_TO_PROCEED"] = "REQUIRES_LOGIN_TO_PROCEED";
  /** Indicates an internal error, typically surfaced if the API is misused, or some type of developer/administrative error. */

  PathValidationErrorTag["INTERNAL"] = "INTERNAL";
})(PathValidationErrorTag || (PathValidationErrorTag = {}));

var PaymentActivityType;

(function (PaymentActivityType) {
  PaymentActivityType["FULL_PAYMENT"] = "FULL_PAYMENT";
  PaymentActivityType["DEPOSIT"] = "DEPOSIT";
  PaymentActivityType["REMAINING_BALANCE"] = "REMAINING_BALANCE";
})(PaymentActivityType || (PaymentActivityType = {}));

var PaymentMethod;

(function (PaymentMethod) {
  PaymentMethod["CARD"] = "CARD";
  PaymentMethod["PAYPAL"] = "PAYPAL";
  PaymentMethod["THREE_D_SECURE"] = "THREE_D_SECURE";
  PaymentMethod["APPLE_PAY"] = "APPLE_PAY";
  PaymentMethod["ANDROID_PAY"] = "ANDROID_PAY";
  PaymentMethod["GOOGLE_PAY"] = "GOOGLE_PAY";
  PaymentMethod["PAY_BY_INSTALLMENT"] = "PAY_BY_INSTALLMENT";
  PaymentMethod["WIRE_TRANSFER"] = "WIRE_TRANSFER";
})(PaymentMethod || (PaymentMethod = {}));

var PaymentProcessorType;

(function (PaymentProcessorType) {
  PaymentProcessorType["STRIPE"] = "STRIPE";
  PaymentProcessorType["PAYPAL"] = "PAYPAL";
  PaymentProcessorType["AFTERPAY"] = "AFTERPAY";
  PaymentProcessorType["AFFIRM"] = "AFFIRM";
})(PaymentProcessorType || (PaymentProcessorType = {}));

var PaymentSourceStatus;

(function (PaymentSourceStatus) {
  /** indicates the source is archived, for ex: on expiry, account closure, deleting previously saved card */
  PaymentSourceStatus["ARCHIVED"] = "ARCHIVED";
  PaymentSourceStatus["CANCELED"] = "CANCELED";
  /** Only chargeable Source can be used to create a charge */

  PaymentSourceStatus["CHARGEABLE"] = "CHARGEABLE";
  /** This indicates an older Source that is now detached from the user. */

  PaymentSourceStatus["CONSUMED"] = "CONSUMED";
  PaymentSourceStatus["FAILED"] = "FAILED";
  PaymentSourceStatus["PENDING"] = "PENDING";
})(PaymentSourceStatus || (PaymentSourceStatus = {}));
/** Whether this source should be reusable or not. Some source types may or may not be reusable by construction,
 * while other may leave the option at creation. If an incompatible value is passed, an error will be returned.
 */


var PaymentSourceUsage;

(function (PaymentSourceUsage) {
  PaymentSourceUsage["REUSABLE"] = "REUSABLE";
  PaymentSourceUsage["SINGLE_USE"] = "SINGLE_USE";
})(PaymentSourceUsage || (PaymentSourceUsage = {}));
/** =============
 * this is used in biz-app, we should migrate to BusinessUserPermission
 * =============
 */


var Permission;

(function (Permission) {
  Permission["UI_OVERWRITE_SELLABLE_PRICE"] = "UI_OVERWRITE_SELLABLE_PRICE";
  Permission["UI_ON_CALL_EXPERT"] = "UI_ON_CALL_EXPERT";
  Permission["UI_ACCEPT_NEW_LEAD"] = "UI_ACCEPT_NEW_LEAD";
})(Permission || (Permission = {}));

var PostalAddressLocationDisplayType;

(function (PostalAddressLocationDisplayType) {
  PostalAddressLocationDisplayType["CITY_STATE"] = "CITY_STATE";
})(PostalAddressLocationDisplayType || (PostalAddressLocationDisplayType = {}));

var PresenceStatus;

(function (PresenceStatus) {
  PresenceStatus["ONLINE"] = "ONLINE";
  PresenceStatus["OFFLINE"] = "OFFLINE";
  PresenceStatus["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
  PresenceStatus["SMS"] = "SMS";
})(PresenceStatus || (PresenceStatus = {}));

var ProductCondition;

(function (ProductCondition) {
  ProductCondition["NEW"] = "NEW";
  ProductCondition["EXCELLENT"] = "EXCELLENT";
  ProductCondition["GOOD"] = "GOOD";
  ProductCondition["FAIR"] = "FAIR";
})(ProductCondition || (ProductCondition = {}));

var ProfileHighlightIconType;

(function (ProfileHighlightIconType) {
  ProfileHighlightIconType["BEER"] = "BEER";
  ProfileHighlightIconType["CAKE"] = "CAKE";
  ProfileHighlightIconType["CALENDAR"] = "CALENDAR";
  ProfileHighlightIconType["CHAT"] = "CHAT";
  ProfileHighlightIconType["CHECK"] = "CHECK";
  ProfileHighlightIconType["COCKTAIL"] = "COCKTAIL";
  ProfileHighlightIconType["DRINK"] = "DRINK";
  ProfileHighlightIconType["GOLF_CLUB"] = "GOLF_CLUB";
  ProfileHighlightIconType["GOLF_CLUB_SET"] = "GOLF_CLUB_SET";
  ProfileHighlightIconType["GOLF_COURSE"] = "GOLF_COURSE";
  ProfileHighlightIconType["HEART"] = "HEART";
  ProfileHighlightIconType["LOCATION"] = "LOCATION";
  ProfileHighlightIconType["DIPLOMA"] = "DIPLOMA";
  ProfileHighlightIconType["SKIER"] = "SKIER";
  ProfileHighlightIconType["SNOWBOARDER"] = "SNOWBOARDER";
  ProfileHighlightIconType["MOUNTAIN"] = "MOUNTAIN";
  ProfileHighlightIconType["SNOWFLAKE"] = "SNOWFLAKE";
  ProfileHighlightIconType["SMILE"] = "SMILE";
  ProfileHighlightIconType["STAR"] = "STAR";
})(ProfileHighlightIconType || (ProfileHighlightIconType = {}));

var ProfileHighlightSource;

(function (ProfileHighlightSource) {
  ProfileHighlightSource["SYSTEM"] = "SYSTEM";
  ProfileHighlightSource["USER"] = "USER";
})(ProfileHighlightSource || (ProfileHighlightSource = {}));

var ProfileHighlightValueType;

(function (ProfileHighlightValueType) {
  ProfileHighlightValueType["TEXT"] = "TEXT";
  ProfileHighlightValueType["ENUMERATION"] = "ENUMERATION";
  ProfileHighlightValueType["DATE"] = "DATE";
})(ProfileHighlightValueType || (ProfileHighlightValueType = {}));

var PromotionActionType;

(function (PromotionActionType) {
  PromotionActionType["PERCENT_OFF_LINE_ITEMS"] = "PERCENT_OFF_LINE_ITEMS";
  PromotionActionType["AMOUNT_OFF_ORDER"] = "AMOUNT_OFF_ORDER";
})(PromotionActionType || (PromotionActionType = {}));

var PromotionDisabledReason;

(function (PromotionDisabledReason) {
  PromotionDisabledReason["MANUAL"] = "MANUAL";
  PromotionDisabledReason["REPLACED"] = "REPLACED";
  PromotionDisabledReason["EXPIRED"] = "EXPIRED";
  PromotionDisabledReason["REACHED_USAGE_LIMIT"] = "REACHED_USAGE_LIMIT";
})(PromotionDisabledReason || (PromotionDisabledReason = {}));

var PromotionRuleComparisonOperator;

(function (PromotionRuleComparisonOperator) {
  PromotionRuleComparisonOperator["GREATER_THAN"] = "GREATER_THAN";
  PromotionRuleComparisonOperator["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
  PromotionRuleComparisonOperator["EQUAL"] = "EQUAL";
  PromotionRuleComparisonOperator["LESS_THAN"] = "LESS_THAN";
  PromotionRuleComparisonOperator["LESS_THAN_OR_EQUAL"] = "LESS_THAN_OR_EQUAL";
})(PromotionRuleComparisonOperator || (PromotionRuleComparisonOperator = {}));

var PromotionRuleFilterStrategy;

(function (PromotionRuleFilterStrategy) {
  /** Filtering reduces the scope of the promotion actions. For example, if the rule is to `FILTER` for sellables in
   * the snowboard category, a subsequent promotion action to take 10% off will only take 10% off of the sellables
   * in the snowboard category - not other items in the cart. If no line items fall into the filter criteria, the
   * promotion will not be applied to the order.
   */
  PromotionRuleFilterStrategy["FILTER"] = "FILTER";
  /** Excluding forces the promotion to not be the order if any of its criteria are met. For example, if the rule is
   * to `EXCLUDE` sellable X, any order with sellable X will not be eligible for the promotion.
   */

  PromotionRuleFilterStrategy["EXCLUDE"] = "EXCLUDE";
})(PromotionRuleFilterStrategy || (PromotionRuleFilterStrategy = {}));

var PromotionRuleType;

(function (PromotionRuleType) {
  PromotionRuleType["ORDER_AMOUNT"] = "ORDER_AMOUNT";
  PromotionRuleType["SELLABLE_FILTER"] = "SELLABLE_FILTER";
  PromotionRuleType["SELLABLE_CATEGORY_FILTER"] = "SELLABLE_CATEGORY_FILTER";
  PromotionRuleType["SELLABLE_BRAND_FILTER"] = "SELLABLE_BRAND_FILTER";
  PromotionRuleType["SELLABLE_ATTRIBUTE_FILTER"] = "SELLABLE_ATTRIBUTE_FILTER";
  PromotionRuleType["PURCHASED_ORDER_COUNT"] = "PURCHASED_ORDER_COUNT";
  PromotionRuleType["USER_USAGE_LIMIT"] = "USER_USAGE_LIMIT";
})(PromotionRuleType || (PromotionRuleType = {}));

var PromotionState;

(function (PromotionState) {
  PromotionState["DRAFT"] = "DRAFT";
  PromotionState["ACTIVE"] = "ACTIVE";
  PromotionState["DISABLED"] = "DISABLED";
})(PromotionState || (PromotionState = {}));

var RecommendedListType;

(function (RecommendedListType) {
  /** Recommendation list built using  a combination of multiple user Attributes learnt from
   * the Path Deal request. More specifically, it uses Gender, Price, Brand, Primary Attributes and other secondary
   * attributes to build this request.
   * The list built only if brand and primary attributes are present in the users request
   * Accessories are explicitly excluded
   */
  RecommendedListType["MY_TOP_LIST"] = "MY_TOP_LIST";
  /** This is similar to TOP LIST but enforces a strict matching of user request attributes. */

  RecommendedListType["STRICT_MY_TOP_LIST"] = "STRICT_MY_TOP_LIST";
  /** Recommendation list built using price and primary attributes from users path request attributes
   * Each primary attribute has a separate list
   * The list built only if primary attributes are present in the users request
   * Accessories are explicitly excluded
   */

  RecommendedListType["PRICE_AND_PRIMARY_ATTRIBUTES"] = "PRICE_AND_PRIMARY_ATTRIBUTES";
  /** Recommendation list built using brands and primary attributes from users path request attributes
   * Each brand has a separate list
   * The list built only if brand attributes are present in the users request
   * Accessories are explicitly excluded
   */

  RecommendedListType["BRAND_AND_PRIMARY_ATTRIBUTES"] = "BRAND_AND_PRIMARY_ATTRIBUTES";
  /** Recommendation list built using accessories selected by the user in the path request
   * Each Accessory has a separate list
   */

  RecommendedListType["ACCESSORIES"] = "ACCESSORIES";
  /** Recommended list built using curated lists that were recommended to similar users */

  RecommendedListType["CURATED_LIST_TO_SIMILAR_USERS"] = "CURATED_LIST_TO_SIMILAR_USERS";
  /** This recommendation list is used to build a digest of recommendations based on user intent from the deal request
   * The relevancy favors most recent sellables and also favors sellables with price within users budget
   * that has changed recently.
   */

  RecommendedListType["PRICE_SENSITIVE_INTENT_BASED_DIGEST"] = "PRICE_SENSITIVE_INTENT_BASED_DIGEST";
  /** the recommended list built from a custom list defined by the operator or expert */

  RecommendedListType["CUSTOM"] = "CUSTOM";
})(RecommendedListType || (RecommendedListType = {}));

var RegisterCustomerErrorCode;

(function (RegisterCustomerErrorCode) {
  RegisterCustomerErrorCode["ALREADY_REGISTERED"] = "ALREADY_REGISTERED";
})(RegisterCustomerErrorCode || (RegisterCustomerErrorCode = {}));

var ReportAccessScope;

(function (ReportAccessScope) {
  ReportAccessScope["BUSINESS_USER"] = "BUSINESS_USER";
  ReportAccessScope["TEAM"] = "TEAM";
  ReportAccessScope["DEPARTMENT"] = "DEPARTMENT";
  ReportAccessScope["GLOBAL"] = "GLOBAL";
})(ReportAccessScope || (ReportAccessScope = {}));

var ReportColumnValueType;

(function (ReportColumnValueType) {
  ReportColumnValueType["STRING"] = "STRING";
  ReportColumnValueType["INTEGER"] = "INTEGER";
  ReportColumnValueType["DOUBLE"] = "DOUBLE";
})(ReportColumnValueType || (ReportColumnValueType = {}));

var ReportSchemaType;

(function (ReportSchemaType) {
  /** The total amount of conversations, and the amount of new conversations in the last week. */
  ReportSchemaType["CONVERSATIONS_COUNT"] = "CONVERSATIONS_COUNT";
  /** Stats about expert ratings; total rating count, and average rating score. */

  ReportSchemaType["EXPERT_RATING_STATS"] = "EXPERT_RATING_STATS";
  /** The total amount of curations, and the amount of new curations in the last week. */

  ReportSchemaType["CURATIONS_COUNT"] = "CURATIONS_COUNT";
  /** Most popular brands recommended by experts, grouped by category */

  ReportSchemaType["RECOMMENDED_BY_EXPERTS_CAT_BRAND_STATS"] = "RECOMMENDED_BY_EXPERTS_CAT_BRAND_STATS";
  /** Most popular brands recommended by experts, grouped and rolled up by category
   * linked to department (e.g.: winter sports, golf, etc)
   */

  ReportSchemaType["RECOMMENDED_BY_EXPERTS_DEPT_CAT_BRAND_STATS"] = "RECOMMENDED_BY_EXPERTS_DEPT_CAT_BRAND_STATS";
})(ReportSchemaType || (ReportSchemaType = {}));

var ReturnPolicyType;

(function (ReturnPolicyType) {
  ReturnPolicyType["NO_RETURNS_ACCEPTED"] = "NO_RETURNS_ACCEPTED";
  ReturnPolicyType["STANDARD"] = "STANDARD";
})(ReturnPolicyType || (ReturnPolicyType = {}));

var ReturnRefundMethod;

(function (ReturnRefundMethod) {
  ReturnRefundMethod["ORIGINAL_PAYMENT"] = "ORIGINAL_PAYMENT";
  ReturnRefundMethod["STORE_CREDIT"] = "STORE_CREDIT";
})(ReturnRefundMethod || (ReturnRefundMethod = {}));

var ReturnShippingPaidBy;

(function (ReturnShippingPaidBy) {
  ReturnShippingPaidBy["NOT_APPLICABLE"] = "NOT_APPLICABLE";
  ReturnShippingPaidBy["MERCHANT"] = "MERCHANT";
  ReturnShippingPaidBy["CUSTOMER"] = "CUSTOMER";
})(ReturnShippingPaidBy || (ReturnShippingPaidBy = {}));

var SavedSellableReason;

(function (SavedSellableReason) {
  SavedSellableReason["PRICE"] = "PRICE";
  SavedSellableReason["STYLE"] = "STYLE";
  SavedSellableReason["HIGH_QUALITY"] = "HIGH_QUALITY";
  SavedSellableReason["BRAND"] = "BRAND";
})(SavedSellableReason || (SavedSellableReason = {}));

var ScheduledPaymentState;

(function (ScheduledPaymentState) {
  ScheduledPaymentState["SCHEDULED"] = "SCHEDULED";
  ScheduledPaymentState["EXECUTED"] = "EXECUTED";
  ScheduledPaymentState["CANCELED"] = "CANCELED";
})(ScheduledPaymentState || (ScheduledPaymentState = {}));

var ScrapingSellablePriceSourceSpider;

(function (ScrapingSellablePriceSourceSpider) {
  ScrapingSellablePriceSourceSpider["EVO"] = "EVO";
  ScrapingSellablePriceSourceSpider["PROGOLFYAKIMA"] = "PROGOLFYAKIMA";
  ScrapingSellablePriceSourceSpider["JENSONUSA"] = "JENSONUSA";
  ScrapingSellablePriceSourceSpider["BIKEBLING"] = "BIKEBLING";
  ScrapingSellablePriceSourceSpider["CHAINREACTIONCYCLES"] = "CHAINREACTIONCYCLES";
})(ScrapingSellablePriceSourceSpider || (ScrapingSellablePriceSourceSpider = {}));

var SellableAttributePromotionRuleReferenceComparison;

(function (SellableAttributePromotionRuleReferenceComparison) {
  SellableAttributePromotionRuleReferenceComparison["EQUAL"] = "EQUAL";
  SellableAttributePromotionRuleReferenceComparison["NOT_EQUAL"] = "NOT_EQUAL";
})(SellableAttributePromotionRuleReferenceComparison || (SellableAttributePromotionRuleReferenceComparison = {}));

var SellableCategoryFilterPromotionRuleReferenceTraversalOption;

(function (SellableCategoryFilterPromotionRuleReferenceTraversalOption) {
  SellableCategoryFilterPromotionRuleReferenceTraversalOption["INCLUDE_PARENTS"] = "INCLUDE_PARENTS";
  SellableCategoryFilterPromotionRuleReferenceTraversalOption["INCLUDE_CHILDREN"] = "INCLUDE_CHILDREN";
})(SellableCategoryFilterPromotionRuleReferenceTraversalOption || (SellableCategoryFilterPromotionRuleReferenceTraversalOption = {}));

var SellablePriceSourceType;

(function (SellablePriceSourceType) {
  SellablePriceSourceType["DEAL"] = "DEAL";
  SellablePriceSourceType["AMAZON"] = "AMAZON";
  SellablePriceSourceType["EBAY"] = "EBAY";
  SellablePriceSourceType["SCRAPING"] = "SCRAPING";
  SellablePriceSourceType["YADAV"] = "YADAV";
})(SellablePriceSourceType || (SellablePriceSourceType = {}));

var SellableSearchFacetsQueryFilter;

(function (SellableSearchFacetsQueryFilter) {
  /** Returns facets that have attributes that are marked as PRIMARY in the specific category.
   * In case there are multiple PRIMARY attributes in a Category, it returns the first one after category specific
   * custom sorting, to provide deterministic behavior.
   */
  SellableSearchFacetsQueryFilter["FIRST_PRIMARY_ATTRIBUTE_ONLY"] = "FIRST_PRIMARY_ATTRIBUTE_ONLY";
  /** All facets with PRIMARY attributes are returned, ordered by category specific sorting. */

  SellableSearchFacetsQueryFilter["ALL_PRIMARY_ATTRIBUTES"] = "ALL_PRIMARY_ATTRIBUTES";
  /** Returns facets that have attributes that are marked as SECONDARY in the specific category.
   * In case there are multiple SECONDARY attributes in a Category, it returns the first one after category specific
   * custom sorting, to provide deterministic behavior.
   */

  SellableSearchFacetsQueryFilter["FIRST_SECONDARY_ATTRIBUTE_ONLY"] = "FIRST_SECONDARY_ATTRIBUTE_ONLY";
  /** All facets with SECONDARY attributes are returned, ordered by category specific sorting. */

  SellableSearchFacetsQueryFilter["ALL_SECONDARY_ATTRIBUTES"] = "ALL_SECONDARY_ATTRIBUTES";
  /** Returns brand facets for the specific category */

  SellableSearchFacetsQueryFilter["INCLUDE_BRANDS"] = "INCLUDE_BRANDS";
  /** Excludes out of stock sellables while building the facets */

  SellableSearchFacetsQueryFilter["EXCLUDE_OUT_OF_STOCK"] = "EXCLUDE_OUT_OF_STOCK";
  /** Include gender facet */

  SellableSearchFacetsQueryFilter["INCLUDE_GENDER"] = "INCLUDE_GENDER";
  /** Include Sale price facet as a range */

  SellableSearchFacetsQueryFilter["INCLUDE_SALE_PRICE_RANGE"] = "INCLUDE_SALE_PRICE_RANGE";
  /** Only includes sellables that have discounts */

  SellableSearchFacetsQueryFilter["INCLUDE_DISCOUNTED_ONLY"] = "INCLUDE_DISCOUNTED_ONLY";
})(SellableSearchFacetsQueryFilter || (SellableSearchFacetsQueryFilter = {}));

var SellableSearchFilter;

(function (SellableSearchFilter) {
  /** Returns sellables that have discounts only
   * In addition if the sorting is by relevancy, it boosts the sellables that have their price updated recently
   * higher in the result set.
   */
  SellableSearchFilter["DISCOUNTED"] = "DISCOUNTED";
  /** Exclude out of stock sellables */

  SellableSearchFilter["EXCLUDE_OUT_OF_STOCK"] = "EXCLUDE_OUT_OF_STOCK";
})(SellableSearchFilter || (SellableSearchFilter = {}));

var SellableSearchUseCase;

(function (SellableSearchUseCase) {
  SellableSearchUseCase["CONSUMER_SEARCH"] = "CONSUMER_SEARCH";
  SellableSearchUseCase["EXPERT_SEARCH"] = "EXPERT_SEARCH";
  SellableSearchUseCase["IMPERSONATE_CONSUMER"] = "IMPERSONATE_CONSUMER";
  SellableSearchUseCase["OPS_SEARCH"] = "OPS_SEARCH";
  /** This use case for consumer does not take the user intent into account and is basically a simple brand search query */

  SellableSearchUseCase["CONSUMER_HOME_PAGE_BY_BRANDS"] = "CONSUMER_HOME_PAGE_BY_BRANDS";
})(SellableSearchUseCase || (SellableSearchUseCase = {}));

var SellableServiceLocationDisplayType;

(function (SellableServiceLocationDisplayType) {
  SellableServiceLocationDisplayType["CITY_STATE"] = "CITY_STATE";
})(SellableServiceLocationDisplayType || (SellableServiceLocationDisplayType = {}));

var SellableSort;

(function (SellableSort) {
  /** Average sale price is calculated as (min + max)/2 for all variations */
  SellableSort["AVG_SALE_PRICE"] = "AVG_SALE_PRICE";
  /** Savings = actual price - sale price */

  SellableSort["MAX_PRICE_SAVINGS"] = "MAX_PRICE_SAVINGS";
  /** Percent savings = (actual price - sale price)/actual price */

  SellableSort["MAX_PRICE_PERCENT_SAVINGS"] = "MAX_PRICE_PERCENT_SAVINGS";
  /** Defined as the unique page views in the last 7 days */

  SellableSort["POPULARITY"] = "POPULARITY";
  /** Defined as the number of purchases in the last 30 days */

  SellableSort["BEST_SELLER"] = "BEST_SELLER";
  /** Relevance score computed from sellables that match users intent */

  SellableSort["RELEVANCE"] = "RELEVANCE";
  /** This is the fastest way to get results if ordering is not important */

  SellableSort["INDEX_ORDER"] = "INDEX_ORDER";
  /** An stable way to paginate across all indexed documents */

  SellableSort["DOC_ID_ORDER"] = "DOC_ID_ORDER";
})(SellableSort || (SellableSort = {}));

var SellableSourceExternalIdType;

(function (SellableSourceExternalIdType) {
  SellableSourceExternalIdType["YADAV_DIAMOND"] = "YADAV_DIAMOND";
  SellableSourceExternalIdType["YADAV_SETTING"] = "YADAV_SETTING";
})(SellableSourceExternalIdType || (SellableSourceExternalIdType = {}));

var SellableSourceType;

(function (SellableSourceType) {
  SellableSourceType["URL"] = "URL";
  SellableSourceType["EXTERNAL_ID"] = "EXTERNAL_ID";
})(SellableSourceType || (SellableSourceType = {}));

var SellableType;

(function (SellableType) {
  SellableType["PRODUCT"] = "PRODUCT";
  SellableType["SERVICE"] = "SERVICE";
})(SellableType || (SellableType = {}));

var ShippingMethod;

(function (ShippingMethod) {
  /** Standard ground (default) */
  ShippingMethod["STANDARD"] = "STANDARD";
  /** Expedited shipping */

  ShippingMethod["EXPEDITED"] = "EXPEDITED";
})(ShippingMethod || (ShippingMethod = {}));

var ShippingPolicy;

(function (ShippingPolicy) {
  ShippingPolicy["NO_SHIPPING"] = "NO_SHIPPING";
  ShippingPolicy["FREE_SHIPPING"] = "FREE_SHIPPING";
  ShippingPolicy["PAID_BY_CUSTOMER"] = "PAID_BY_CUSTOMER";
})(ShippingPolicy || (ShippingPolicy = {}));

var ShippingStatus;

(function (ShippingStatus) {
  ShippingStatus["UNKNOWN"] = "UNKNOWN";
  ShippingStatus["IN_TRANSIT"] = "IN_TRANSIT";
  ShippingStatus["DELIVERED"] = "DELIVERED";
  ShippingStatus["FAILURE"] = "FAILURE";
  ShippingStatus["RETURNED"] = "RETURNED";
})(ShippingStatus || (ShippingStatus = {}));

var SimpleCuratedOrderType;

(function (SimpleCuratedOrderType) {
  SimpleCuratedOrderType["EXPERT_CONSULTATION_FEE"] = "EXPERT_CONSULTATION_FEE";
})(SimpleCuratedOrderType || (SimpleCuratedOrderType = {}));

var SocialMediaType;

(function (SocialMediaType) {
  SocialMediaType["FACEBOOK"] = "FACEBOOK";
  SocialMediaType["TWITTER"] = "TWITTER";
  SocialMediaType["LINKEDIN"] = "LINKEDIN";
  SocialMediaType["INSTAGRAM"] = "INSTAGRAM";
  SocialMediaType["PINTEREST"] = "PINTEREST";
  SocialMediaType["YOUTUBE"] = "YOUTUBE";
  SocialMediaType["STRAVA"] = "STRAVA";
})(SocialMediaType || (SocialMediaType = {}));
/** Common ordering context, each query should define its specific sortable fields as enums. */


var SortOrder;

(function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));

var StringFieldType;

(function (StringFieldType) {
  StringFieldType["EMAIL_ADDRESS"] = "EMAIL_ADDRESS";
  StringFieldType["DURATION"] = "DURATION";
})(StringFieldType || (StringFieldType = {}));

var StripeAuthenticationFlow;

(function (StripeAuthenticationFlow) {
  StripeAuthenticationFlow["REDIRECT"] = "redirect";
  StripeAuthenticationFlow["RECEIVER"] = "receiver";
  StripeAuthenticationFlow["CODE_VERIFICATION"] = "code_verification";
  StripeAuthenticationFlow["NONE"] = "none";
})(StripeAuthenticationFlow || (StripeAuthenticationFlow = {}));

var StripeCodeVerificationStatus;

(function (StripeCodeVerificationStatus) {
  StripeCodeVerificationStatus["PENDING"] = "pending";
  StripeCodeVerificationStatus["AWAITING_VERIFICATION"] = "awaiting_verification";
  StripeCodeVerificationStatus["SUCCEEDED"] = "succeeded";
  StripeCodeVerificationStatus["FAILED"] = "failed";
})(StripeCodeVerificationStatus || (StripeCodeVerificationStatus = {}));

var SuggestedActionType;

(function (SuggestedActionType) {
  SuggestedActionType["SEND_INITIAL_RESPONSE"] = "SEND_INITIAL_RESPONSE";
  SuggestedActionType["RESPOND_TO_NEW_MESSAGE"] = "RESPOND_TO_NEW_MESSAGE";
  SuggestedActionType["FOLLOW_UP"] = "FOLLOW_UP";
  SuggestedActionType["SNOOZE"] = "SNOOZE";
  SuggestedActionType["STAR"] = "STAR";
  SuggestedActionType["ARCHIVE"] = "ARCHIVE";
  SuggestedActionType["REQUEST_EXPERT_REVIEW"] = "REQUEST_EXPERT_REVIEW";
  SuggestedActionType["REQUEST_EXPERT_REFERRAL"] = "REQUEST_EXPERT_REFERRAL";
  SuggestedActionType["SEND_CURATION"] = "SEND_CURATION";
  SuggestedActionType["CLASSIFY_ARCHIVED_LEAD"] = "CLASSIFY_ARCHIVED_LEAD";
})(SuggestedActionType || (SuggestedActionType = {}));

var SuggestExpertCuratedItemNotesSort;

(function (SuggestExpertCuratedItemNotesSort) {
  /** Sort by purchase rate, usage count, note length */
  SuggestExpertCuratedItemNotesSort["DEFAULT"] = "DEFAULT";
  /** Sort by usage count, note length */

  SuggestExpertCuratedItemNotesSort["USAGES"] = "USAGES";
})(SuggestExpertCuratedItemNotesSort || (SuggestExpertCuratedItemNotesSort = {}));

var SupportTaskAction;

(function (SupportTaskAction) {
  SupportTaskAction["ASSIGN"] = "ASSIGN";
  SupportTaskAction["UNASSIGN"] = "UNASSIGN";
  SupportTaskAction["DISMISS"] = "DISMISS";
  SupportTaskAction["DELEGATE_LEAD"] = "DELEGATE_LEAD";
  SupportTaskAction["REASSIGN_LEAD"] = "REASSIGN_LEAD";
  SupportTaskAction["SUGGEST_LEAD_ACTIONS"] = "SUGGEST_LEAD_ACTIONS";
  SupportTaskAction["ESCALATE_LEAD_FOR_DELEGATION"] = "ESCALATE_LEAD_FOR_DELEGATION";
  SupportTaskAction["ESCALATE_LEAD_FOR_REASSIGNMENT"] = "ESCALATE_LEAD_FOR_REASSIGNMENT";
  SupportTaskAction["REQUEST_ORDER_SUPPORT_FOR_LEAD"] = "REQUEST_ORDER_SUPPORT_FOR_LEAD";
  SupportTaskAction["SNOOZE"] = "SNOOZE";
  SupportTaskAction["UNSNOOZE"] = "UNSNOOZE";
})(SupportTaskAction || (SupportTaskAction = {}));

var SupportTaskListEventType;

(function (SupportTaskListEventType) {
  SupportTaskListEventType["ADD"] = "ADD";
  SupportTaskListEventType["REMOVE"] = "REMOVE";
})(SupportTaskListEventType || (SupportTaskListEventType = {}));

var SupportTaskState;

(function (SupportTaskState) {
  SupportTaskState["PENDING"] = "PENDING";
  SupportTaskState["ASSIGNED"] = "ASSIGNED";
  SupportTaskState["COMPLETED"] = "COMPLETED";
})(SupportTaskState || (SupportTaskState = {}));

var SupportTaskType;

(function (SupportTaskType) {
  SupportTaskType["LEAD"] = "LEAD";
  SupportTaskType["ORDER"] = "ORDER";
})(SupportTaskType || (SupportTaskType = {}));

var SystemCuratedConsumerSellableReactionRating;

(function (SystemCuratedConsumerSellableReactionRating) {
  SystemCuratedConsumerSellableReactionRating["SKIP"] = "SKIP";
  SystemCuratedConsumerSellableReactionRating["DISLIKE"] = "DISLIKE";
  SystemCuratedConsumerSellableReactionRating["LIKE"] = "LIKE";
  SystemCuratedConsumerSellableReactionRating["LOVE"] = "LOVE";
})(SystemCuratedConsumerSellableReactionRating || (SystemCuratedConsumerSellableReactionRating = {}));

var SystemCuratedItemSurveyTerminationReason;

(function (SystemCuratedItemSurveyTerminationReason) {
  SystemCuratedItemSurveyTerminationReason["SKIPPED"] = "SKIPPED";
  SystemCuratedItemSurveyTerminationReason["TERMINATED_EARLY"] = "TERMINATED_EARLY";
  SystemCuratedItemSurveyTerminationReason["REVIEWED_ALL"] = "REVIEWED_ALL";
})(SystemCuratedItemSurveyTerminationReason || (SystemCuratedItemSurveyTerminationReason = {}));

var SystemCuratedItemType;

(function (SystemCuratedItemType) {
  SystemCuratedItemType["EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER"] = "EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER";
  SystemCuratedItemType["EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER_RANKED_BY_TIMES_RECOMMENDED"] = "EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER_RANKED_BY_TIMES_RECOMMENDED";
  SystemCuratedItemType["TOP_RECOMMENDATIONS_BASED_ON_DEAL_REQUEST"] = "TOP_RECOMMENDATIONS_BASED_ON_DEAL_REQUEST";
  SystemCuratedItemType["SIMILAR_USER_AND_TOP_RECOMMENDATIONS_GLOBALLY_RANKED"] = "SIMILAR_USER_AND_TOP_RECOMMENDATIONS_GLOBALLY_RANKED";
})(SystemCuratedItemType || (SystemCuratedItemType = {}));

var TagType;

(function (TagType) {
  TagType["BROADCAST_LEAD_QUALITY"] = "BROADCAST_LEAD_QUALITY";
  TagType["BROADCAST_CONVERSION_STRATEGY"] = "BROADCAST_CONVERSION_STRATEGY";
  TagType["BROADCAST_TRUST_STRATEGY"] = "BROADCAST_TRUST_STRATEGY";
  TagType["REMINDER_TASK_TYPE"] = "REMINDER_TASK_TYPE";
})(TagType || (TagType = {}));

var TemplateDataModelType;

(function (TemplateDataModelType) {
  TemplateDataModelType["DATA_OBJECT"] = "DATA_OBJECT";
  TemplateDataModelType["CUSTOM_QUERY"] = "CUSTOM_QUERY";
  TemplateDataModelType["NAMED_QUERIES"] = "NAMED_QUERIES";
})(TemplateDataModelType || (TemplateDataModelType = {}));

var TemplateTagSyntax;

(function (TemplateTagSyntax) {
  TemplateTagSyntax["DEFAULT"] = "DEFAULT";
  TemplateTagSyntax["ALTERNATIVE"] = "ALTERNATIVE";
})(TemplateTagSyntax || (TemplateTagSyntax = {}));

var TemplateTypeGroup;

(function (TemplateTypeGroup) {
  TemplateTypeGroup["ONBOARDING"] = "ONBOARDING";
  TemplateTypeGroup["NURTURING"] = "NURTURING";
  TemplateTypeGroup["FEEDBACK"] = "FEEDBACK";
  TemplateTypeGroup["CURATION"] = "CURATION";
  TemplateTypeGroup["EXPERT_ONBOARDING"] = "EXPERT_ONBOARDING";
  TemplateTypeGroup["MESSAGE_ROUTING"] = "MESSAGE_ROUTING";
  TemplateTypeGroup["EXPERT_NOTIFICATION"] = "EXPERT_NOTIFICATION";
  TemplateTypeGroup["POST_PURCHASE"] = "POST_PURCHASE";
  TemplateTypeGroup["CONSUMER_REQUEST"] = "CONSUMER_REQUEST";
  TemplateTypeGroup["CAMPAIGN"] = "CAMPAIGN";
  TemplateTypeGroup["ABANDONED_CART"] = "ABANDONED_CART";
  TemplateTypeGroup["ABANDONED_CHECKOUT"] = "ABANDONED_CHECKOUT";
  TemplateTypeGroup["PATH_DROPOFF"] = "PATH_DROPOFF";
  TemplateTypeGroup["FULFILLMENT"] = "FULFILLMENT";
  TemplateTypeGroup["REFERRAL"] = "REFERRAL";
})(TemplateTypeGroup || (TemplateTypeGroup = {}));

var ThreeDSecureVerification;

(function (ThreeDSecureVerification) {
  /** 3D Secure is required, and the process must be completed for a charge to be successful. */
  ThreeDSecureVerification["REQUIRED"] = "REQUIRED";
  /** 3D Secure is recommended. The process is not required, but it is highly recommended and
   * has minimal impact to your conversion rate.
   */

  ThreeDSecureVerification["RECOMMENDED"] = "RECOMMENDED";
  /** 3D Secure is optional. The process is neither required nor recommended, but it can be performed to
   * help reduce the likelihood of fraud.
   */

  ThreeDSecureVerification["OPTIONAL"] = "OPTIONAL";
  /** 3D Secure is not supported on this card. Proceed with a regular card payment instead. */

  ThreeDSecureVerification["NOT_SUPPORTED"] = "NOT_SUPPORTED";
})(ThreeDSecureVerification || (ThreeDSecureVerification = {}));

var TransactionStatus;

(function (TransactionStatus) {
  TransactionStatus["SUCCESS"] = "SUCCESS";
  TransactionStatus["PENDING"] = "PENDING";
  TransactionStatus["FAILURE"] = "FAILURE";
  TransactionStatus["REFUNDED"] = "REFUNDED";
})(TransactionStatus || (TransactionStatus = {}));

var TransactionType;

(function (TransactionType) {
  TransactionType["CUSTOMER"] = "CUSTOMER";
  TransactionType["MERCHANT"] = "MERCHANT";
})(TransactionType || (TransactionType = {}));

var TriggerConditionType;

(function (TriggerConditionType) {
  TriggerConditionType["LOGICAL"] = "LOGICAL";
  TriggerConditionType["BINARY"] = "BINARY";
  TriggerConditionType["EXPERIMENT"] = "EXPERIMENT";
})(TriggerConditionType || (TriggerConditionType = {}));

var TriggerDelayIntervalType;

(function (TriggerDelayIntervalType) {
  TriggerDelayIntervalType["FIXED"] = "FIXED";
  TriggerDelayIntervalType["WITH_EXPERIMENT"] = "WITH_EXPERIMENT";
})(TriggerDelayIntervalType || (TriggerDelayIntervalType = {}));

var TriggerDurationUnit;

(function (TriggerDurationUnit) {
  TriggerDurationUnit["SECONDS"] = "SECONDS";
  TriggerDurationUnit["MINUTES"] = "MINUTES";
  TriggerDurationUnit["HOURS"] = "HOURS";
  TriggerDurationUnit["DAYS"] = "DAYS";
})(TriggerDurationUnit || (TriggerDurationUnit = {}));
/** =============================
 * Trigger metadata.
 * =============================
 */


var TriggerFieldType;

(function (TriggerFieldType) {
  TriggerFieldType["BOOLEAN"] = "BOOLEAN";
  TriggerFieldType["INTEGER"] = "INTEGER";
  TriggerFieldType["STRING"] = "STRING";
  TriggerFieldType["STRING_LIST"] = "STRING_LIST";
  TriggerFieldType["DATE"] = "DATE";
  TriggerFieldType["ID"] = "ID";
  TriggerFieldType["ID_LIST"] = "ID_LIST";
})(TriggerFieldType || (TriggerFieldType = {}));

var TriggerLogicalOperator;

(function (TriggerLogicalOperator) {
  TriggerLogicalOperator["AND"] = "AND";
  TriggerLogicalOperator["OR"] = "OR";
})(TriggerLogicalOperator || (TriggerLogicalOperator = {}));

var TriggerNodeEdgeType;

(function (TriggerNodeEdgeType) {
  TriggerNodeEdgeType["NEXT"] = "NEXT";
  TriggerNodeEdgeType["TRUE"] = "TRUE";
  TriggerNodeEdgeType["FALSE"] = "FALSE";
})(TriggerNodeEdgeType || (TriggerNodeEdgeType = {}));

var TriggerNodeType;

(function (TriggerNodeType) {
  TriggerNodeType["DELAY"] = "DELAY";
  TriggerNodeType["FILTER"] = "FILTER";
  TriggerNodeType["BRANCH"] = "BRANCH";
  TriggerNodeType["ACTION"] = "ACTION";
  TriggerNodeType["WAIT"] = "WAIT";
})(TriggerNodeType || (TriggerNodeType = {}));

var TriggerParameterType;

(function (TriggerParameterType) {
  TriggerParameterType["ENTITY_FIELD"] = "ENTITY_FIELD";
  TriggerParameterType["EVENT_PARAMETER"] = "EVENT_PARAMETER";
  TriggerParameterType["LITERAL_VALUE"] = "LITERAL_VALUE";
})(TriggerParameterType || (TriggerParameterType = {}));
/** =============================
 * Trigger instance
 * =============================
 */


var TriggerState;

(function (TriggerState) {
  TriggerState["DRAFT"] = "DRAFT";
  TriggerState["TEST"] = "TEST";
  TriggerState["PUBLISHED"] = "PUBLISHED";
  TriggerState["DEACTIVATED"] = "DEACTIVATED";
})(TriggerState || (TriggerState = {}));

var UnsavedSellableReason;

(function (UnsavedSellableReason) {
  UnsavedSellableReason["NOT_INTERESTED"] = "NOT_INTERESTED";
  UnsavedSellableReason["TOO_EXPENSIVE"] = "TOO_EXPENSIVE";
  UnsavedSellableReason["LOW_QUALITY"] = "LOW_QUALITY";
  UnsavedSellableReason["UGLY"] = "UGLY";
  UnsavedSellableReason["DONT_NEED"] = "DONT_NEED";
  UnsavedSellableReason["BOUGHT_ELSEWHERE"] = "BOUGHT_ELSEWHERE";
})(UnsavedSellableReason || (UnsavedSellableReason = {}));

var UserActivityType;

(function (UserActivityType) {
  UserActivityType["ADD_SELLABLE"] = "ADD_SELLABLE";
  UserActivityType["CHECKOUT_STARTED"] = "CHECKOUT_STARTED";
  UserActivityType["COMPLETE_ORDER"] = "COMPLETE_ORDER";
  UserActivityType["CURATED_LIST_VIEWED"] = "CURATED_LIST_VIEWED";
  UserActivityType["PAYMENT_INFO_ENTERED"] = "PAYMENT_INFO_ENTERED";
  UserActivityType["REMOVE_SELLABLE"] = "REMOVE_SELLABLE";
  UserActivityType["SEARCH_SELLABLES"] = "SEARCH_SELLABLES";
  UserActivityType["VIEW_CART"] = "VIEW_CART";
  UserActivityType["VIEW_SELLABLE"] = "VIEW_SELLABLE";
  UserActivityType["VOICE_CALL"] = "VOICE_CALL";
  UserActivityType["SAVED_SELLABLE"] = "SAVED_SELLABLE";
  UserActivityType["UNSAVED_SELLABLE"] = "UNSAVED_SELLABLE";
})(UserActivityType || (UserActivityType = {}));

var UserEditErrorCode;

(function (UserEditErrorCode) {
  UserEditErrorCode["FIRST_NAME_REQUIRED"] = "FIRST_NAME_REQUIRED";
  UserEditErrorCode["INVALID_CONTACT"] = "INVALID_CONTACT";
})(UserEditErrorCode || (UserEditErrorCode = {}));

var UserSourceType;

(function (UserSourceType) {
  UserSourceType["ADS"] = "ADS";
  UserSourceType["REFERRAL"] = "REFERRAL";
  UserSourceType["PHONE_CALL"] = "PHONE_CALL";
  UserSourceType["SMS"] = "SMS";
  UserSourceType["INVESTOR"] = "INVESTOR";
  UserSourceType["PARTNER"] = "PARTNER";
  UserSourceType["ORGANIC"] = "ORGANIC";
})(UserSourceType || (UserSourceType = {}));

var VerifyPendingAccessContactErrorCode;

(function (VerifyPendingAccessContactErrorCode) {
  VerifyPendingAccessContactErrorCode["INVALID_TOKEN"] = "INVALID_TOKEN";
})(VerifyPendingAccessContactErrorCode || (VerifyPendingAccessContactErrorCode = {}));

var CreateFirebaseTokenDocument = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation CreateFirebaseToken($messagingUserId: AnyId!) {\n    createFirebaseToken(input: { messagingUserId: $messagingUserId }) {\n      identityToken\n    }\n  }\n"], ["\n  mutation CreateFirebaseToken($messagingUserId: AnyId!) {\n    createFirebaseToken(input: { messagingUserId: $messagingUserId }) {\n      identityToken\n    }\n  }\n"])));
var CreateFirebaseTokenComponent = function CreateFirebaseTokenComponent(props) {
  return createElement(Mutation, __assign({
    mutation: CreateFirebaseTokenDocument
  }, props));
};
var templateObject_1;

var ChatContext = React__default.createContext({
  customMessageComponents: []
});
var ChatConsumer = ChatContext.Consumer;

var ChatProvider =
/** @class */
function (_super) {
  __extends(ChatProvider, _super);

  function ChatProvider(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    _this.initialize = _this.initialize.bind(_this);
    _this.handleAuthenticated = _this.handleAuthenticated.bind(_this);
    _this.handleDeauthenticated = _this.handleDeauthenticated.bind(_this);
    return _this;
  }

  ChatProvider.prototype.componentDidMount = function () {
    this.initialize();
  };

  ChatProvider.prototype.componentDidUpdate = function (prevProps) {
    var _this = this;

    if (this.client && prevProps.userId !== this.props.userId) {
      // need to logout before login
      this.client.logout().then(function () {
        return _this.handleDeauthenticated(false);
      }).then(function () {
        if (_this.props.userId) {
          _this.authenticate(_this.props.userId);
        }
      });
    }
  };

  ChatProvider.prototype.authenticate = function (userId) {
    var _this = this;

    this.props.authenticate(userId).then(function (token) {
      return _this.client.login(token);
    }).then(function () {
      return _this.handleAuthenticated();
    });
  };

  ChatProvider.prototype.componentWillUnmount = function () {
    var _this = this;

    if (this.client) {
      this.client.logout().then(function () {
        _this.handleDeauthenticated(true);
      });
    }
  };

  ChatProvider.prototype.initialize = function () {
    var _this = this;

    if (!this.client) {
      this.client = createClient({
        apiKey: this.props.firebaseApiKey,
        projectId: this.props.firebaseProjectId,
        fetchUserProfiles: this.props.fetchUserProfiles
      });
      this.client.on('unreadChanged', function (evt) {
        _this.setState({
          unreadMessageCount: evt.client.unreadMessageCount,
          unreadConversationCount: evt.client.unreadConversationCount
        });
      });

      if (this.props.userId) {
        this.authenticate(this.props.userId);
      }
    }
  };

  ChatProvider.prototype.handleAuthenticated = function () {
    if (this.client) {
      // TODO: Subscribe to unread count
      this.setState({
        authenticatedUserId: this.client.myself.userId
      });
    } else {
      throw new Error('Authentication succeeded, but client is not available');
    }
  };

  ChatProvider.prototype.handleDeauthenticated = function (unmount) {
    var _this = this;

    if (!unmount) {
      return new Promise(function (resolve) {
        return _this.setState({
          authenticatedUserId: undefined
        }, function () {
          return resolve();
        });
      });
    } else {
      return Promise.resolve();
    }
  };

  ChatProvider.prototype.render = function () {
    // TODO: Ensure this causes re-renders during reauthentication
    var context = {
      client: this.client && this.client.myself ? this.client : undefined,
      authenticatedUserId: this.state.authenticatedUserId,
      impersonating: this.props.impersonating,
      customMessageComponents: this.props.customMessageComponents || [],
      unreadMessageCount: this.state.unreadMessageCount,
      unreadConversationCount: this.state.unreadConversationCount
    };
    return React__default.createElement(ChatContext.Provider, {
      value: context
    }, this.props.children);
  };

  return ChatProvider;
}(React__default.PureComponent);

var ExternalChatProvider = function ExternalChatProvider(props) {
  return React__default.createElement(CreateFirebaseTokenComponent, null, function (createFirebaseToken) {
    return React__default.createElement(ChatProvider, __assign({
      authenticate: function authenticate(userId) {
        return createFirebaseToken({
          variables: {
            messagingUserId: userId
          }
        }).then(function (response) {
          if (!response || !response.data) {
            throw new Error('Failed to generate Firebase authentication token');
          }

          return response.data.createFirebaseToken.identityToken;
        });
      }
    }, props));
  });
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withChat(WrappedComponent) {
  var WithChat =
  /** @class */
  function (_super) {
    __extends(WithChat, _super);

    function WithChat() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    WithChat.prototype.render = function () {
      var _this = this;

      return React__default.createElement(ChatConsumer, null, function (_a) {
        var client = _a.client,
            customMessageComponents = _a.customMessageComponents,
            authenticatedUserId = _a.authenticatedUserId,
            impersonating = _a.impersonating;
        return React__default.createElement(WrappedComponent, __assign({
          firebaseChatClient: client,
          authenticatedUserId: authenticatedUserId,
          customMessageComponents: customMessageComponents,
          impersonating: impersonating
        }, _this.props));
      });
    };

    WithChat.displayName = "WithChat(" + getDisplayName(WrappedComponent) + ")";
    return WithChat;
  }(Component);

  return hoistNonReactStatic(WithChat, WrappedComponent);
}

var ChatActionsContext = React__default.createContext({
  messageAction: undefined
}); // Consumer

var ChatActionsConsumer = ChatActionsContext.Consumer; // Provider

var ChatActionsProvider = function ChatActionsProvider(_a) {
  var children = _a.children,
      messageAction = _a.messageAction;
  return React__default.createElement(ChatActionsContext.Provider, {
    value: {
      messageAction: messageAction
    }
  }, children);
};

var styles$1 = {"list-wrapper":"styles_list-wrapper__1t7xO flex flex-auto flex-column","message-list":"styles_message-list__dkon3 flex flex-auto justify-start m0 px1","listWrapper":"styles_list-wrapper__1t7xO flex flex-auto flex-column","messageList":"styles_message-list__dkon3 flex flex-auto justify-start m0 px1"};

var ScrollContext = React__default.createContext({
  scrollToTarget: function scrollToTarget() {},
  isScrolledToBottom: true
});
var ScrollConsumer = ScrollContext.Consumer;

var Scrollable =
/** @class */
function (_super) {
  __extends(Scrollable, _super);

  function Scrollable(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      isScrolledToBottom: true,
      hasInitialScrollCompleted: false,
      scrollBottom: 0,
      scrollTop: 0
    };
    _this.addScrollListener = _this.addScrollListener.bind(_this);
    _this.removeScrollListener = _this.removeScrollListener.bind(_this);
    /**
     *  Only update the `isScrolledToBottom` state at most once per animation frame, but
     *  fire an event on initial change to kick off the state change. This ensures that the state will be appropriately set when the waypoint is entered
     */

    _this.handleScroll = debounce(_this.handleScroll.bind(_this), 0, {
      leading: true
    });
    /**
     *  Only reset scroll position at most once per animation frame, but
     * - Make sure the first event is fired to reposition before the waypoint/fetchMore is fired again
     * - Make sure the last event is fired to capture the most up-to-date scrollHeight
     */

    _this.scrollToTarget = debounce(_this.scrollToTarget.bind(_this), 0, {
      trailing: true,
      leading: true
    });
    _this.scrollToBottom = _this.scrollToBottom.bind(_this);
    _this.scrollToReset = _this.scrollToReset.bind(_this);
    return _this;
  }

  Scrollable.prototype.componentDidMount = function () {
    if (this.props.element.current) {
      this.addScrollListener(this.props.element.current);
    }
  };

  Scrollable.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.conversationId !== prevProps.conversationId) {
      this.scrollToBottom();
    }

    if (this.props.element !== prevProps.element) {
      this.props.element.current && this.addScrollListener(this.props.element.current);
      prevProps.element.current && this.removeScrollListener(prevProps.element.current);
    }
  };

  Scrollable.prototype.componentWillUnmount = function () {
    this.props.element.current && this.removeScrollListener(this.props.element.current);
  }; // TODO: Use RAF to improve perf


  Scrollable.prototype.handleScroll = function (_event) {
    var element = this.props.element;

    if (this.state.hasInitialScrollCompleted && element.current) {
      var newScrollBottom = this.getScrollBottom();
      /**
       *  Can only set isScrolledBottom = true if the user scrolled up.
       *  Otherwise, there is a race condition where isScrolledBottom is set to true after new messages load, but before it
       *  has been scrolled to the bottom again
       */

      var didUserScroll = this.state.scrollTop > element.current.scrollTop;
      var isScrolledToBottom = newScrollBottom === 0;
      this.setState({
        isScrolledToBottom: didUserScroll ? isScrolledToBottom : this.state.isScrolledToBottom,
        scrollBottom: this.getScrollBottom(),
        scrollTop: element.current.scrollTop
      });
    }
  };

  Scrollable.prototype.addScrollListener = function (element) {
    element.addEventListener('scroll', this.handleScroll.bind(this));
  };

  Scrollable.prototype.removeScrollListener = function (element) {
    element.removeEventListener('scroll', this.handleScroll.bind(this));
  };

  Scrollable.prototype.getScrollBottom = function () {
    var element = this.props.element.current;

    if (element) {
      return element.scrollHeight - (element.scrollTop + element.clientHeight);
    }
  };

  Scrollable.prototype.scrollToBottom = function () {
    var element = this.props.element.current;

    if (element) {
      element.scrollTop = element.scrollHeight;
      this.setState({
        isScrolledToBottom: true,
        hasInitialScrollCompleted: true
      });
    }
  };

  Scrollable.prototype.scrollToReset = function () {
    var element = this.props.element.current;

    if (element) {
      element.scrollTop = element.scrollHeight - (element.clientHeight + this.state.scrollBottom);
    }
  };

  Scrollable.prototype.scrollToTarget = function () {
    if (this.state.isScrolledToBottom) {
      this.scrollToBottom();
    } else {
      this.scrollToReset();
    }
  };

  Scrollable.prototype.render = function () {
    return React__default.createElement(ScrollContext.Provider, {
      value: {
        scrollToTarget: this.scrollToTarget,
        isScrolledToBottom: this.state.isScrolledToBottom
      }
    }, this.props.children);
  };

  return Scrollable;
}(Component);

var Conversation = function Conversation(_a) {
  var children = _a.children,
      loading = _a.loading,
      hasMore = _a.hasMore,
      className = _a.className,
      scrollableElementRef = _a.scrollableElementRef,
      onInfiniteLoad = _a.onInfiniteLoad,
      props = __rest(_a, ["children", "loading", "hasMore", "className", "scrollableElementRef", "onInfiniteLoad"]);

  var _b = useContext(ScrollContext),
      isScrolledToBottom = _b.isScrolledToBottom,
      scrollToTarget = _b.scrollToTarget;

  return (
    /**
     * We need to scroll to bottom when either the scroll container resizes (like when suggested actions are rendered)
     * or when the content within the scroll container changes size (messages change size or a new message is added)
     * Unfortunately, react-measure has a bug that prevents it from referencing the same element as a different ref
     * i.e. we can't do ref={scrollableElementRef(e); measureRef(e)} on just the one scroll container
     * https://github.com/souporserious/react-measure/issues/90
     */
    React__default.createElement(Measure, {
      bounds: true,
      onResize: scrollToTarget
    }, function (_a) {
      var measureRef = _a.measureRef;
      return React__default.createElement("div", {
        ref: measureRef,
        className: styles$1.listWrapper
      }, React__default.createElement(TouchScrollable, null, React__default.createElement("div", __assign({
        className: classnames(className, styles$1.messageList),
        ref: scrollableElementRef
      }, props), children && !loading && hasMore && onInfiniteLoad && React__default.createElement(Waypoint, {
        topOffset: '-1',
        onEnter: function onEnter() {
          // Only load more converersations if the user is not at the bottom of the page (this prevents fetching events on initial load)
          !isScrolledToBottom && onInfiniteLoad();
        }
      }), React__default.createElement(Measure, {
        bounds: true,
        onResize: scrollToTarget
      }, function (_a) {
        var measureRef = _a.measureRef;
        return React__default.createElement("div", {
          ref: measureRef
        }, children);
      }))));
    })
  );
};

var styles$2 = {"row":"styles_row__2iSCM flex items-center","indicator":"styles_indicator__1nwU9 flex items-center justify-around mr1","dot":"styles_dot__3wmnC","blink":"styles_blink__3Ow5s","paused":"styles_paused__2soLN styles_indicator__1nwU9 flex items-center justify-around mr1","typing":"styles_typing__3fEY1 styles_indicator__1nwU9 flex items-center justify-around mr1"};

var TypingIndicator =
/** @class */
function (_super) {
  __extends(TypingIndicator, _super);

  function TypingIndicator() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TypingIndicator.prototype.render = function () {
    var typing = this.props.typing;
    var names = typing.map(function (identity) {
      return identity.displayName;
    });
    var activity;

    switch (names.length) {
      case 0:
        activity = null;
        break;

      case 1:
        activity = names[0] + " is typing...";
        break;

      case 2:
      case 3:
        activity = names.slice(0, -1).join(', ') + " and " + names.slice(1)[0] + " are typing...";
        break;

      default:
        activity = names.length + " people are typing...";
    }

    if (activity) {
      return React__default.createElement("div", {
        className: styles$2.row
      }, React__default.createElement("div", {
        className: styles$2.typing
      }, React__default.createElement("div", {
        className: styles$2.dot
      }), React__default.createElement("div", {
        className: styles$2.dot
      }), React__default.createElement("div", {
        className: styles$2.dot
      })), activity);
    } else {
      return null;
    }
  };

  return TypingIndicator;
}(Component);

var TypingIndicatorContainer =
/** @class */
function (_super) {
  __extends(TypingIndicatorContainer, _super);

  function TypingIndicatorContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      typing: []
    };
    _this.handleTypingStateChange = _this.handleTypingStateChange.bind(_this);
    return _this;
  }

  TypingIndicatorContainer.prototype.handleTypingStateChange = function (evt) {
    this.props.onTypingStatusChange();

    switch (evt.event) {
      case 'typingStarted':
        this.setState(function (prevState) {
          return {
            typing: prevState.typing.concat([evt.user])
          };
        });
        break;

      case 'typingStopped':
        this.setState(function (prevState) {
          return {
            typing: prevState.typing.filter(function (user) {
              return user.userId !== evt.user.userId;
            })
          };
        });
        break;
    }
  };

  TypingIndicatorContainer.prototype.componentDidMount = function () {
    this.conversation = this.props.client.getConversation(this.props.conversationId);
    this.addTypingListener();
  };

  TypingIndicatorContainer.prototype.componentWillReceiveProps = function (nextProps) {
    if (nextProps.conversationId !== this.props.conversationId) {
      this.setState({
        typing: []
      });
      this.removeTypingListener();
      this.conversation = this.props.client.getConversation(nextProps.conversationId);
      this.addTypingListener();
    }
  };

  TypingIndicatorContainer.prototype.componentWillUnmount = function () {
    this.removeTypingListener();
    this.conversation = undefined;
  };

  TypingIndicatorContainer.prototype.addTypingListener = function () {
    if (this.conversation) {
      this.conversation.on('typingStarted', this.handleTypingStateChange);
      this.conversation.on('typingStopped', this.handleTypingStateChange);
    }
  };

  TypingIndicatorContainer.prototype.removeTypingListener = function () {
    if (this.conversation) {
      this.conversation.off('typingStarted', this.handleTypingStateChange);
      this.conversation.off('typingStopped', this.handleTypingStateChange);
    }
  };

  TypingIndicatorContainer.prototype.render = function () {
    return React__default.createElement(TypingIndicator, {
      typing: this.state.typing
    });
  };

  return TypingIndicatorContainer;
}(Component);

var TypingIndicator$1 = (function (props) {
  var client = useContext(ChatContext).client;
  var scrollToTarget = useContext(ScrollContext).scrollToTarget;

  if (client && client.myself) {
    return React__default.createElement(TypingIndicatorContainer, __assign({
      client: client
    }, props, {
      onTypingStatusChange: scrollToTarget
    }));
  } else {
    return null;
  }
});

var styles$3 = {"messages":"styles_messages__eqrAq flex list-reset","label":"styles_label__12haw my2 center","date":"styles_date__3I8sb bold"};

/**
 * A set of messages sent in quick succession. Each exchange in a conversation is headed by a date & time.
 */

var Exchange = function Exchange(_a) {
  var startedAt = _a.startedAt,
      children = _a.children; // TODO: This component should be stateful to track the current date.
  //   The method is impure because it uses `new Date`.

  var now = new Date();
  var date = null;
  var time = format(startedAt, 'h:mm A');

  if (isSameDay(startedAt, now)) {
    date = 'Today';
  } else if (isSameDay(startedAt, subDays(now, 1))) {
    date = 'Yesterday';
  } else if (isSameWeek(startedAt, now)) {
    date = format(startedAt, 'dddd');
  } else if (isSameYear(startedAt, now)) {
    date = format(startedAt, 'ddd, MMM D');
  } else {
    date = format(startedAt, 'ddd, MMM D, YYYY');
  }

  return React__default.createElement("div", null, React__default.createElement("div", {
    className: styles$3.label
  }, React__default.createElement("span", {
    className: styles$3.date
  }, date), React__default.createElement("span", {
    className: styles$3.time
  }, time)), React__default.createElement("ul", {
    className: styles$3.messages
  }, children));
};

/**
 * Displays a chat participants photo/avatar, or a consistently colored circle with their initials
 */

var FirebaseAvatar = function FirebaseAvatar(_a) {
  var sender = _a.sender,
      props = __rest(_a, ["sender"]);

  return React__default.createElement(Avatar, __assign({
    name: sender.displayName,
    hash: sender.userId,
    src: sender.avatarUrl
  }, props));
};

var styles$4 = {"row":"styles_row__LvrZ1","sent":"styles_sent__NP84S","status":"styles_status__1Enkc"};

var MessageStatus;

(function (MessageStatus) {
  MessageStatus[MessageStatus["Unknown"] = 0] = "Unknown";
  MessageStatus[MessageStatus["Pending"] = 1] = "Pending";
  MessageStatus[MessageStatus["Sent"] = 2] = "Sent";
  MessageStatus[MessageStatus["Delivered"] = 3] = "Delivered";
  MessageStatus[MessageStatus["Read"] = 4] = "Read";
})(MessageStatus || (MessageStatus = {}));

var MessageRow =
/** @class */
function (_super) {
  __extends(MessageRow, _super);

  function MessageRow(props) {
    var _this = _super.call(this, props) || this;

    _this.handleMessageStatusChange = _this.handleMessageStatusChange.bind(_this);
    _this.addMessageStatusListener = _this.addMessageStatusListener.bind(_this);
    _this.removeMessageStatusListener = _this.removeMessageStatusListener.bind(_this);
    return _this;
  }

  MessageRow.prototype.handleMessageStatusChange = function () {
    this.forceUpdate();
  };

  MessageRow.prototype.componentDidMount = function () {
    this.addMessageStatusListener(this.props.message);
  };

  MessageRow.prototype.componentWillReceiveProps = function (incomingProps) {
    if (incomingProps.message !== this.props.message) {
      this.removeMessageStatusListener(this.props.message);
      this.addMessageStatusListener(incomingProps.message);
    } // Also subscribe to changes to the next message (from "us"), since that status is
    //   used to determine whether to render this message's status (see `render`)


    if (incomingProps.nextMessageBySameParticipant !== this.props.nextMessageBySameParticipant) {
      if (this.props.nextMessageBySameParticipant) this.removeMessageStatusListener(this.props.nextMessageBySameParticipant);
      if (incomingProps.nextMessageBySameParticipant) this.addMessageStatusListener(incomingProps.nextMessageBySameParticipant);
    }
  };

  MessageRow.prototype.componentWillUnmount = function () {
    this.removeMessageStatusListener(this.props.message);
  };

  MessageRow.prototype.addMessageStatusListener = function (message) {
    message.on('read', this.handleMessageStatusChange, this);
    message.on('delivered', this.handleMessageStatusChange, this);
    message.on('sent', this.handleMessageStatusChange, this);
    message.on('initialized', this.handleMessageStatusChange, this);
  };

  MessageRow.prototype.removeMessageStatusListener = function (message) {
    message.off(undefined, this.handleMessageStatusChange, this);
  };

  MessageRow.prototype.getMessageStatus = function (message) {
    // Generate an array of ReceiptStates for this message, excluding the message sender
    var receiptStatuses = Object.keys(message.receipts).filter(function (key) {
      return key !== message.sentBy.userId;
    }).map(function (key) {
      return message.receipts[key];
    });

    if (receiptStatuses.some(function (status) {
      return status === FirebaseMessageReceiptType.READ;
    })) {
      // The message has been read by at least one user
      return MessageStatus.Read;
    } else if (receiptStatuses.some(function (status) {
      return status === FirebaseMessageReceiptType.DELIVERED;
    })) {
      // The message has been delivered to at least one user
      return MessageStatus.Delivered;
    } else if (receiptStatuses.some(function (status) {
      return status === FirebaseMessageReceiptType.SENT;
    })) {
      // The message has been sent to at least one user
      return MessageStatus.Sent;
    } else if (message.pending) {
      // The message only exists locally
      return MessageStatus.Pending;
    } else {
      // This should not happen
      return MessageStatus.Unknown;
    }
  };

  MessageRow.prototype.renderStatus = function (status) {
    switch (status) {
      case MessageStatus.Pending:
        return 'Pending';

      case MessageStatus.Sent:
        return 'Sent';

      case MessageStatus.Delivered:
        return 'Delivered';

      case MessageStatus.Read:
        return 'Read';

      default:
        return null;
    }
  };

  MessageRow.prototype.render = function () {
    var _a;

    var message = this.props.message;
    var nextMessage = this.props.nextMessageBySameParticipant;
    var messageStatus = this.getMessageStatus(message);
    var nextMessageStatus = nextMessage && this.getMessageStatus(nextMessage);
    var isMyself = message.sentBy.isMyself; // Only render the message status if it's "our" message, AND:
    //   - The following message (sent by us) has a different status
    //   - OR, there is no following message

    var shouldRender = isMyself && (!nextMessage || messageStatus !== nextMessageStatus);
    /**
     * A row in a conversation that contains a single message.
     *
     * Sets the text-alignment to `right` or `left` depending on whether the message is coming from the message owner.
     */

    return React__default.createElement("div", {
      className: classnames(styles$4.row, (_a = {}, _a[styles$4.sent] = isMyself, _a))
    }, this.props.children, shouldRender && React__default.createElement("div", {
      className: styles$4.status
    }, this.renderStatus(messageStatus)));
  };

  return MessageRow;
}(Component);

var styles$5 = {"breakpoint-sm":"(min-width: 40em)","message-bubble":"styles_message-bubble__M_5zY inline-block","full-width":"styles_full-width__1KNFo","sent":"styles_sent__17d7s","received":"styles_received__LQQLT","breakpointSm":"(min-width: 40em)","messageBubble":"styles_message-bubble__M_5zY inline-block","fullWidth":"styles_full-width__1KNFo"};

var MessageBubble =
/** @class */
function (_super) {
  __extends(MessageBubble, _super);

  function MessageBubble() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * This ensures that the scroll container is reset to the correct position when rich cards are loaded
   * Previously, the scroll container was only reset for <MessageText/> components
   */


  MessageBubble.prototype.componentDidMount = function () {
    this.props.onLoaded && this.props.onLoaded();
  };

  MessageBubble.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        message = _b.message,
        onLoaded = _b.onLoaded,
        fullWidth = _b.fullWidth,
        rest = __rest(_b, ["className", "message", "onLoaded", "fullWidth"]);

    var classes = classnames(className, styles$5.messageBubble, (_a = {}, _a[styles$5.fullWidth] = fullWidth, _a));
    return React__default.createElement("div", __assign({
      title: format(message.sentAt.toDate(), 'ddd, MMM Do [at] h:mm A'),
      className: classes
    }, rest));
  };

  return MessageBubble;
}(React__default.Component);

var styles$6 = {"text-message-bubble":"styles_text-message-bubble__24J0-","sent":"styles_sent__1KDL3 styles_text-message-bubble__24J0-","received":"styles_received__2MMvK styles_text-message-bubble__24J0-","from-teammate":"styles_from-teammate__2jnpO styles_received__2MMvK styles_text-message-bubble__24J0-","rich-media-wrapper":"styles_rich-media-wrapper__3hYJJ","rich-media":"styles_rich-media__uBNtm","text":"styles_text__3GjcI","textMessageBubble":"styles_text-message-bubble__24J0-","fromTeammate":"styles_from-teammate__2jnpO styles_received__2MMvK styles_text-message-bubble__24J0-","richMediaWrapper":"styles_rich-media-wrapper__3hYJJ","richMedia":"styles_rich-media__uBNtm"};

var SUPPORTED_VIDEO_PROVIDERS = ['youtube', 'vimeo'];

var MessageBubbleText =
/** @class */
function (_super) {
  __extends(MessageBubbleText, _super);

  function MessageBubbleText() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.linkifier = new Linkify();
    return _this;
  }

  MessageBubbleText.prototype.matchLinks = function (text) {
    return this.linkifier.match(text);
  };
  /**
   * Extract the first URL in the text that we can show a rich media preview for.
   *
   * @param text
   */


  MessageBubbleText.prototype.extractRichMedia = function (text) {
    var matches = this.matchLinks(text);

    if (!matches) {
      return undefined;
    }

    return matches.find(function (match) {
      var parsedVideoUrl = VideoUrlParser.parse(match.url);

      if (parsedVideoUrl && SUPPORTED_VIDEO_PROVIDERS.includes(parsedVideoUrl.provider)) {
        return true;
      }

      return false;
    });
  };

  MessageBubbleText.prototype.formatText = function (text) {
    var matches = this.matchLinks(text); // If there are no URLs, skip processing altogether

    if (!matches) {
      return text;
    } // Iterate through the matches, replacing each match with a link while preserving the plain text


    return matches.reduce(function (output, match, index, matches) {
      var previousEndingIndex = index ? matches[index - 1].lastIndex : 0; // Preserve the text preceding this match

      output.push(text.slice(previousEndingIndex, match.index)); // Convert the match to a link

      output.push(React__default.createElement("a", {
        href: match.url,
        title: match.url,
        key: match.url,
        target: "_blank"
      }, cropUrl(match.text, 45))); // If there are no more matches, include the remaining text

      if (index === matches.length - 1) {
        output.push(text.slice(match.lastIndex));
      }

      return output;
    }, []);
  };

  MessageBubbleText.prototype.render = function () {
    var _a;

    var _b = this.props,
        children = _b.children,
        message = _b.message,
        myself = _b.myself,
        className = _b.className,
        rest = __rest(_b, ["children", "message", "myself", "className"]);

    var sender = message.sentBy;
    var isTeammate = sender.type === 'BUSINESS_USER' && myself.type === 'BUSINESS_USER' && myself !== sender || sender.type === 'SUPPORT' && myself.type === 'OPERATOR' && myself !== sender;
    var classes = classnames(className, message.sentBy.isMyself ? styles$6.sent : styles$6.received, (_a = {}, _a[styles$6.fromTeammate] = isTeammate, _a)); // If there is a video URL in the text, render a video player

    var richMedia = typeof children === 'string' ? this.extractRichMedia(children) : null; // If the video URL is the only text, don't render the raw text

    var isOnlyRichMediaUrl = typeof children === 'string' && richMedia && richMedia.index === 0 && richMedia.lastIndex === children.length;
    return React__default.createElement(MessageBubble, __assign({
      message: message,
      className: classes,
      fullWidth: !!richMedia
    }, rest), richMedia && React__default.createElement("div", {
      className: styles$6.richMediaWrapper
    }, React__default.createElement(ReactPlayer, {
      url: richMedia.url,
      className: styles$6.richMedia,
      width: "100%",
      height: ""
    })), !isOnlyRichMediaUrl && React__default.createElement("div", {
      className: styles$6.text
    }, typeof children === 'string' ? this.formatText(children) : children));
  };

  return MessageBubbleText;
}(React__default.Component);

var styles$7 = {"breakpoint-sm":"(min-width: 40em)","container":"styles_container__1D7WG flex items-center","icon":"styles_icon__3Iku1 flex items-center justify-center relative","expertContainer":"styles_expertContainer__2g--t styles_container__1D7WG flex items-center justify-end","userContainer":"styles_userContainer__3eqnn styles_container__1D7WG flex items-center justify-end","menu":"styles_menu__39hkN","expertMenu":"styles_expertMenu__2ZTIX styles_menu__39hkN","userMenu":"styles_userMenu__3MCyo styles_menu__39hkN","breakpointSm":"(min-width: 40em)"};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var MenuDots = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "4",
    viewBox: "0 0 18 4"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FFF",
    d: "M-904-938h3137V832H-904z"
  }), React__default.createElement("path", {
    d: "M-3-10h24v24H-3z"
  }), React__default.createElement("g", {
    fill: "#111",
    fillRule: "nonzero"
  }, React__default.createElement("circle", {
    cx: "9",
    cy: "2",
    r: "2"
  }), React__default.createElement("circle", {
    cx: "2",
    cy: "2",
    r: "2"
  }), React__default.createElement("circle", {
    cx: "16",
    cy: "2",
    r: "2"
  }))));
});

var ChatActions = function ChatActions(_a) {
  var messagePart = _a.messagePart,
      children = _a.children;
  var messageAction = useContext(ChatActionsContext).messageAction;
  var MessageAction = messageAction;
  return messageAction && messageAction.handlesMessagePart(messagePart) ? React__default.createElement("div", {
    className: messagePart.message.sentBy.isMyself ? styles$7.expertContainer : styles$7.userContainer
  }, React__default.createElement("div", {
    className: styles$7.icon
  }, React__default.createElement(MenuDots, null), React__default.createElement("div", {
    className: messagePart.message.sentBy.isMyself ? styles$7.expertMenu : styles$7.userMenu
  }, MessageAction && React__default.createElement(MessageAction, {
    messagePart: messagePart
  }))), children) : React__default.createElement(React__default.Fragment, null, children);
};

var MessageTextPart =
/** @class */
function (_super) {
  __extends(MessageTextPart, _super);

  function MessageTextPart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageTextPart.prototype.getMessageFromPart = function (part) {
    return part.message;
  };

  MessageTextPart.prototype.getMessagePartText = function (messagePart) {
    switch (messagePart.type) {
      case 'TEXT':
      case 'SHORTENED_TEMPLATE':
      case 'TEMPLATE':
      case 'TEMPLATE_TEXT':
        return messagePart.body.text;

      default:
        throw new Error('Could not decode message part');
    }
  };

  MessageTextPart.prototype.render = function () {
    var text = this.getMessagePartText(this.props.part);
    var message = this.getMessageFromPart(this.props.part);
    return React__default.createElement(ChatActions, {
      messagePart: this.props.part
    }, React__default.createElement(MessageBubbleText, {
      message: message,
      myself: this.props.myself
    }, text));
  };

  return MessageTextPart;
}(Component);

var MessageText =
/** @class */
function (_super) {
  __extends(MessageText, _super);

  function MessageText() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageText.handlesMessage = function (message) {
    return message.parts.length === 1 && this.acceptedTypes.has(message.parts[0].type);
  };

  MessageText.prototype.componentDidMount = function () {
    this.props.onLoaded();
  };

  MessageText.prototype.render = function () {
    var _this = this;

    return this.props.message.parts.map(function (part, idx) {
      return React__default.createElement(MessageTextPart, {
        key: idx,
        part: part,
        myself: _this.props.myself
      });
    });
  };

  MessageText.acceptedTypes = new Set(['TEXT', 'TEMPLATE_TEXT', 'SHORTENED_TEMPLATE', 'TEMPLATE']);
  return MessageText;
}(Component);

var MessageBubbleImage = function MessageBubbleImage(_a) {
  var url = _a.url,
      skipHref = _a.skipHref,
      onLoaded = _a.onLoaded,
      rest = __rest(_a, ["url", "skipHref", "onLoaded"]);

  return React__default.createElement(MessageBubble, __assign({}, rest), skipHref && React__default.createElement("img", {
    src: url,
    onLoad: onLoaded
  }), !skipHref && React__default.createElement("a", {
    href: url,
    target: "_blank"
  }, React__default.createElement("img", {
    src: url,
    onLoad: onLoaded
  })));
};

var MessageImagePart =
/** @class */
function (_super) {
  __extends(MessageImagePart, _super);

  function MessageImagePart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageImagePart.prototype.getMessageFromPart = function (part) {
    return part.message;
  };

  MessageImagePart.prototype.getImageMessagePartUrl = function (messagePart) {
    var body = messagePart.body;
    return body.mediaUrl;
  };

  MessageImagePart.prototype.render = function () {
    var message = this.getMessageFromPart(this.props.part);
    var sourceUrl = this.getImageMessagePartUrl(this.props.part);
    return React__default.createElement(MessageBubbleImage, {
      message: message,
      url: sourceUrl,
      onLoaded: this.props.onLoaded
    });
  };

  return MessageImagePart;
}(Component);

var MessageImage =
/** @class */
function (_super) {
  __extends(MessageImage, _super);

  function MessageImage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageImage.handlesMessage = function (message) {
    return message.parts.length === 1 && message.parts[0].type === 'IMAGE';
  };

  MessageImage.prototype.render = function () {
    var _this = this;

    return this.props.message.parts.map(function (part, idx) {
      return React__default.createElement(MessageImagePart, {
        part: part,
        key: idx,
        onLoaded: _this.props.onLoaded,
        myself: _this.props.myself
      });
    });
  };

  return MessageImage;
}(Component);

var MessageAudioPart =
/** @class */
function (_super) {
  __extends(MessageAudioPart, _super);

  function MessageAudioPart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageAudioPart.prototype.getMessageFromPart = function (part) {
    return part.message;
  };

  MessageAudioPart.prototype.getVideoMessagePartUrl = function (messagePart) {
    var body = messagePart.body;
    return body.mediaUrl;
  };

  MessageAudioPart.prototype.render = function () {
    var message = this.getMessageFromPart(this.props.part);
    var sourceUrl = this.getVideoMessagePartUrl(this.props.part);
    return React__default.createElement(MessageBubble, {
      message: message
    }, React__default.createElement("audio", {
      src: sourceUrl,
      controls: true
    }, "Sorry, your browser doesn't support embedded audios, but don't worry, you can", ' ', React__default.createElement("a", {
      href: sourceUrl,
      target: "_blank"
    }, "download it"), ' ', "and watch it with your favorite audio player!"));
  };

  return MessageAudioPart;
}(Component);

var MessageAudio =
/** @class */
function (_super) {
  __extends(MessageAudio, _super);

  function MessageAudio() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageAudio.handlesMessage = function (message) {
    return message.parts.length === 1 && message.parts[0].type === 'AUDIO';
  };

  MessageAudio.prototype.render = function () {
    var _this = this;

    return this.props.message.parts.map(function (part, idx) {
      return React__default.createElement(MessageAudioPart, {
        part: part,
        key: idx,
        myself: _this.props.myself
      });
    });
  };

  return MessageAudio;
}(Component);

var styles$8 = {"video":"styles_video__1EWEt fit"};

var MessageVideoPart =
/** @class */
function (_super) {
  __extends(MessageVideoPart, _super);

  function MessageVideoPart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageVideoPart.prototype.getMessageFromPart = function (part) {
    return part.message;
  };

  MessageVideoPart.prototype.getVideoMessagePartUrl = function (messagePart) {
    var body = messagePart.body;
    return body.mediaUrl;
  };

  MessageVideoPart.prototype.render = function () {
    var message = this.getMessageFromPart(this.props.part);
    var sourceUrl = this.getVideoMessagePartUrl(this.props.part);
    return React__default.createElement(MessageBubble, {
      message: message
    }, React__default.createElement("video", {
      src: sourceUrl,
      className: styles$8.video,
      controls: true,
      onLoad: this.props.onLoaded
    }, "Sorry, your browser doesn't support embedded videos, but don't worry, you can", ' ', React__default.createElement("a", {
      href: sourceUrl,
      target: "_blank"
    }, "download it"), ' ', "and watch it with your favorite video player!"));
  };

  return MessageVideoPart;
}(Component);

var MessageVideo =
/** @class */
function (_super) {
  __extends(MessageVideo, _super);

  function MessageVideo() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageVideo.handlesMessage = function (message) {
    return message.parts.length === 1 && message.parts[0].type === 'VIDEO';
  };

  MessageVideo.prototype.render = function () {
    var _this = this;

    return this.props.message.parts.map(function (part, idx) {
      return React__default.createElement(MessageVideoPart, {
        key: idx,
        part: part,
        onLoaded: _this.props.onLoaded,
        myself: _this.props.myself
      });
    });
  };

  return MessageVideo;
}(Component);

var Link = function Link(_a) {
  var to = _a.to,
      children = _a.children,
      props = __rest(_a, ["to", "children"]); // Try to use react router for links within the same domain for a nice SPA transition


  var origin = window.location ? window.location.protocol + "//" + window.location.hostname : '';
  var isInternalLink = window.location && to.startsWith(origin);

  if (isInternalLink) {
    var absolutePath = to.substring(origin.length) || '/';
    return React__default.createElement(Link$1, __assign({
      to: absolutePath
    }, props), children);
  } else {
    return React__default.createElement("a", __assign({
      href: to,
      target: "_blank"
    }, props), children);
  }
};

var MessageHyperLinkTextPart =
/** @class */
function (_super) {
  __extends(MessageHyperLinkTextPart, _super);

  function MessageHyperLinkTextPart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageHyperLinkTextPart.prototype.getMessageFromPart = function (part) {
    return part.message;
  };

  MessageHyperLinkTextPart.prototype.render = function () {
    var body = this.props.part.body;
    var message = this.getMessageFromPart(this.props.part);
    return React__default.createElement(ChatActions, {
      messagePart: this.props.part
    }, React__default.createElement(MessageBubbleText, {
      message: message,
      myself: this.props.myself
    }, React__default.createElement(Link, {
      to: body.link
    }, body.text)));
  };

  return MessageHyperLinkTextPart;
}(Component);

var styles$9 = {"error-message":"styles_error-message__2PqQ0 py1 px2","errorMessage":"styles_error-message__2PqQ0 py1 px2"};

var MessageError =
/** @class */
function (_super) {
  __extends(MessageError, _super);

  function MessageError() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageError.handlesMessage = function () {
    return true;
  };

  MessageError.prototype.render = function () {
    return React__default.createElement(MessageBubble, {
      message: this.props.message,
      className: styles$9.errorMessage
    }, "Unrecognized message type");
  };

  return MessageError;
}(Component);

var styles$a = {"carousel-container":"styles_carousel-container__3ZvLm inline-block","carousel":"styles_carousel__1N--S flex","carouselContainer":"styles_carousel-container__3ZvLm inline-block"};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var AttachmentIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$1({
    width: "38",
    height: "46",
    viewBox: "0 0 38 46",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("title", null, "Group 2"), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    fillRule: "nonzero"
  }, React__default.createElement("path", {
    d: "M36 46H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h24l12 12v32a2 2 0 0 1-2 2z",
    fill: "#E6E6E6"
  }), React__default.createElement("path", {
    d: "M26 0v10a2 2 0 0 0 2 2h10L26 0z",
    fill: "#B3B3B3"
  })), React__default.createElement("path", {
    d: "M8 15h24v24H8z"
  }), React__default.createElement("path", {
    d: "M30 26.4l-8.8 8.8c-2.5 2.5-6.7 2.5-9.2 0-2.5-2.5-2.5-6.7 0-9.2l7.8-7.8c1.8-1.8 4.6-1.8 6.4 0 1.8 1.8 1.8 4.6 0 6.4L19 31.7c-1 1-2.6 1-3.5 0-1-1-1-2.6 0-3.5l6-6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#3D4E56",
    strokeWidth: "2"
  })));
});

var styles$b = {"file-container":"styles_file-container__2cBgd flex items-center","attachment-icon":"styles_attachment-icon__1wfFa","file-name":"styles_file-name__2lkMt","fileContainer":"styles_file-container__2cBgd flex items-center","attachmentIcon":"styles_attachment-icon__1wfFa","fileName":"styles_file-name__2lkMt"};

var MessageBubbleFile = function MessageBubbleFile(_a) {
  var url = _a.url,
      fileName = _a.fileName,
      onLoad = _a.onLoad,
      rest = __rest(_a, ["url", "fileName", "onLoad"]);

  return React__default.createElement(MessageBubble, __assign({}, rest), React__default.createElement("a", {
    href: url,
    target: "_blank"
  }, React__default.createElement("div", {
    className: styles$b.fileContainer
  }, React__default.createElement(AttachmentIcon, {
    className: styles$b.attachmentIcon
  }), React__default.createElement("span", {
    className: styles$b.fileName
  }, fileName ? fileName : url && url.substring(url.lastIndexOf('/') + 1)))));
};

var MessageFilePart =
/** @class */
function (_super) {
  __extends(MessageFilePart, _super);

  function MessageFilePart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageFilePart.prototype.getMessageFromPart = function (part) {
    return part.message;
  };

  MessageFilePart.prototype.getFileMessagePartUrl = function (messagePart) {
    var body = messagePart.body;
    return body.mediaUrl;
  };

  MessageFilePart.prototype.getFilenameFromPart = function (messagePart) {
    var body = messagePart.body;
    return body.originalFileName;
  };

  MessageFilePart.prototype.render = function () {
    var message = this.getMessageFromPart(this.props.part);
    var sourceUrl = this.getFileMessagePartUrl(this.props.part);
    var fileName = this.getFilenameFromPart(this.props.part);
    return React__default.createElement(MessageBubbleFile, {
      fileName: fileName,
      message: message,
      url: sourceUrl
    });
  };

  return MessageFilePart;
}(Component);

var MessageCarousel =
/** @class */
function (_super) {
  __extends(MessageCarousel, _super);

  function MessageCarousel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageCarousel.handlesMessage = function (message) {
    return message.parts.length > 1;
  };

  MessageCarousel.prototype.render = function () {
    var _this = this;

    return React__default.createElement("div", {
      className: styles$a.carouselContainer
    }, React__default.createElement("div", {
      className: styles$a.carousel
    }, this.props.message.parts.map(function (part, idx) {
      switch (part.type) {
        case 'IMAGE':
          return React__default.createElement(MessageImagePart, {
            part: part,
            key: idx,
            onLoaded: _this.props.onLoaded,
            myself: _this.props.myself
          });

        case 'VIDEO':
          return React__default.createElement(MessageVideoPart, {
            part: part,
            key: idx,
            onLoaded: _this.props.onLoaded,
            myself: _this.props.myself
          });

        case 'TEXT':
        case 'TEMPLATE':
        case 'SHORTENED_TEMPLATE':
        case 'TEMPLATE_TEXT':
          return React__default.createElement(MessageTextPart, {
            part: part,
            key: idx,
            myself: _this.props.myself
          });

        case 'HYPERLINK_TEXT':
          return React__default.createElement(MessageHyperLinkTextPart, {
            part: part,
            key: idx,
            myself: _this.props.myself
          });

        case 'TEMPLATE_CAROUSEL':
          return null;

        case 'FILE':
          return React__default.createElement(MessageFilePart, {
            part: part,
            key: idx,
            myself: _this.props.myself
          });

        default:
          return React__default.createElement(MessageError, __assign({}, _this.props, {
            key: idx,
            myself: _this.props.myself
          }));
      }
    })));
  };

  return MessageCarousel;
}(Component);

var MessageHyperLinkText =
/** @class */
function (_super) {
  __extends(MessageHyperLinkText, _super);

  function MessageHyperLinkText() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageHyperLinkText.handlesMessage = function (message) {
    return message.parts.length === 1 && message.parts[0].type === 'HYPERLINK_TEXT';
  };

  MessageHyperLinkText.prototype.render = function () {
    var _this = this;

    return this.props.message.parts.map(function (part, idx) {
      return React__default.createElement(MessageHyperLinkTextPart, {
        part: part,
        key: idx,
        myself: _this.props.myself
      });
    });
  };

  MessageHyperLinkText.acceptedMimeTypes = ['application/vnd.deal.hyperlinktext+json'];
  return MessageHyperLinkText;
}(Component);

var MessageFile =
/** @class */
function (_super) {
  __extends(MessageFile, _super);

  function MessageFile() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageFile.handlesMessage = function (message) {
    return message.parts.length === 1 && message.parts[0].type === 'FILE';
  };

  MessageFile.prototype.componentDidMount = function () {
    this.props.onLoaded();
  };

  MessageFile.prototype.render = function () {
    var _this = this;

    return this.props.message.parts.map(function (part, idx) {
      return React__default.createElement(MessageFilePart, {
        part: part,
        key: idx,
        myself: _this.props.myself
      });
    });
  };

  return MessageFile;
}(Component);

var MessageChannel;

(function (MessageChannel) {
  MessageChannel["SMS"] = "SMS";
  MessageChannel["EMAIL"] = "EMAIL";
  MessageChannel["FACEBOOK"] = "FACEBOOK";
})(MessageChannel || (MessageChannel = {}));

var MessageContainer =
/** @class */
function (_super) {
  __extends(MessageContainer, _super);

  function MessageContainer(props) {
    var _a;

    var _this = _super.call(this, props) || this;
    /**
     * A list of React components available to render messages. Each message component must
     *   implement a static `handlesMessage` method that determines whether it can render
     *   a given message.
     *
     * Note: Order matters! The first component that can handle a message is used.
     */


    _this.components = [MessageImage, MessageVideo, MessageAudio, MessageCarousel, MessageText, MessageHyperLinkText, MessageFile, MessageError];
    _this.state = {
      isRead: props.message.read
    };

    (_a = _this.components).unshift.apply(_a, _this.props.customMessageComponents);

    _this.handlePositionChange = _this.handlePositionChange.bind(_this);
    _this.handleMessageRead = _this.handleMessageRead.bind(_this);
    return _this;
  }

  MessageContainer.prototype.handleMessageRead = function () {
    this.setState({
      isRead: true
    });
  };

  MessageContainer.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.enableReadReceipts !== this.props.enableReadReceipts) {
      this.props.message.conversation.markConversationRead(this.props.message.messageId);
    }
  };

  MessageContainer.prototype.componentDidMount = function () {
    var _this = this;

    if (!this.props.message.initialized) {
      this.props.message.once('initialized', function () {
        return _this.forceUpdate();
      }, this);
    }

    this.props.message.on('read', this.handleMessageRead);
  };

  MessageContainer.prototype.componentWillUnmount = function () {
    this.props.message.off('initialized', undefined, this);
    this.props.message.off('read', this.handleMessageRead);
  };

  MessageContainer.prototype.handlePositionChange = function (_a) {
    var _this = this;

    var currentPosition = _a.currentPosition;

    if (currentPosition === Waypoint.inside && !this.props.impersonating && this.props.enableReadReceipts !== false) {
      // @ts-ignore TODO: Runtime require/import with Rollup? See: https://github.com/rollup/rollup/issues/1807
      var Visibility = require('visibilityjs');

      Visibility.onVisible(function () {
        _this.props.message.conversation.markConversationRead(_this.props.message.messageId);
      });
    }
  };

  MessageContainer.prototype.handleError = function (error) {
    throw new Error(error);
  };

  MessageContainer.prototype.render = function () {
    var _this = this;

    var client = this.props.firebaseChatClient;
    var myself = client && client.myself;

    if (!this.props.message.initialized || !myself) {
      // Not initialized, or the client isn't available, so don't render the message
      return null;
    } // Find the first component that is able to render this message


    var MessageComponent = this.components.find(function (handler) {
      return handler.handlesMessage(_this.props.message);
    });

    if (MessageComponent) {
      /**
       *  TODO: This <div> complicates styling, because it breaks the flexbox.
       *  See: MessageGroup/styles.css
       *  MessageRow assumes there is only one child. If this is no longer the case, MessageRow will need to be updated
       */
      var message = React__default.createElement("div", null, React__default.createElement(ScrollConsumer, null, function (_a) {
        var scrollToTarget = _a.scrollToTarget;
        return React__default.createElement(MessageRow, {
          message: _this.props.message,
          nextMessage: _this.props.nextMessage,
          nextMessageBySameParticipant: _this.props.nextMessageBySameParticipant
        }, React__default.createElement(MessageComponent, {
          message: _this.props.message,
          myself: myself,
          onError: _this.handleError,
          onLoaded: scrollToTarget
        }));
      }));

      if (this.state.isRead) {
        return message;
      } else {
        return React__default.createElement(Waypoint, {
          onPositionChange: this.handlePositionChange
        }, message);
      }
    } else {
      throw new Error('Unknown message type');
    }
  };

  return MessageContainer;
}(Component);

var Message = withChat(MessageContainer);

var styles$c = {"group":"styles_group__2CKex mb2","sent":"styles_sent__2jW2H styles_group__2CKex mb2 items-end","received":"styles_received__1zetl styles_group__2CKex mb2 items-start","-webkit-columns":"styles_columns__2qeGK","-moz-columns":"styles_columns__2qeGK","columns":"styles_columns__2qeGK","avatar":"styles_avatar__S6zxH self-start","messages":"styles_messages__26m-S","sender":"styles_sender__1eQ5c flex items-center bold","channels":"styles_channels__1fadw flex items-center bold","webkitColumns":"styles_columns__2qeGK","mozColumns":"styles_columns__2qeGK"};

function formatChannel(channel) {
  switch (channel) {
    case MessageChannel.SMS:
      return 'SMS';

    case MessageChannel.EMAIL:
      return 'Email';

    case MessageChannel.FACEBOOK:
      return 'Facebook Messenger';
  }
}

var MessageGroup = function MessageGroup(_a) {
  var _b, _c;

  var sender = _a.sender,
      channels = _a.channels,
      children = _a.children,
      persona = _a.persona;
  var showIdentity = sender && !sender.isMyself;
  var uniqChannels = uniq(channels).filter(function (c) {
    return c !== null;
  });
  var formattedChannels = uniqChannels.length ? "via " + uniqChannels.map(formatChannel).join(' and ') : null;
  var isSenderClickable = sender && sender.vanityId;
  return React__default.createElement("li", {
    className: styles$c.group
  }, React__default.createElement("div", {
    className: styles$c.columns
  }, showIdentity && sender && (isSenderClickable ? React__default.createElement(Link$1, {
    to: "/experts/" + sender.vanityId
  }, React__default.createElement(FirebaseAvatar, {
    sender: sender,
    size: "medium",
    className: classnames(styles$c.avatar, (_b = {}, _b[styles$c.clickable] = isSenderClickable, _b))
  })) : React__default.createElement(FirebaseAvatar, {
    sender: sender,
    size: "medium",
    className: classnames(styles$c.avatar, (_c = {}, _c[styles$c.clickable] = isSenderClickable, _c))
  })), React__default.createElement("div", {
    className: styles$c.messages
  }, children, showIdentity && sender && (isSenderClickable ? React__default.createElement(Link$1, {
    to: "/experts/" + sender.vanityId
  }, React__default.createElement("span", {
    className: classnames(styles$c.sender)
  }, sender && sender.displayName, React__default.createElement("span", {
    className: styles$c.channels
  }, formattedChannels))) : React__default.createElement("span", {
    className: classnames(styles$c.sender)
  }, sender && sender.displayName, " ", persona && "(" + persona + ")", React__default.createElement("span", {
    className: styles$c.channels
  }, formattedChannels))))));
};

var ExchangeContainer =
/** @class */
function (_super) {
  __extends(ExchangeContainer, _super);

  function ExchangeContainer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Get the messaging channels (sms, email, facebook, etc.) used to send a single message.
   */


  ExchangeContainer.prototype.getChannelsForMessage = function (message) {
    switch (message.sentVia) {
      case FirebaseMessageChannel.EMAIL:
        return new Set([MessageChannel.EMAIL]);

      case FirebaseMessageChannel.FACEBOOK:
        return new Set([MessageChannel.FACEBOOK]);

      case FirebaseMessageChannel.SMS:
        return new Set([MessageChannel.SMS]);
    }

    return new Set();
  };
  /**
   * Get the messaging channels (sms, email, facebook, etc.) used to send a group of messages.
   */


  ExchangeContainer.prototype.getChannelsForGroup = function (group) {
    var _this = this;

    var channels = new Set();
    group.forEach(function (conversationItem) {
      conversationItem.type === 'FirebaseMessage' && _this.getChannelsForMessage(conversationItem.message).forEach(function (channel) {
        channels.add(channel);
      });
    });
    return channels;
  };

  ExchangeContainer.prototype.isConversationMessage = function (item) {
    return item.type === 'FirebaseMessage';
  };
  /**
   * Return all the FirebaseMessages in this exchange's items
   *
   * TODO: memoization
   */


  ExchangeContainer.prototype.getMessages = function () {
    return this.props.items.filter(this.isConversationMessage).map(function (item) {
      return item.message;
    });
  };
  /**
   * Given a FirebaseMessage, determine the next message in the conversation.
   */


  ExchangeContainer.prototype.getNextMessage = function (message) {
    var messages = this.getMessages();
    var currentMessageIndex = messages.findIndex(function (m) {
      return m.messageId === message.messageId;
    });
    return messages[currentMessageIndex - 1];
  };
  /**
   * Given a FirebaseMessage, determine the next message sent by the same participant.
   */


  ExchangeContainer.prototype.getNextMessageBySameParticipant = function (message) {
    // Filter out messages from other participants
    var myMessages = this.getMessages().filter(function (message) {
      return message.sentBy.isMyself;
    });
    var currentMessageIndex = myMessages.findIndex(function (m) {
      return m.messageId === message.messageId;
    });
    return myMessages[currentMessageIndex - 1];
  };

  ExchangeContainer.prototype.render = function () {
    var _this = this;
    /**
     * Chunk this exchange of messages into messages sent by the same user ("message groups")
     *
     * This logic requires the messages to be sorted
     */


    var groups = this.props.items.reduce(function (accumulatedGroups, current, index, messages) {
      var previous = messages[index - 1];
      var currentSender = current.type === 'FirebaseMessage' ? _this.props.showRealSender && current.message.realSender ? current.message.realSender : current.message.sentBy : undefined;
      var prevSender = previous && previous.type === 'FirebaseMessage' ? _this.props.showRealSender && previous.message.realSender ? previous.message.realSender : previous.message.sentBy : undefined;

      if (!previous || (currentSender && currentSender.userId) !== (prevSender && prevSender.userId)) {
        accumulatedGroups.push([]);
      }

      accumulatedGroups[accumulatedGroups.length - 1].push(current);
      return accumulatedGroups;
    }, []);

    if (!this.props.items.length) {
      return null;
    }

    return React__default.createElement(Exchange, {
      startedAt: this.props.items[this.props.items.length - 1].time
    }, groups.map(function (group, idx) {
      var channels = Array.from(_this.getChannelsForGroup(group));
      var firstMessage = group.find(function (group) {
        return group.type === 'FirebaseMessage';
      });
      var sender = firstMessage && firstMessage.type === 'FirebaseMessage' ? _this.props.showRealSender && firstMessage.message.realSender ? firstMessage.message.realSender : firstMessage.message.sentBy : null;
      var persona = !sender ? null : _this.props.showRealSender && firstMessage && firstMessage.type === 'FirebaseMessage' && firstMessage.message.sentBy.userId !== sender.userId ? firstMessage.message.sentBy.displayName : null;
      return React__default.createElement(MessageGroup, {
        sender: sender,
        persona: persona,
        channels: channels,
        key: idx
      }, group.map(function (conversationItem) {
        return conversationItem.type === 'FirebaseMessage' ? React__default.createElement(Message, {
          message: conversationItem.message,
          nextMessage: _this.getNextMessage(conversationItem.message),
          enableReadReceipts: _this.props.enableReadReceipts,
          nextMessageBySameParticipant: _this.getNextMessageBySameParticipant(conversationItem.message),
          key: conversationItem.message.messageId
        }) : conversationItem.event.element;
      }));
    }));
  };

  return ExchangeContainer;
}(Component);

var FirebaseMessageQuery =
/** @class */
function (_super) {
  __extends(FirebaseMessageQuery, _super);

  function FirebaseMessageQuery(props) {
    var _this = _super.call(this, props) || this; // TODO: Call `load` in the constructor to prevent this loading state.
    //   We will need to remove the state side-effects of `load` first.


    _this.state = {
      loading: !!_this.props.conversationId
    };
    _this.load = _this.load.bind(_this);
    _this.cancel = _this.cancel.bind(_this);
    _this.fetchMore = _this.fetchMore.bind(_this);
    _this.handleMessagesLoaded = _this.handleMessagesLoaded.bind(_this);
    return _this;
  }

  FirebaseMessageQuery.prototype.componentDidMount = function () {
    if (!this.query && this.props.conversationId && this.props.firebaseChatClient) {
      this.load(this.props.conversationId, this.props.firebaseChatClient);
    }
  };

  FirebaseMessageQuery.prototype.componentDidUpdate = function (prevProps) {
    // Firebase client no longer available, or no conversation ID provided
    if (!this.props.firebaseChatClient || !this.props.conversationId) {
      this.cancel();
    } // Conversation or authenticated user has changed


    if (this.props.firebaseChatClient && (prevProps.conversationId !== this.props.conversationId || prevProps.authenticatedUserId !== this.props.authenticatedUserId)) {
      this.cancel();

      if (this.props.conversationId) {
        this.load(this.props.conversationId, this.props.firebaseChatClient);
      }
    }
  };

  FirebaseMessageQuery.prototype.componentWillUnmount = function () {
    this.cancel();
  };

  FirebaseMessageQuery.prototype.load = function (conversationId, client) {
    var conversation = client.getConversation(conversationId);
    this.query = conversation.getMessageQuery(this.props.pageSize);

    if (this.query.initialized) {
      // If the query is already initialized, return immediately.
      return this.handleMessagesLoaded();
    } else {
      // Otherwise, enter a loading state and handle the results asyncronously.
      this.setState({
        messages: undefined,
        loading: true
      });
    }

    this.query.once('initialized', this.handleMessagesLoaded, this);
    this.query.on('updated', this.handleMessagesLoaded, this);
  };

  FirebaseMessageQuery.prototype.cancel = function () {
    if (this.query) {
      this.query.off('initialized', this.handleMessagesLoaded, this);
      this.query.off('updated', this.handleMessagesLoaded, this);
      this.query.close();
      delete this.query;
    }
  };

  FirebaseMessageQuery.prototype.handleMessagesLoaded = function () {
    if (this.query) {
      var _a = this.query,
          messages = _a.messages,
          hasMore = _a.hasMore;
      this.setState({
        messages: messages,
        hasMore: hasMore,
        loading: false
      });

      if (this.props.onCompleted) {
        this.props.onCompleted({
          messages: messages,
          hasMore: hasMore
        });
      }
    }
  };

  FirebaseMessageQuery.prototype.fetchMore = function () {
    var _this = this;

    if (this.query) {
      this.setState({
        loading: true
      });
      return this.query.more(this.props.fetchMorePageSize).then(function (_a) {
        var messages = _a.messages,
            hasMore = _a.hasMore;

        _this.setState({
          loading: false,
          messages: messages
        });

        return {
          messages: messages,
          hasMore: hasMore
        };
      });
    }

    return Promise.resolve({
      messages: this.state.messages,
      hasMore: this.state.hasMore
    });
  };

  FirebaseMessageQuery.prototype.render = function () {
    /**
     * `this.state.loading` only tracks whether the query is unfinished. We also
     *    need to consider the loading/auth state of the Firebase client itself.
     */
    var loading = this.state.loading || !this.props.firebaseChatClient || !this.props.authenticatedUserId;
    return this.props.children({
      loading: loading,
      messages: this.state.messages,
      hasMore: this.state.hasMore,
      fetchMore: this.fetchMore
    });
  };

  FirebaseMessageQuery.defaultProps = {
    pageSize: 25,
    fetchMorePageSize: 25
  };
  return FirebaseMessageQuery;
}(Component);

var FirebaseMessageQuery$1 = withChat(FirebaseMessageQuery);

var ConversationContainer =
/** @class */
function (_super) {
  __extends(ConversationContainer, _super);

  function ConversationContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      queryCompleted: false
    };
    _this.scrollableElement = React__default.createRef();
    _this.toConversationItem = _this.toConversationItem.bind(_this);
    _this.handleQueryCompleted = _this.handleQueryCompleted.bind(_this);
    return _this;
  }

  ConversationContainer.prototype.getConversationRange = function (result) {
    var messages = result.messages;

    if (!messages || messages.length === 0) {
      return {
        start: null,
        end: new Date().toISOString()
      };
    }

    return {
      start: result.hasMore ? messages[messages.length - 1].sentAt.toDate().toISOString() : null,
      // Gets the most recent events (even if more recent than last message)
      end: null
    };
  };

  ConversationContainer.prototype.handleQueryCompleted = function (result) {
    if (result.messages) {
      // Fetch events that occured during this time range (the range from the oldest loaded message until now)
      var conversationRange = this.getConversationRange(result);

      if (this.props.fetchEvents) {
        this.props.fetchEvents(conversationRange.start, conversationRange.end);
      } // Determine the parent element to use as the scroll context (for manual scroll position correction)


      this.setState({
        queryCompleted: true
      });
    }
  };

  ConversationContainer.prototype.isFirebaseObject = function (arg) {
    return arg.read !== undefined;
  };

  ConversationContainer.prototype.toConversationItem = function (item) {
    if (this.isFirebaseObject(item)) {
      return {
        time: item.sentAt.toDate(),
        type: 'FirebaseMessage',
        message: item
      };
    } else {
      return {
        time: new Date(item.occuredAt),
        type: 'Event',
        event: item
      };
    }
  };
  /**
   * Merge Firebase conversation messages and user events into single sorted array
   *   of conversation items
   */


  ConversationContainer.prototype.mergeMessagesAndEvents = function (messages, events) {
    var _this = this;

    var conversationItems = concat(messages, events).reduce(function (acc, currentItem) {
      var newItem = _this.toConversationItem(currentItem);

      acc.push(newItem);
      return acc;
    }, []); // Sort array messages and events by date

    var sortedConversationItems = conversationItems.sort(function (a, b) {
      if (isAfter(a.time, b.time)) return -1;
      if (isAfter(b.time, a.time)) return 1;else return 0;
    });
    return sortedConversationItems;
  };
  /**
   * Given a list of conversation items, group them into "exchanges". An exchange is
   *   a group of conversation items occuring in quick succession (i.e. no more than
   *   5 minutes between any two items)
   *
   * Note: The conversation items MUST be sorted before chunking.
   */


  ConversationContainer.prototype.chunkConversationItems = function (conversationItems) {
    var IDLE_MINUTES = 5;
    return reduce(conversationItems, function (accumulatedExchanges, current, index, messages) {
      var previous = messages[index - 1];

      if (!previous || Math.abs(differenceInMinutes(previous.time, current.time)) > IDLE_MINUTES) {
        accumulatedExchanges.push([]);
      }

      accumulatedExchanges[accumulatedExchanges.length - 1].push(current);
      return accumulatedExchanges;
    }, []);
  };

  ConversationContainer.prototype.render = function () {
    var _this = this;

    return React__default.createElement(ChatActionsProvider, {
      messageAction: this.props.messageAction
    }, React__default.createElement(Scrollable, {
      element: this.scrollableElement,
      conversationId: this.props.conversationId
    }, React__default.createElement(FirebaseMessageQuery$1, {
      conversationId: this.props.conversationId,
      onCompleted: this.handleQueryCompleted
    }, function (_a) {
      var loading = _a.loading,
          messages = _a.messages,
          hasMore = _a.hasMore,
          fetchMore = _a.fetchMore;
      var exchanges = [];

      if (messages) {
        var conversationItems = _this.mergeMessagesAndEvents(messages, _this.props.events || []);

        exchanges = _this.chunkConversationItems(conversationItems);
      } // Render children if the conversation doesn't exist, or if we've reached the top of the conversation


      var showConversationStarter = !_this.props.conversationId || !hasMore && !loading;
      return React__default.createElement(Conversation, {
        loading: loading,
        hasMore: hasMore || false,
        onInfiniteLoad: fetchMore,
        scrollableElementRef: _this.scrollableElement,
        onClick: _this.props.onClick
      }, showConversationStarter && _this.props.children, loading && React__default.createElement(Loader, {
        size: "22px",
        color: "#087bcc",
        thickness: "3px"
      }), exchanges.length > 0 && exchanges.reverse().map(function (exchange) {
        // Key by the last item in the exchange so that exchanges are stable
        //   even if older items are loaded later
        var lastItem = exchange[exchange.length - 1];
        return React__default.createElement(ExchangeContainer, {
          items: exchange,
          showRealSender: _this.props.showRealSender,
          enableReadReceipts: _this.props.enableReadReceipts,
          key: lastItem.type === 'FirebaseMessage' ? "exchange:message:" + lastItem.message.messageId : "exchange:event:" + lastItem.event.occuredAt
        });
      }), _this.props.conversationId && React__default.createElement(TypingIndicator$1, {
        conversationId: _this.props.conversationId
      }));
    })));
  };

  return ConversationContainer;
}(Component);

var Conversation$1 = withChat(ConversationContainer);

var styles$d = {"chat":"styles_chat__1aCmL flex flex-auto flex-column"};

var Chat = function Chat(_a) {
  var children = _a.children;
  return React__default.createElement("div", {
    className: styles$d.chat
  }, children);
};

var styles$e = {"control":"styles_control__11--R px1","collapsedControl":"styles_collapsedControl__FUsP8 styles_control__11--R px1"};

var Controls =
/** @class */
function (_super) {
  __extends(Controls, _super);

  function Controls() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Controls.prototype.render = function () {
    var _a = this.props,
        controls = _a.controls,
        conversationId = _a.conversationId,
        onAttach = _a.onAttach,
        onAppendText = _a.onAppendText,
        collapsed = _a.collapsed,
        onError = _a.onError;
    return controls.map(function (Control, index) {
      return React__default.createElement("div", {
        key: index,
        className: collapsed ? styles$e.collapsedControl : styles$e.control
      }, React__default.createElement(Control, {
        conversationId: conversationId,
        attach: onAttach,
        appendText: onAppendText,
        onError: onError
      }));
    });
  };

  return Controls;
}(React__default.PureComponent);

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ChevronLeft = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: "44",
    height: "44",
    viewBox: "0 0 44 44"
  }, props), React__default.createElement("path", {
    d: "M15.657 21.828l18 18-2.829 2.829L10 21.828 30.828 1l2.829 2.828z"
  }));
});

var styles$f = {"composer":"styles_composer__3Bulu fit flex flex-auto flex-column px2","content":"styles_content__8SuaW flex","preview":"styles_preview__a7XtZ flex","attachment":"styles_attachment__2vXZP","tray":"styles_tray__3iFm0 flex flex-auto items-center","input":"styles_input__180l- flex-auto m1 p1 border-none","send":"styles_send__3MP8w bold items-end m1 p1 border-none","disabled":"styles_disabled__3FSQ6 styles_send__3MP8w bold items-end m1 p1 border-none","extend":"styles_extend__1BYQe","text-area-wrapper":"styles_text-area-wrapper__1T03P flex flex-auto","textAreaWrapper":"styles_text-area-wrapper__1T03P flex flex-auto"};

var Composer =
/** @class */
function (_super) {
  __extends(Composer, _super);

  function Composer(props) {
    var _this = _super.call(this, props) || this;

    _this.button = null;
    _this.handleError = _this.handleError.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    return _this;
  }

  Composer.prototype.handleKeyPress = function (event) {
    // Submit the form on "Enter", unless it was "Shift+Enter"
    // React fires a synthetic event for form submissions, so we click the submit button to trigger the event
    if (event.key === 'Enter' && !event.shiftKey && this.button) {
      this.button.click();
      event.preventDefault();
    }
  };

  Composer.prototype.handleError = function (error) {
    console.log(error.toString());
  };

  Composer.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        collapsed = _a.collapsed,
        controls = _a.controls,
        setComposerRef = _a.setComposerRef,
        onFocus = _a.onFocus,
        onAppendText = _a.onAppendText,
        onAttach = _a.onAttach,
        onChange = _a.onChange,
        onExpand = _a.onExpand,
        text = _a.text,
        loading = _a.loading,
        conversationId = _a.conversationId;
    return React__default.createElement("form", {
      className: styles$f.composer,
      onSubmit: this.props.onSubmit
    }, React__default.createElement("div", {
      className: styles$f.preview
    }, (this.props.attachments || []).map(function (attachment, index) {
      var PreviewComponent = attachment.previewer;
      return React__default.createElement("div", {
        key: index,
        className: styles$f.attachment,
        onClick: function onClick() {
          return _this.props.onDetach(index);
        }
      }, React__default.createElement(PreviewComponent, {
        data: attachment.data
      }));
    })), React__default.createElement("div", {
      className: styles$f.tray
    }, React__default.createElement("div", {
      className: styles$f.textAreaWrapper
    }, React__default.createElement(TextArea, {
      innerRef: setComposerRef,
      className: styles$f.input,
      onFocus: onFocus,
      value: text || '',
      placeholder: "Send a message...",
      onChange: onChange,
      onKeyPress: this.handleKeyPress,
      disabled: loading
    })), !collapsed && React__default.createElement(Controls, {
      conversationId: conversationId,
      controls: controls || [],
      onAttach: onAttach,
      onAppendText: onAppendText,
      collapsed: collapsed,
      onError: this.handleError
    }), collapsed && controls && controls.length ? React__default.createElement(ChevronLeft, {
      className: styles$f.extend,
      onClick: onExpand
    }) : null, React__default.createElement("button", {
      type: "submit",
      className: !loading ? styles$f.send : styles$f.disabled,
      ref: function ref(el) {
        return _this.button = el;
      }
    }, "Send")));
  };

  return Composer;
}(React__default.Component);

/**
 * Execute a set of Promises in series. Accepts an array of functions returning Promises.
 *
 * From: https://hackernoon.com/functional-javascript-resolving-promises-sequentially-7aac18c4431e
 */
function promiseSerial(promises) {
  return promises.reduce(function (promise, func) {
    return promise.then(function (result) {
      return func().then(Array.prototype.concat.bind(result));
    });
  }, Promise.resolve([]));
}

var FirebaseConversationQuery =
/** @class */
function (_super) {
  __extends(FirebaseConversationQuery, _super);

  function FirebaseConversationQuery(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      loading: !!_this.props.conversationId
    };
    _this.load = _this.load.bind(_this);
    _this.cancel = _this.cancel.bind(_this);
    _this.handleConversationLoaded = _this.handleConversationLoaded.bind(_this);
    _this.handleConversationChanged = _this.handleConversationChanged.bind(_this);
    return _this;
  }

  FirebaseConversationQuery.prototype.componentDidMount = function () {
    if (this.props.conversationId && this.props.firebaseChatClient) {
      this.load(this.props.conversationId, this.props.firebaseChatClient);
    }
  };

  FirebaseConversationQuery.prototype.componentDidUpdate = function (prevProps) {
    // Firebase client no longer available
    if (!this.props.firebaseChatClient) {
      this.cancel();
    } // Conversation or authenticated user has changed


    if (this.props.firebaseChatClient && (prevProps.conversationId !== this.props.conversationId || prevProps.authenticatedUserId !== this.props.authenticatedUserId)) {
      this.cancel();

      if (this.props.conversationId) {
        this.load(this.props.conversationId, this.props.firebaseChatClient);
      } else {
        // We still need to update since we read `this.conversation` in render, which is deleted by `cancel`.
        this.forceUpdate();
      }
    }
  };

  FirebaseConversationQuery.prototype.componentWillUnmount = function () {
    this.cancel();
  };

  FirebaseConversationQuery.prototype.load = function (conversationId, client) {
    this.setState({
      loading: true
    });
    this.conversation = client.getConversation(conversationId);

    if (this.conversation.initialized) {
      this.handleConversationLoaded();
    } else {
      this.conversation.once('initialized', this.handleConversationLoaded, this);
    }

    this.conversation.on('changed', this.handleConversationChanged, this);
  };

  FirebaseConversationQuery.prototype.cancel = function () {
    if (this.conversation) {
      this.conversation.off('initialized', this.handleConversationLoaded, this);
      this.conversation.off('changed', this.handleConversationChanged, this);
      delete this.conversation;
    }
  };

  FirebaseConversationQuery.prototype.handleConversationLoaded = function () {
    if (this.props.onCompleted) {
      this.props.onCompleted({
        conversation: this.conversation
      });
    }

    this.setState({
      loading: false
    });
  };

  FirebaseConversationQuery.prototype.handleConversationChanged = function () {
    this.forceUpdate();
  };

  FirebaseConversationQuery.prototype.render = function () {
    /**
     * `this.state.loading` only tracks whether the `query` is in flight. We also need to consider:
     *    - Whether the client itself is loading or unauthenticated
     *    - Whether the conversation is initialized
     */
    var conversationIsLoading = this.conversation && !this.conversation.initialized;
    var firebaseClientIsAuthed = this.props.firebaseChatClient && this.props.authenticatedUserId;
    var loading = this.state.loading || conversationIsLoading || !firebaseClientIsAuthed;
    return this.props.children({
      loading: loading,
      conversation: this.conversation
    });
  };

  return FirebaseConversationQuery;
}(Component);

var FirebaseConversationQuery$1 = withChat(FirebaseConversationQuery);

var ComposerContainer =
/** @class */
function (_super) {
  __extends(ComposerContainer, _super);

  function ComposerContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.messageQueue = [];
    _this.state = {
      text: '',
      attachments: [],
      collapsed: false
    };
    _this.sendMessage = _this.sendMessage.bind(_this);
    _this.sendMessages = _this.sendMessages.bind(_this);
    _this.handleAttach = _this.handleAttach.bind(_this);
    _this.handleDetach = _this.handleDetach.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleExpand = _this.handleExpand.bind(_this);
    _this.setComposerRef = _this.setComposerRef.bind(_this);
    _this.handleFocusRequested = _this.handleFocusRequested.bind(_this);
    _this.handleAppendText = _this.handleAppendText.bind(_this);
    _this.handleConversationLoaded = _this.handleConversationLoaded.bind(_this);
    _this.startTyping = _this.startTyping.bind(_this);
    _this.throttledStartTyping = throttle(_this.startTyping, 1000);
    return _this;
  }

  ComposerContainer.prototype.componentDidMount = function () {
    if (this.props.firebaseChatClient && this.props.conversationId) {
      this.restoreDraft(this.props.conversationId);
      this.forceUpdate(); // TODO: Move conversation to state?
    }
  };

  ComposerContainer.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.firebaseChatClient && (this.props.conversationId !== prevProps.conversationId || this.props.authenticatedUserId !== prevProps.authenticatedUserId)) {
      // Store the draft associated with this conversation
      if (prevProps.conversationId) {
        this.saveDraft(prevProps.conversationId);
      } // Empty the composer


      this.setState({
        text: ''
      }); // Restore draft associated with the incoming conversation

      if (this.props.conversationId) {
        this.restoreDraft(this.props.conversationId);
      }
    }
  };

  ComposerContainer.prototype.componentWillUnmount = function () {
    if (this.props.conversationId) {
      this.saveDraft(this.props.conversationId);
    }
  };

  ComposerContainer.prototype.saveDraft = function (conversationId) {
    if (window.sessionStorage) {
      var key = "draft-" + conversationId;

      if (this.state.text !== '' || window.sessionStorage.getItem(key) !== '') {
        window.sessionStorage.setItem(key, this.state.text);
      }
    }
  };

  ComposerContainer.prototype.restoreDraft = function (conversationId) {
    if (window.sessionStorage) {
      var key = "draft-" + conversationId;
      var draft = window.sessionStorage.getItem(key);

      if (draft) {
        this.setState({
          text: draft
        });
      }
    }
  };

  ComposerContainer.prototype.handleAttach = function (attachment) {
    this.setState(function (prevState) {
      var attachments = prevState.attachments;
      attachments.push(attachment);
      return __assign({}, prevState, {
        attachments: attachments
      });
    });
  };

  ComposerContainer.prototype.handleAppendText = function (text) {
    this.setState(function (prevState) {
      var newText = prevState.text ? prevState.text + ' ' + text : text;
      return __assign({}, prevState, {
        text: newText
      });
    });
  };

  ComposerContainer.prototype.handleDetach = function (index) {
    this.setState(function (prevState) {
      var attachments = prevState.attachments.filter(function (_a, i) {
        return i !== index;
      });
      return __assign({}, prevState, {
        attachments: attachments
      });
    });
  };

  ComposerContainer.prototype.handleChange = function (event, conversation) {
    this.setState({
      text: event.target.value,
      collapsed: true
    });

    if (conversation) {
      this.throttledStartTyping(conversation);
    }
  };

  ComposerContainer.prototype.startTyping = function (conversation) {
    conversation.startTyping();
  };
  /**
   * Send a ComposerMessage.
   *
   * One ComposerMessage may result in multiple FirebaseMessages, if it has attachments.
   */


  ComposerContainer.prototype.sendMessage = function (message, conversation) {
    var _this = this;

    var firebaseMessages = [];
    var promisedMessageAttachments = message.attachments.map(function (attachment) {
      return attachment.toMessage(attachment.data, conversation);
    }); // Label each message with some metadata
    // TODO: This fn can be purely functional, and accept `metadata` as an argument

    var metadata = this.props.source ? {
      source: this.props.source
    } : {}; // Convert each attachment into a FirebaseMessage

    return Promise.all(promisedMessageAttachments).then(function (messageAttachments) {
      firebaseMessages.push.apply(firebaseMessages, messageAttachments); // If the message has a text portion, convert it to a FirebaseMessage. It will be sent last.

      if (message.text && message.text.length) {
        var textMessage = conversation.createDraftMessage();
        textMessage.addDraftPart('TEXT', {
          text: message.text
        });
        firebaseMessages.push(textMessage);
      } // Add metadata to each message


      firebaseMessages.forEach(function (message) {
        return message.metadata = metadata;
      }); // Send

      firebaseMessages.forEach(function (message) {
        return conversation.sendMessage(message);
      }); // Fire send message callback if passed in

      if (_this.props.onSendMessage) {
        _this.props.onSendMessage();
      }
    });
  };
  /**
   * Send all the queued ComposerMessages.
   */


  ComposerContainer.prototype.sendMessages = function (conversation) {
    var _this = this;

    if (!this.messageQueue) {
      return;
    } // Send each queued message sequentially


    promiseSerial(this.messageQueue.map(function (message) {
      return function () {
        return _this.sendMessage(message, conversation);
      };
    })); // Empty the queue

    this.messageQueue = [];
  };
  /**
   * Queue messages for sending
   */


  ComposerContainer.prototype.handleSubmit = function (event, conversation) {
    event.preventDefault(); // Stop the typing indicator

    this.throttledStartTyping.cancel();

    if (conversation) {
      conversation.stopTyping();
    } // Convert the current state to a ComposerMessage


    var message = {
      text: this.state.text,
      attachments: this.state.attachments
    }; // Add the message to the queue

    this.messageQueue.push(message); // If we already have a conversation, send immediately.

    if (conversation) {
      this.sendMessages(conversation);
    } else if (this.props.onConversationStarted) {
      this.props.onConversationStarted();
    } // Probably an invariant: You should pass a conversation or a callback to initate one.
    // Reset the composer state


    this.setState({
      text: '',
      attachments: []
    });
  };
  /**
   * Send all queued messages once we have a handle on a conversation to send them to.
   */


  ComposerContainer.prototype.handleConversationLoaded = function (result) {
    if (result.conversation) {
      this.sendMessages(result.conversation);
    }
  };

  ComposerContainer.prototype.handleExpand = function () {
    this.setState({
      collapsed: false
    });
  };
  /**
   * Focus compose bar text area
   */


  ComposerContainer.prototype.handleFocusRequested = function () {
    this.composerRef && this.composerRef.focus();
  };

  ComposerContainer.prototype.setComposerRef = function (textarea) {
    this.composerRef = textarea;
  };

  ComposerContainer.prototype.render = function () {
    var _this = this;

    return React__default.createElement(FirebaseConversationQuery$1, {
      conversationId: this.props.conversationId,
      onCompleted: this.handleConversationLoaded
    }, function (_b) {
      var conversation = _b.conversation,
          loading = _b.loading;
      return React__default.createElement(React__default.Fragment, null, _this.props.suggestedActions && React__default.createElement(_this.props.suggestedActions, {
        onAppendText: _this.handleAppendText,
        onFocusRequested: _this.handleFocusRequested
      }), React__default.createElement(Composer, {
        setComposerRef: _this.setComposerRef,
        conversationId: conversation ? conversation.conversationId : undefined,
        loading: loading,
        text: _this.state.text,
        attachments: _this.state.attachments,
        controls: _this.props.controls,
        onAttach: _this.handleAttach,
        onAppendText: _this.handleAppendText,
        onDetach: _this.handleDetach,
        onChange: function onChange(e) {
          return _this.handleChange(e, conversation);
        },
        onFocus: _this.props.onFocus,
        onSubmit: function onSubmit(e) {
          return _this.handleSubmit(e, conversation);
        },
        onExpand: _this.handleExpand,
        collapsed: _this.state.collapsed
      }));
    });
  };

  return ComposerContainer;
}(Component);

var Composer$1 = withChat(ComposerContainer);

var ChatContainer = function ChatContainer(_a) {
  var conversationId = _a.conversationId,
      controls = _a.controls,
      events = _a.events,
      fetchEvents = _a.fetchEvents,
      messageAction = _a.messageAction,
      source = _a.source,
      onSendMessage = _a.onSendMessage,
      children = _a.children,
      suggestedActions = _a.suggestedActions,
      showRealSender = _a.showRealSender;
  return React__default.createElement(Chat, null, React__default.createElement(Conversation$1, {
    conversationId: conversationId,
    events: events ? events : [],
    fetchEvents: fetchEvents,
    messageAction: messageAction,
    showRealSender: showRealSender
  }, children), React__default.createElement(Composer$1, {
    conversationId: conversationId,
    suggestedActions: suggestedActions,
    controls: controls,
    source: source,
    onSendMessage: onSendMessage
  }));
};

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Decline = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "12",
    viewBox: "0 0 32 12"
  }, props), React__default.createElement("path", {
    fill: "#FFF",
    d: "M16 2.667c-2.14 0-4.2.333-6.133.96v4.14c0 .526-.307.98-.747 1.2a15.468 15.468 0 0 0-3.553 2.466 1.332 1.332 0 0 1-1.874-.013l-3.3-3.3A1.33 1.33 0 0 1 0 7.173c0-.366.147-.7.393-.946A22.582 22.582 0 0 1 16 0a22.582 22.582 0 0 1 15.607 6.227c.246.24.393.58.393.946 0 .367-.147.7-.393.94l-3.3 3.3a1.33 1.33 0 0 1-1.874.014A15.468 15.468 0 0 0 22.88 8.96a1.343 1.343 0 0 1-.747-1.2V3.62A20.047 20.047 0 0 0 16 2.667z"
  }));
});

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$4(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Pickup = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, props), React__default.createElement("path", {
    fill: "#FFF",
    d: "M6.444 13.858A26.773 26.773 0 0 0 18.16 25.564l3.911-3.92a1.784 1.784 0 0 1 1.805-.435 20.238 20.238 0 0 0 6.346 1.013c.987 0 1.778.791 1.778 1.778v6.222C32 31.21 31.209 32 30.222 32 13.53 32 0 18.471 0 1.778 0 .79.8 0 1.778 0H8c.987 0 1.778.791 1.778 1.778 0 2.213.355 4.355 1.013 6.346a1.784 1.784 0 0 1-.435 1.805l-3.912 3.929z"
  }));
});

var styles$g = {"declineButton":"styles_declineButton__1jZHv","acceptButton":"styles_acceptButton__27Skc","actions":"styles_actions__16n7A","text":"styles_text__1Xg1x"};

var VideoChatRingModal =
/** @class */
function (_super) {
  __extends(VideoChatRingModal, _super);

  function VideoChatRingModal(props) {
    var _this = _super.call(this, props) || this;

    _this.onAccept = _this.onAccept.bind(_this);
    _this.onDecline = _this.onDecline.bind(_this);
    return _this;
  }

  VideoChatRingModal.prototype.onAccept = function () {
    this.props.onAccept();
  };

  VideoChatRingModal.prototype.onDecline = function () {
    this.props.onDecline();
  };

  VideoChatRingModal.prototype.render = function () {
    return React__default.createElement(Modal, {
      isOpen: true
    }, !!this.props.ringAudioUrl && React__default.createElement("audio", {
      src: this.props.ringAudioUrl,
      loop: true,
      autoPlay: true
    }), React__default.createElement("div", {
      className: styles$g.text
    }, this.props.invitor.displayName, " is video calling you..."), React__default.createElement("div", {
      className: styles$g.actions
    }, React__default.createElement("div", {
      className: styles$g.acceptButton,
      onClick: this.onAccept
    }, React__default.createElement(Pickup, {
      className: styles$g.buttonIcon
    })), React__default.createElement("div", {
      className: styles$g.declineButton,
      onClick: this.onDecline
    }, React__default.createElement(Decline, {
      className: styles$g.buttonIcon
    }))));
  };

  return VideoChatRingModal;
}(Component);

var styles$h = {"modal":"styles_modal__t78bX","remoteVideo":"styles_remoteVideo__BUmqp","remoteVideoPanel":"styles_remoteVideoPanel__1PeVc","localVideo":"styles_localVideo__3DC-N","localVideoControl":"styles_localVideoControl__37ciR","localVideoPanel":"styles_localVideoPanel__2UZxl","declineButton":"styles_declineButton__1PDM5","mediaStreamButton":"styles_mediaStreamButton__2DcxJ","remoteVideos":"styles_remoteVideos__1L_JP","videoPanel":"styles_videoPanel__GeYQn","buttonIcon":"styles_buttonIcon__1Cmr2","actions":"styles_actions__2A9JX","blankVideo":"styles_blankVideo__2pn8b","cameraSwitchButton":"styles_cameraSwitchButton__15SS5"};

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$5(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CameraRotate = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "20",
    viewBox: "0 0 25 20"
  }, props), React__default.createElement("path", {
    fill: "#FFF",
    d: "M21 10.165V3.5A1.5 1.5 0 0 0 19.5 2h-3.079L15.914.649A1 1 0 0 0 14.978 0H9.943a1 1 0 0 0-.936.649L8.5 2h-3A1.5 1.5 0 0 0 4 3.5v6.665C1.425 11 0 12.175 0 13.5c0 2.732 5.63 4.288 11.314 4.48l-1.167 1.167a.5.5 0 1 0 .707.707l2-2a.5.5 0 0 0 0-.707l-2-2a.5.5 0 0 0-.707.707l1.125 1.125C5.16 16.773 1 15.053 1 13.5c0-.781 1.137-1.631 3-2.284V12.5A1.5 1.5 0 0 0 5.5 14h14a1.5 1.5 0 0 0 1.5-1.5v-1.284c1.863.653 3 1.503 3 2.284 0 1.397-3.643 3.111-9.528 3.441a.5.5 0 1 0 .028 1l.028-.002C19.572 17.656 25 16.146 25 13.5c0-1.325-1.425-2.5-4-3.335zM12.5 11a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7zm6-6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z"
  }));
});

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$6(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Muted = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "19",
    viewBox: "0 0 18 19"
  }, props), React__default.createElement("path", {
    fill: "#FFF",
    d: "M16 9h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V3c0-1.66-1.34-3-3-3S6 1.34 6 3v.18l5.98 5.99zM1.27 1L0 2.27l6.01 6.01V9c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H2c0 3.41 2.72 6.23 6 6.72V19h2v-3.28c.91-.13 1.77-.45 2.54-.9L16.73 19 18 17.73 1.27 1z"
  }));
});

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$7(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Unmuted = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "19",
    viewBox: "0 0 14 19"
  }, props), React__default.createElement("path", {
    fill: "#FFF",
    d: "M7 12c1.66 0 2.99-1.34 2.99-3L10 3c0-1.66-1.34-3-3-3S4 1.34 4 3v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S1.7 12 1.7 9H0c0 3.41 2.72 6.23 6 6.72V19h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
  }));
});

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$8(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CameraOn = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "12",
    viewBox: "0 0 18 12"
  }, props), React__default.createElement("path", {
    fill: "#FFF",
    d: "M14 4.5V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V7.5l4 4V.5l-4 4z"
  }));
});

var _extends$9 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$9(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CameraOff = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$9(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "19",
    viewBox: "0 0 19 19"
  }, props), React__default.createElement("path", {
    fill: "#FFF",
    d: "M19 4.5l-4 4V5c0-.55-.45-1-1-1H7.82L19 15.18V4.5zM1.27 0L0 1.27 2.73 4H2c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L17.73 19 19 17.73 1.27 0z"
  }));
});

var _extends$a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$a(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Decline$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$a(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "12",
    viewBox: "0 0 32 12"
  }, props), React__default.createElement("path", {
    fill: "#FFF",
    d: "M16 2.667c-2.14 0-4.2.333-6.133.96v4.14c0 .526-.307.98-.747 1.2a15.468 15.468 0 0 0-3.553 2.466 1.332 1.332 0 0 1-1.874-.013l-3.3-3.3A1.33 1.33 0 0 1 0 7.173c0-.366.147-.7.393-.946A22.582 22.582 0 0 1 16 0a22.582 22.582 0 0 1 15.607 6.227c.246.24.393.58.393.946 0 .367-.147.7-.393.94l-3.3 3.3a1.33 1.33 0 0 1-1.874.014A15.468 15.468 0 0 0 22.88 8.96a1.343 1.343 0 0 1-.747-1.2V3.62A20.047 20.047 0 0 0 16 2.667z"
  }));
});

var VideoChatModal =
/** @class */
function (_super) {
  __extends(VideoChatModal, _super);

  function VideoChatModal(props) {
    var _this = _super.call(this, props) || this;

    _this.localVideoDiv = null;
    _this.remoteVideoDivs = new Map();
    _this.remoteVideoCaptureCallback = new Map();
    _this.state = {
      availableCameraDeviceIds: [],
      remoteParticipants: [],
      audioEnabled: true,
      videoEnabled: true
    };

    if (_this.props.Twilio.Video.isSupported && navigator.mediaDevices && !_this.props.monitorOnly) {
      navigator.mediaDevices.enumerateDevices().then(function (devices) {
        return devices.filter(function (device) {
          return device.kind === 'videoinput';
        }).map(function (device) {
          return device.deviceId;
        });
      }).then(function (cameraDeviceIds) {
        _this.setState({
          availableCameraDeviceIds: cameraDeviceIds
        });
      });
    }

    _this.onEnd = _this.onEnd.bind(_this);
    _this.switchCamera = _this.switchCamera.bind(_this);
    _this.captureRemoteVideoReference = _this.captureRemoteVideoReference.bind(_this);
    _this.captureLocalVideoReference = _this.captureLocalVideoReference.bind(_this);
    _this.onRemoteParticipantTrackAdded = _this.onRemoteParticipantTrackAdded.bind(_this);
    _this.onRemoteParticipantTrackRemoved = _this.onRemoteParticipantTrackRemoved.bind(_this);
    _this.subscribeRemoteParticipant = _this.subscribeRemoteParticipant.bind(_this);
    _this.connectRoom = _this.connectRoom.bind(_this);
    _this.detachTrack = _this.detachTrack.bind(_this);
    _this.attachTrack = _this.attachTrack.bind(_this);
    _this.enableLocalVideo = _this.enableLocalVideo.bind(_this);
    _this.disableLocalVideo = _this.disableLocalVideo.bind(_this);
    _this.enableLocalAudio = _this.enableLocalAudio.bind(_this);
    _this.disableLocalAudio = _this.disableLocalAudio.bind(_this);
    return _this;
  }

  VideoChatModal.prototype.detachTrack = function (track) {
    if (track.detach) {
      var mediaTrack = track;
      mediaTrack.detach().forEach(function (element) {
        return element.remove();
      });
    }
  };

  VideoChatModal.prototype.attachTrack = function (track, div, className) {
    if (track.attach) {
      var element = track.attach();

      if (track.kind === 'video') {
        // Only apply classes for video tracks
        element.className = className;
      }

      div.appendChild(element);
    }
  };

  VideoChatModal.prototype.enableLocalVideo = function () {
    if (this.state.localVideoTrack) {
      this.state.localVideoTrack.enable();
      this.setState({
        videoEnabled: true
      });
    }
  };

  VideoChatModal.prototype.disableLocalVideo = function () {
    if (this.state.localVideoTrack) {
      this.state.localVideoTrack.disable();
      this.setState({
        videoEnabled: false
      });
    }
  };

  VideoChatModal.prototype.enableLocalAudio = function () {
    if (this.state.room && !this.props.monitorOnly) {
      this.state.room.localParticipant.audioTracks.forEach(function (track) {
        return track.enable();
      });
      this.setState({
        audioEnabled: true
      });
    }
  };

  VideoChatModal.prototype.disableLocalAudio = function () {
    if (this.state.room && !this.props.monitorOnly) {
      this.state.room.localParticipant.audioTracks.forEach(function (track) {
        return track.disable();
      });
      this.setState({
        audioEnabled: false
      });
    }
  };

  VideoChatModal.prototype.onRemoteParticipantTrackAdded = function (sid, track) {
    var div = this.remoteVideoDivs.get(sid);

    if (div) {
      this.attachTrack(track, div, styles$h.remoteVideo);
    }
  };

  VideoChatModal.prototype.onRemoteParticipantTrackRemoved = function (sid, track) {
    if (this.remoteVideoDivs.has(sid)) {
      this.detachTrack(track);
    }
  };

  VideoChatModal.prototype.subscribeRemoteParticipant = function (participant) {
    participant.on('trackAdded', this.onRemoteParticipantTrackAdded.bind(this, participant.sid));
    participant.on('trackRemoved', this.onRemoteParticipantTrackRemoved.bind(this, participant.sid));
  };

  VideoChatModal.prototype.componentWillMount = function () {
    this.connectRoom(this.props);
  };

  VideoChatModal.prototype.connectRoom = function (props) {
    var _this = this;

    this.setState({
      room: undefined,
      localVideoTrack: undefined
    });

    if (!props.monitorOnly) {
      if (!this.currentCameraDeviceId) {
        this.props.Twilio.Video.createLocalVideoTrack({
          facingMode: {
            ideal: 'user'
          }
        }).then(function (newVideoTrack) {
          _this.currentCameraDeviceId = newVideoTrack.mediaStreamTrack.getSettings().deviceId;

          _this.setState({
            localVideoTrack: newVideoTrack
          });
        });
      } else {
        this.props.Twilio.Video.createLocalVideoTrack({
          deviceId: {
            exact: this.currentCameraDeviceId
          }
        }).then(function (newVideoTrack) {
          _this.currentCameraDeviceId = newVideoTrack.mediaStreamTrack.getSettings().deviceId;

          _this.setState({
            localVideoTrack: newVideoTrack
          });
        });
      }
    }

    this.props.Twilio.Video.connect(props.token, {
      name: props.roomName,
      audio: !props.monitorOnly,
      video: false
    }).then(function (room) {
      var remoteParticipants = [];
      room.participants.forEach(function (participant) {
        // Skip all monitoring remote participants
        if (!participant.identity.startsWith('monitor-')) {
          remoteParticipants.push(participant);

          _this.subscribeRemoteParticipant(participant);
        }
      });
      room.on('participantConnected', function (participant) {
        // Skip all monitoring remote participants
        if (!participant.identity.startsWith('monitor-')) {
          _this.setState({
            remoteParticipants: remoteParticipants.concat([participant])
          });

          _this.subscribeRemoteParticipant(participant);
        }
      });
      room.on('participantDisconnected', function (participant) {
        // Skip all monitoring remote participants
        if (!participant.identity.startsWith('monitor-')) {
          participant.tracks.forEach(function (track) {
            _this.detachTrack(track);
          });

          _this.setState({
            remoteParticipants: _this.state.remoteParticipants.filter(function (value) {
              return value.sid !== participant.sid;
            })
          });

          _this.remoteVideoDivs.delete(participant.sid);
        }
      });

      _this.setState({
        room: room,
        remoteParticipants: remoteParticipants
      });
    }).catch(function (error) {
      return _this.props.onError && _this.props.onError(error);
    });
  };

  VideoChatModal.prototype.componentWillReceiveProps = function (nextProps) {
    if (nextProps.roomName !== this.props.roomName || nextProps.token !== this.props.token) {
      // room or token changed, need to reconnect
      this.connectRoom(nextProps);
    }
  };

  VideoChatModal.prototype.componentWillUpdate = function (_nextProps, nextState) {
    if (this.state.localVideoTrack !== nextState.localVideoTrack) {
      if (this.state.localVideoTrack) {
        // Detach the local video track and unpublish
        this.detachTrack(this.state.localVideoTrack);
        this.state.localVideoTrack.mediaStreamTrack.stop();

        if (this.state.room) {
          this.state.room.localParticipant.unpublishTrack(this.state.localVideoTrack);
        }
      }

      if (nextState.localVideoTrack) {
        // Attach and publish for the next video track
        if (this.localVideoDiv) {
          this.attachTrack(nextState.localVideoTrack, this.localVideoDiv, styles$h.localVideo);
        }

        if (nextState.room) {
          nextState.room.localParticipant.publishTrack(nextState.localVideoTrack);
        }
      }
    }

    if (this.state.room !== nextState.room) {
      if (this.state.room) {
        // Need to disconnect room
        this.state.room.disconnect();
      }

      if (nextState.room && this.state.localVideoTrack === nextState.localVideoTrack && nextState.localVideoTrack) {
        // When the local video track are not the same, it is already handled in the above condition
        nextState.room.localParticipant.publishTrack(nextState.localVideoTrack);
      }
    }
  };

  VideoChatModal.prototype.captureRemoteVideoReference = function (sid, ref) {
    var _this = this;

    if ((this.remoteVideoDivs.has(sid) || ref) && this.remoteVideoDivs.get(sid) !== ref) {
      // Need to detach the old one
      var remoteParticipant = this.state.remoteParticipants.find(function (participant) {
        return participant.sid === sid;
      });

      if (this.remoteVideoDivs.has(sid) && remoteParticipant) {
        remoteParticipant.tracks.forEach(this.detachTrack);
      }

      if (ref) {
        // New div, not the same as old, need to reattach if tracks available
        if (remoteParticipant) {
          remoteParticipant.tracks.forEach(function (track) {
            return _this.attachTrack(track, ref, styles$h.remoteVideo);
          });
        }

        this.remoteVideoDivs.set(sid, ref);
      } else {
        this.remoteVideoCaptureCallback.delete(sid);
        this.remoteVideoDivs.delete(sid);
      }
    }
  };

  VideoChatModal.prototype.captureLocalVideoReference = function (ref) {
    if (this.localVideoDiv !== ref) {
      if (this.state.localVideoTrack) {
        if (this.localVideoDiv) {
          // Need to detach from the old div if it is there
          this.detachTrack(this.state.localVideoTrack);
        }

        if (ref) {
          // Need to attach to the new div if it is there
          this.attachTrack(this.state.localVideoTrack, ref, styles$h.localVideo);
        }
      }

      this.localVideoDiv = ref;
    }
  };

  VideoChatModal.prototype.switchCamera = function () {
    var _this = this;

    if (this.state.availableCameraDeviceIds.length > 1) {
      // Get the next camera device ID, wrap around
      this.currentCameraDeviceId = this.state.availableCameraDeviceIds[(this.state.availableCameraDeviceIds.indexOf(this.currentCameraDeviceId || '') + 1) % this.state.availableCameraDeviceIds.length]; // Create the local video track

      this.props.Twilio.Video.createLocalVideoTrack({
        deviceId: {
          exact: this.currentCameraDeviceId
        }
      }).then(function (newVideoTrack) {
        _this.setState({
          localVideoTrack: newVideoTrack
        });
      });
    }
  };

  VideoChatModal.prototype.componentWillUnmount = function () {
    if (this.state.room) {
      this.state.room.localParticipant.tracks.forEach(function (track) {
        if (track.stop) {
          var mediaTrack = track;
          mediaTrack.stop();
        }
      });
      this.state.room.disconnect();
    }
  };

  VideoChatModal.prototype.onEnd = function () {
    this.setState({
      room: undefined,
      localVideoTrack: undefined
    });
    this.props.onLeaveVideoChat();
  };

  VideoChatModal.prototype.getRemoteVideoReferenceCallback = function (sid) {
    var callback = this.remoteVideoCaptureCallback.get(sid);

    if (!callback) {
      callback = this.captureRemoteVideoReference.bind(this, sid);
      this.remoteVideoCaptureCallback.set(sid, callback);
    }

    return callback;
  };

  VideoChatModal.prototype.render = function () {
    var _this = this;

    var remoteParticipants = this.state.remoteParticipants;
    return React__default.createElement(Modal, {
      isOpen: true,
      className: styles$h.modal
    }, React__default.createElement("div", {
      className: styles$h.videoPanel
    }, React__default.createElement("div", {
      className: styles$h.remoteVideos
    }, remoteParticipants.map(function (participant) {
      return React__default.createElement("div", {
        className: styles$h.remoteVideoPanel,
        key: participant.sid,
        ref: _this.getRemoteVideoReferenceCallback(participant.sid)
      });
    }), remoteParticipants.length === 0 && React__default.createElement("div", {
      className: styles$h.blankVideo
    })), React__default.createElement("div", {
      className: styles$h.actions
    }, React__default.createElement("div", {
      className: styles$h.declineButton,
      onClick: this.onEnd
    }, React__default.createElement(Decline$1, {
      className: styles$h.buttonIcon
    })), this.state.localVideoTrack && React__default.createElement("div", {
      className: styles$h.mediaStreamButton,
      onClick: this.state.videoEnabled ? this.disableLocalVideo : this.enableLocalVideo
    }, this.state.videoEnabled && React__default.createElement(CameraOn, {
      className: styles$h.buttonIcon
    }), !this.state.videoEnabled && React__default.createElement(CameraOff, {
      className: styles$h.buttonIcon
    })), this.state.room && !this.props.monitorOnly && React__default.createElement("div", {
      className: styles$h.mediaStreamButton,
      onClick: this.state.audioEnabled ? this.disableLocalAudio : this.enableLocalAudio
    }, this.state.audioEnabled && React__default.createElement(Unmuted, {
      className: styles$h.buttonIcon
    }), !this.state.audioEnabled && React__default.createElement(Muted, {
      className: styles$h.buttonIcon
    }))), React__default.createElement("div", {
      className: styles$h.localVideoControl,
      onClick: this.switchCamera
    }, React__default.createElement("div", {
      className: styles$h.localVideoPanel,
      ref: this.captureLocalVideoReference
    }, this.state.room && this.state.availableCameraDeviceIds && this.state.availableCameraDeviceIds.length > 1 && React__default.createElement(CameraRotate, {
      className: styles$h.cameraSwitchButton
    })))));
  };

  return VideoChatModal;
}(Component);

var VideoChatModal$1 = makeAsyncScriptLoader(VideoChatModal, 'https://media.twiliocdn.com/sdk/js/video/releases/1.11.1/twilio-video.min.js', {
  globalName: 'Twilio'
});

var _extends$b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$b(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CallActiveIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$b(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: "17",
    height: "16",
    viewBox: "0 0 17 16"
  }, props), React__default.createElement("g", {
    fill: "#00A056"
  }, React__default.createElement("path", {
    d: "M10 11.293l1.646-1.647a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-2 2A.5.5 0 0 1 13 15.5C6.097 15.5.5 9.903.5 3a.5.5 0 0 1 .146-.354l2-2a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708L4.707 6 10 11.293zm.354 1.06a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.707L5.293 4 3 1.707 1.502 3.205C1.61 9.393 6.607 14.39 12.795 14.498L14.293 13 12 10.707l-1.646 1.647zM9 4.5a.5.5 0 0 1 0-1A4.5 4.5 0 0 1 13.5 8a.5.5 0 1 1-1 0A3.5 3.5 0 0 0 9 4.5z"
  }), React__default.createElement("path", {
    d: "M9 1.5a.5.5 0 0 1 0-1A7.5 7.5 0 0 1 16.5 8a.5.5 0 1 1-1 0A6.5 6.5 0 0 0 9 1.5z"
  })));
});

var _extends$c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$c(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CallFailedIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$c(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React__default.createElement("g", {
    fill: "#F44240"
  }, React__default.createElement("path", {
    d: "M5.01 6.031l2.329 2.15a.5.5 0 0 1-.678.734L3.933 6.4a.5.5 0 0 1 0-.735L5.716 4.02 3.181 1.68 1.502 3.23C1.558 6 2.676 8.607 4.633 10.653a.5.5 0 0 1-.722.692C1.728 9.063.5 6.126.5 3.012a.5.5 0 0 1 .161-.367L2.842.633a.5.5 0 0 1 .678 0L6.793 3.65a.5.5 0 0 1 0 .735L5.01 6.031zm6.737 3.622a.5.5 0 0 1 .72 0l2.893 3a.5.5 0 0 1 0 .694l-1.929 2a.5.5 0 0 1-.36.153 11.76 11.76 0 0 1-7.384-2.61.5.5 0 1 1 .626-.78 10.766 10.766 0 0 0 6.548 2.388L14.305 13l-2.198-2.28-1.569 1.627a.5.5 0 0 1-.72 0l-1.928-2a.5.5 0 1 1 .72-.694l1.568 1.627 1.57-1.627z"
  }), React__default.createElement("path", {
    d: "M13.646.646a.5.5 0 0 1 .708.708l-13 13a.5.5 0 0 1-.708-.708l13-13z"
  })));
});

var styles$i = {"video-call":"styles_video-call__m4FMD p2","status":"styles_status__1dAYb flex items-center overflow-hidden","icon":"styles_icon__3iMZA mr1","cta":"styles_cta__wVFey mt2","videoCall":"styles_video-call__m4FMD p2"};

var InvitationState;

(function (InvitationState) {
  InvitationState[InvitationState["Self"] = 1] = "Self";
  InvitationState[InvitationState["Ended"] = 2] = "Ended";
  InvitationState[InvitationState["Declined"] = 3] = "Declined";
  InvitationState[InvitationState["Joined"] = 4] = "Joined";
  InvitationState[InvitationState["Pending"] = 5] = "Pending";
  InvitationState[InvitationState["Nosupport"] = 6] = "Nosupport";
})(InvitationState || (InvitationState = {}));

var MessageNewVideoChat =
/** @class */
function (_super) {
  __extends(MessageNewVideoChat, _super);

  function MessageNewVideoChat(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    _this.joinVideoChat = _this.joinVideoChat.bind(_this);
    _this.leaveVideoChat = _this.leaveVideoChat.bind(_this);
    _this.declineVideoChat = _this.declineVideoChat.bind(_this);
    _this.updateInvitationState = _this.updateInvitationState.bind(_this);
    _this.handleError = _this.handleError.bind(_this);
    _this.conversation = props.message.conversation;
    return _this;
  }

  MessageNewVideoChat.prototype.componentDidMount = function () {
    this.conversation.on('conversations:change', this.handleConversationChange, this);
    this.updateInvitationState(this.props);
  };

  MessageNewVideoChat.prototype.componentWillUnmount = function () {
    // @ts-ignore
    this.conversation.off(null, null, this);
  };

  MessageNewVideoChat.prototype.componentWillReceiveProps = function (nextProps) {
    this.updateInvitationState(nextProps);
  };

  MessageNewVideoChat.prototype.handleError = function (error) {
    this.props.onError(error);
    this.setState({
      videoChatToken: undefined
    });
  };

  MessageNewVideoChat.prototype.joinVideoChat = function () {
    var _this = this;

    this.props.joinVideoChat(this.conversation.conversationId, this.props.myself.userId).then(function (token) {
      _this.setState({
        invitationState: _this.props.message.sentBy.isMyself ? InvitationState.Self : InvitationState.Joined,
        videoChatToken: token
      });
    });
  };

  MessageNewVideoChat.prototype.leaveVideoChat = function () {
    this.setState({
      videoChatToken: undefined
    });
  };

  MessageNewVideoChat.prototype.declineVideoChat = function () {
    var _this = this;

    this.props.declineVideoChat(this.conversation.conversationId, this.props.myself.userId).then(function (_success) {
      _this.setState({
        invitationState: InvitationState.Declined
      });
    }) // user should be able to terminate even when error happend
    .catch(function () {
      return _this.setState({
        invitationState: InvitationState.Declined
      });
    });
  };

  MessageNewVideoChat.prototype.updateInvitationState = function (props) {
    var message = props.message;
    var messagingUserId = this.props.myself.userId;
    var videoChat = this.conversation.metadata.videoChat;
    var invitationState = InvitationState.Pending;

    if (!videoChat || videoChat.invitationId !== props.invitationId) {
      invitationState = InvitationState.Ended;
    } else if (message.sentBy.isMyself) {
      invitationState = InvitationState.Self;
    } else if (videoChat.participants[messagingUserId] && videoChat.answered && videoChat.answered[messagingUserId]) {
      invitationState = InvitationState.Joined;
    } else if (!videoChat.participants[messagingUserId] && videoChat.answered && !!videoChat.answered[messagingUserId]) {
      invitationState = InvitationState.Declined;
    } else if (!this.props.Twilio || !this.props.Twilio.Video.isSupported) {
      invitationState = InvitationState.Nosupport;
    }

    this.setState({
      invitationState: invitationState
    });
  };

  MessageNewVideoChat.prototype.handleConversationChange = function (evt) {
    // video chat metadata changed
    this.updateInvitationState(this.props);
    var videoChatMetadata = evt.conversation.metadata.videoChat;

    if (videoChatMetadata && Object.keys(videoChatMetadata.participants).length <= 1) {
      // Looks like all other participants declined, so ending this video chat
      this.leaveVideoChat();
    }
  };

  MessageNewVideoChat.prototype.getBody = function () {
    var senderName = this.props.message.sentBy.displayName;

    switch (this.state.invitationState) {
      case InvitationState.Ended:
        return React__default.createElement(React__default.Fragment, null, React__default.createElement(CallFailedIcon, {
          className: styles$i.icon
        }), " Video chat ended");

      case InvitationState.Self:
        return React__default.createElement(React__default.Fragment, null, React__default.createElement(CallActiveIcon, {
          className: styles$i.icon
        }), " Video chat invitation sent");

      case InvitationState.Joined:
        return React__default.createElement(React__default.Fragment, null, React__default.createElement(CallActiveIcon, {
          className: styles$i.icon
        }), " You're connected with ", senderName);

      case InvitationState.Declined:
        return React__default.createElement(React__default.Fragment, null, React__default.createElement(CallFailedIcon, {
          className: styles$i.icon
        }), " Video chat invitation from ", senderName, " was declined");

      case InvitationState.Pending:
        return React__default.createElement(React__default.Fragment, null, React__default.createElement(CallActiveIcon, {
          className: styles$i.icon
        }), " You've got a call from ", senderName);

      case InvitationState.Nosupport:
        return React__default.createElement(React__default.Fragment, null, React__default.createElement(CallFailedIcon, {
          className: styles$i.icon
        }), " ", senderName, " is inviting you to a video chat, but your browser is not supported. Please update to the latest Chrome, Firefox, or iOS 11.");

      default:
        return null;
    }
  };

  MessageNewVideoChat.prototype.getActions = function () {
    switch (this.state.invitationState) {
      case InvitationState.Self:
      case InvitationState.Joined:
        return React__default.createElement(Button, {
          size: "medium",
          variant: "black-outline",
          className: styles$i.cta,
          onClick: this.joinVideoChat
        }, "Re-join");

      case InvitationState.Pending:
        return React__default.createElement(VideoChatRingModal, {
          ringAudioUrl: this.props.ringAudioUrl,
          invitor: this.props.message.sentBy,
          onAccept: this.joinVideoChat,
          onDecline: this.declineVideoChat
        });

      default:
        return null;
    }
  };

  MessageNewVideoChat.prototype.render = function () {
    var message = this.props.message;

    if (!this.state.invitationState) {
      return null;
    }

    var videoChatMetadata = this.conversation.metadata.videoChat; // if the current user is not a participant, don't show any video modal.
    // Just display the message to indicate there was a video call.
    // this can happen when an expert is viewing a team inbox

    var isParticipant = videoChatMetadata && videoChatMetadata.participants[this.props.myself.userId];

    if (!isParticipant) {
      return React__default.createElement(MessageBubble, {
        className: styles$i.videoCall,
        message: message
      }, React__default.createElement("div", {
        className: styles$i.status
      }, React__default.createElement(CallFailedIcon, {
        className: styles$i.icon
      }), " Video chat ended"));
    }

    var actions = this.getActions();
    return React__default.createElement(React__default.Fragment, null, this.state.videoChatToken && React__default.createElement(VideoChatModal$1, {
      token: this.state.videoChatToken,
      onLeaveVideoChat: this.leaveVideoChat,
      onError: this.handleError,
      monitorOnly: false,
      roomName: this.conversation.conversationId
    }), React__default.createElement(MessageBubble, {
      className: styles$i.videoCall,
      message: message
    }, React__default.createElement("div", {
      className: styles$i.status
    }, this.getBody()), actions && React__default.createElement("div", {
      className: styles$i.action
    }, actions)));
  };

  return MessageNewVideoChat;
}(Component);

var MessageNewVideoChat$1 = makeAsyncScriptLoader(MessageNewVideoChat, 'https://media.twiliocdn.com/sdk/js/video/releases/1.11.1/twilio-video.min.js', {
  globalName: 'Twilio'
});

var MessageNewVideoChatContainer =
/** @class */
function (_super) {
  __extends(MessageNewVideoChatContainer, _super);

  function MessageNewVideoChatContainer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageNewVideoChatContainer.handlesMessage = function (message) {
    return message.parts.length === 1 && message.parts[0].type === MessageNewVideoChatContainer.type;
  };

  MessageNewVideoChatContainer.prototype.render = function () {
    var message = this.props.message;
    var invitationId = message.parts[0].body.invitationId;
    return React__default.createElement(MessageNewVideoChat$1, __assign({}, this.props, {
      invitationId: invitationId
    }));
  };

  MessageNewVideoChatContainer.type = 'NEW_VIDEO_CHAT';
  return MessageNewVideoChatContainer;
}(Component);

var ChatNotifier =
/** @class */
function (_super) {
  __extends(ChatNotifier, _super);

  function ChatNotifier() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ChatNotifier.prototype.componentDidMount = function () {
    if (this.props.firebaseChatClient) {
      this.props.firebaseChatClient.on('newMessage', this.props.onNewMessage);
    }
  };

  ChatNotifier.prototype.componentWillUnmount = function () {
    if (this.props.firebaseChatClient) {
      this.props.firebaseChatClient.off('newMessage', this.props.onNewMessage);
    }
  };

  ChatNotifier.prototype.componentDidUpdate = function (prevProps) {
    // Client now available
    if (this.props.firebaseChatClient && !prevProps.firebaseChatClient) {
      this.props.firebaseChatClient.on('newMessage', this.props.onNewMessage);
    } // Client no longer available


    if (!this.props.firebaseChatClient && prevProps.firebaseChatClient) {
      prevProps.firebaseChatClient.off('newMessage', prevProps.onNewMessage);
    } // Callback updated


    if (this.props.firebaseChatClient && this.props.onNewMessage !== prevProps.onNewMessage) {
      this.props.firebaseChatClient.off('newMessage', prevProps.onNewMessage);
      this.props.firebaseChatClient.on('newMessage', this.props.onNewMessage);
    }
  };

  ChatNotifier.prototype.render = function () {
    return null;
  };

  return ChatNotifier;
}(React__default.PureComponent);

var index = withChat(ChatNotifier);

var FirebaseUserQuery =
/** @class */
function (_super) {
  __extends(FirebaseUserQuery, _super);

  function FirebaseUserQuery(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      loading: true
    };
    _this.load = _this.load.bind(_this);
    _this.cancel = _this.cancel.bind(_this);
    return _this;
  }

  FirebaseUserQuery.prototype.componentDidMount = function () {
    if (this.props.firebaseChatClient) {
      this.load(this.props.userIds, this.props.firebaseChatClient);
    }
  };

  FirebaseUserQuery.prototype.componentDidUpdate = function (prevProps) {
    // Firebase client no longer available
    if (!this.props.firebaseChatClient) {
      this.cancel();
    } // Conversation or authenticated user has changed


    if (this.props.firebaseChatClient && (!isEqual(prevProps.userIds.sort(), this.props.userIds.sort()) || prevProps.authenticatedUserId !== this.props.authenticatedUserId)) {
      this.cancel();
      this.load(this.props.userIds, this.props.firebaseChatClient);
    }
  };

  FirebaseUserQuery.prototype.componentWillUnmount = function () {
    this.cancel();
  };

  FirebaseUserQuery.prototype.load = function (userIds, client) {
    var _this = this;

    this.setState({
      users: undefined,
      loading: true
    });
    client.getUsers(userIds).then(function (users) {
      _this.setState({
        loading: false,
        users: users
      });
    });
  };
  /**
   * TODO: Implement cancellation
   *
   * Without it, the getUsers callback might call setState on an unmounted component
   */


  FirebaseUserQuery.prototype.cancel = function () {};

  FirebaseUserQuery.prototype.render = function () {
    /**
     * `this.state.loading` only tracks whether the `getUsers` call is unfinished.
     *   We also need to consider the loading/auth state of the Firebase client itself.
     */
    var loading = this.state.loading || !this.props.firebaseChatClient || !this.props.authenticatedUserId;
    return this.props.children({
      loading: loading,
      users: this.state.users
    });
  };

  return FirebaseUserQuery;
}(Component);

var FirebaseUserQuery$1 = withChat(FirebaseUserQuery);

var _extends$d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$d(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var StarIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$d(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M0 0h12v12H0z"
  }), React__default.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 .555l1.298 4.147h4.327L8.187 7.285l1.352 4.16L6 8.874l-3.538 2.571 1.351-4.16L.375 4.702h4.327z"
  })));
});

var styles$j = {"header":"styles_header__ARh_v flex items-center","avatar-and-presence":"styles_avatar-and-presence__2zPMc relative","presence-badge":"styles_presence-badge__1tEoj","rating":"styles_rating__1dlw9 bold flex items-center","stars-rating":"styles_stars-rating__1P_ri styles_rating__1dlw9 bold flex items-center","number-rating":"styles_number-rating__2UraC styles_rating__1dlw9 bold flex items-center","stars":"styles_stars__1jfOV relative","combined-rating":"styles_combined-rating__1qlE_ styles_rating__1dlw9 bold flex items-center","avatar":"styles_avatar__2kpWM","star":"styles_star__3cpVe","labels":"styles_labels__fsH4C flex flex-auto flex-column","title":"styles_title__3UYB5 bold mr1","presence":"styles_presence__3NG6R flex items-center","presence-online":"styles_presence-online__1CspA styles_presence-badge__1tEoj","presence-offline":"styles_presence-offline__1aXiq styles_presence-badge__1tEoj","presence-text":"styles_presence-text__1KdXl","cta":"styles_cta__3_rxx flex items-center","cta-icon":"styles_cta-icon__6UPLa mr1","cta-text":"styles_cta-text__1nh3E","minimized":"styles_minimized__3eiDf","avatarAndPresence":"styles_avatar-and-presence__2zPMc relative","presenceBadge":"styles_presence-badge__1tEoj","starsRating":"styles_stars-rating__1P_ri styles_rating__1dlw9 bold flex items-center","numberRating":"styles_number-rating__2UraC styles_rating__1dlw9 bold flex items-center","combinedRating":"styles_combined-rating__1qlE_ styles_rating__1dlw9 bold flex items-center","presenceOnline":"styles_presence-online__1CspA styles_presence-badge__1tEoj","presenceOffline":"styles_presence-offline__1aXiq styles_presence-badge__1tEoj","presenceText":"styles_presence-text__1KdXl","ctaIcon":"styles_cta-icon__6UPLa mr1","ctaText":"styles_cta-text__1nh3E"};

var ChatHeader =
/** @class */
function (_super) {
  __extends(ChatHeader, _super);

  function ChatHeader(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    _this.tick = _this.tick.bind(_this);
    return _this;
  }

  ChatHeader.prototype.componentDidMount = function () {
    this.timer = setInterval(this.tick, 2000);
  };

  ChatHeader.prototype.componentWillUnmount = function () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  };

  ChatHeader.prototype.tick = function () {
    this.setState(function (prevState) {
      return {
        alertNewMessage: !prevState.alertNewMessage
      };
    });
  };

  ChatHeader.prototype.render = function () {
    var _a;

    var _b = this.props,
        recipients = _b.recipients,
        unread = _b.unread,
        className = _b.className,
        minimized = _b.minimized,
        online = _b.online,
        ctaIcon = _b.ctaIcon,
        ctaText = _b.ctaText,
        onCtaClick = _b.onCtaClick,
        rating = _b.rating,
        rest = __rest(_b, ["recipients", "unread", "className", "minimized", "online", "ctaIcon", "ctaText", "onCtaClick", "rating"]);

    var CtaIcon = this.props.ctaIcon; // "Tom", "Dick" and "Harry"

    var recipientNames = recipients.map(function (recipient) {
      return recipient.displayName;
    });
    var recipientsLabel = [recipientNames.slice(0, -1).join(', '), recipientNames.slice(-1)[0]].join(recipientNames.length < 2 ? '' : ' and ');
    var primaryRecipient = recipients[0];
    return React__default.createElement("div", __assign({
      className: classnames(styles$j.header, className, (_a = {}, _a[styles$j.minimized] = minimized, _a))
    }, rest), React__default.createElement("div", {
      className: styles$j.avatarAndPresence
    }, React__default.createElement(FirebaseAvatar, {
      sender: primaryRecipient,
      size: 48,
      className: styles$j.avatar
    }), rating !== 'none' && online && React__default.createElement("span", {
      className: styles$j.presenceBadge
    })), React__default.createElement("div", {
      className: styles$j.labels
    }, React__default.createElement("div", {
      className: styles$j.title
    }, unread && this.state.alertNewMessage ? 'New message' : recipientsLabel), rating === 'none' && online && React__default.createElement("div", {
      className: styles$j.presence
    }, React__default.createElement("span", {
      className: styles$j.presenceBadge
    }), React__default.createElement("span", {
      className: styles$j.presenceText
    }, "Online")), rating === 'stars' && primaryRecipient && primaryRecipient.expertRating !== undefined && React__default.createElement("div", {
      className: styles$j.starsRating
    }, React__default.createElement("div", {
      className: styles$j.stars
    }, times(Math.round(primaryRecipient.expertRating)).map(function (i) {
      return React__default.createElement(StarIcon, {
        className: styles$j.star,
        key: i
      });
    }))), rating === 'number' && primaryRecipient && primaryRecipient.expertRating !== undefined && React__default.createElement("div", {
      className: styles$j.numberRating
    }, primaryRecipient.expertRating.toFixed(1), React__default.createElement("div", {
      className: styles$j.stars
    }, React__default.createElement(StarIcon, {
      className: styles$j.star
    }))), rating === 'combined' && primaryRecipient && primaryRecipient.expertRating !== undefined && React__default.createElement("div", {
      className: styles$j.combinedRating
    }, primaryRecipient.expertRating.toFixed(1), React__default.createElement("div", {
      className: styles$j.stars
    }, times(Math.round(primaryRecipient.expertRating)).map(function (i) {
      return React__default.createElement(StarIcon, {
        className: styles$j.star,
        key: i
      });
    })))), (ctaIcon || ctaText) && React__default.createElement("div", {
      className: styles$j.cta,
      onClick: function onClick(e) {
        e.stopPropagation();
        onCtaClick && onCtaClick(e);
      }
    }, CtaIcon && React__default.createElement(CtaIcon, {
      className: styles$j.ctaIcon
    }), ctaText && React__default.createElement("span", {
      className: styles$j.ctaText
    }, ctaText)));
  };

  return ChatHeader;
}(React__default.Component);

var useMedia = function useMedia(query, defaultMatches) {
  if (defaultMatches === void 0) {
    defaultMatches = true;
  }

  var _a = useState(defaultMatches),
      matches = _a[0],
      setMatches = _a[1];

  useEffect(function () {
    var mediaQueryList = window.matchMedia(json2mq(query));

    var listener = function listener() {
      if (mediaQueryList.matches) {
        setMatches(true);
      } else {
        setMatches(false);
      }
    };

    mediaQueryList.addListener(listener);
    setMatches(mediaQueryList.matches);
    return function () {
      return mediaQueryList.removeListener(listener);
    };
  }, [query]);
  return matches;
};

var _extends$e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$e(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CloseIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$e(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "44",
    height: "44",
    viewBox: "0 0 44 44"
  }, props), React__default.createElement("defs", null, React__default.createElement("path", {
    id: "a",
    d: "M28 24V10a2 2 0 1 0-4 0v14H10a2 2 0 1 0 0 4h14v14a2 2 0 1 0 4 0V28h14a2 2 0 1 0 0-4H28z"
  })), React__default.createElement("use", {
    transform: "rotate(45 28.828 19.172)",
    xlinkHref: "#a"
  }));
});

var _extends$f = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$f(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ChatIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$f(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), React__default.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(0 -1)"
  }, React__default.createElement("path", {
    fillRule: "nonzero",
    d: "M16.492 16.539a1 1 0 0 1 .087-.99A7.94 7.94 0 0 0 18 11.002a8 8 0 1 0-3.716 6.743 1 1 0 0 1 .769-.128l2.176.521-.737-1.6zm2.047-.336l1.37 2.968a1 1 0 0 1-1.142 1.392l-3.781-.905A10 10 0 1 1 20 11a9.94 9.94 0 0 1-1.46 5.203z"
  }), React__default.createElement("rect", {
    width: "8",
    height: "2",
    x: "6",
    y: "8",
    rx: "1"
  }), React__default.createElement("rect", {
    width: "6",
    height: "2",
    x: "6",
    y: "12",
    rx: "1"
  })));
});

var styles$k = {"breakpoint-sm":"(min-width: 40em)","widget":"styles_widget__2zhy1 relative","expanded":"styles_expanded__19jhh","chat":"styles_chat__F1T17 pt3 flex flex-auto flex-column fixed bottom-0 left-0 right-0","halfExpanded":"styles_halfExpanded__3dg3d","conversation":"styles_conversation__3D2ZI flex flex-auto justify-start m0 px1","header":"styles_header__31qty","snackbar":"styles_snackbar__1Py4m fixed left-0 bottom-0 right-0 mx2 mb2","-webkit-transform":"styles_transform__2v5gu","transform":"styles_transform__2v5gu","shrunk":"styles_shrunk__1R7lu","breakpointSm":"(min-width: 40em)","webkitTransform":"styles_transform__2v5gu"};

var ChatWidget =
/** @class */
function (_super) {
  __extends(ChatWidget, _super);

  function ChatWidget(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      display: !!_this.props.hasUnreadMessages ? 'preview' : 'collapsed'
    };
    _this.expand = _this.expand.bind(_this);
    _this.collapse = _this.collapse.bind(_this);
    _this.getApplicationDomNode = _this.getApplicationDomNode.bind(_this);
    _this.addApplicationClassNames = _this.addApplicationClassNames.bind(_this);
    _this.removeApplicationClassNames = _this.removeApplicationClassNames.bind(_this);
    _this.shrinkApplication = _this.shrinkApplication.bind(_this);
    _this.expandApplication = _this.expandApplication.bind(_this);
    _this.getKeyForPersistentStorage = _this.getKeyForPersistentStorage.bind(_this);
    _this.handleNewMessage = _this.handleNewMessage.bind(_this);
    return _this;
  }

  ChatWidget.prototype.componentDidUpdate = function (prevProps) {
    // Listen for messages on the conversation when it's available, or when it has changed.
    var conversation = this.props.conversation;
    var prevConversation = prevProps.conversation;

    if (conversation && (!prevConversation || conversation.conversationId !== prevConversation.conversationId)) {
      if (prevConversation) {
        prevConversation.off('newMessage', this.handleNewMessage);
      }

      conversation.on('newMessage', this.handleNewMessage);
    }
  };

  ChatWidget.prototype.componentDidMount = function () {
    var _this = this;

    this.addApplicationClassNames(styles$k.transform); // Listen for new messages

    if (this.props.conversation) {
      this.props.conversation.on('newMessage', this.handleNewMessage);
    } // If the user navigates, collapse the widget


    if (this.props.history) {
      this.unlisten = this.props.history.listen(function () {
        if (window.matchMedia('(max-width: 40em)').matches) {
          _this.collapse();
        }
      });
    } // Initialize the local display state from the previously persisted display state


    if (this.props.conversationId) {
      var persistedDisplayState = window.sessionStorage.getItem(this.getKeyForPersistentStorage(this.props.conversationId)); // Restore the previous display state of the chat widget for this conversation

      if (persistedDisplayState) {
        this.setState({
          display: persistedDisplayState
        });
      }
    }
  };

  ChatWidget.prototype.componentWillUnmount = function () {
    this.expandApplication();
    this.removeApplicationClassNames(styles$k.transform);

    if (this.props.conversation) {
      this.props.conversation.off('newMessage', this.handleNewMessage);
    }

    if (this.unlisten) {
      this.unlisten();
    }

    if (this.props.conversationId) {
      window.sessionStorage.setItem(this.getKeyForPersistentStorage(this.props.conversationId), this.state.display);
    }
  };

  ChatWidget.prototype.handleNewMessage = function () {
    if (this.state.display === 'collapsed') {
      this.setState({
        display: 'preview'
      });
    }
  };

  ChatWidget.prototype.getApplicationDomNode = function () {
    return this.props.getAppRoot && this.props.getAppRoot();
  };

  ChatWidget.prototype.getKeyForPersistentStorage = function (conversationId) {
    return "conversation:" + conversationId + ":user:" + this.props.userId + ":widget-state";
  };
  /**
   * Expand the widget
   */


  ChatWidget.prototype.expand = function () {
    if (this.state.display === 'expanded') {
      return;
    } // When the ChatWidget expands, we shrink the rest of the application


    this.shrinkApplication();

    if (!this.state.windowScollPositionWhenOpened && this.props.isMobile) {
      this.setState({
        windowScollPositionWhenOpened: [window.scrollX, window.scrollY]
      });
      window.scrollTo(0, 0);
    }

    this.setState({
      display: 'expanded'
    });

    if (this.props.conversationId) {
      window.sessionStorage.setItem(this.getKeyForPersistentStorage(this.props.conversationId), 'expanded');
    }
  };
  /**
   * Collapse the widget
   */


  ChatWidget.prototype.collapse = function () {
    // When the ChatWidget collapses, we reset the rest of the application
    this.expandApplication();

    if (this.state.windowScollPositionWhenOpened && this.props.isMobile) {
      var _a = this.state.windowScollPositionWhenOpened,
          x = _a[0],
          y = _a[1];
      window.scrollTo(x, y);
      this.setState({
        windowScollPositionWhenOpened: undefined
      });
    }

    this.setState({
      display: 'collapsed'
    });

    if (this.props.conversationId) {
      window.sessionStorage.setItem(this.getKeyForPersistentStorage(this.props.conversationId), 'collapsed');
    }
  };
  /**
   * Visually "detach" the rest of the application from the browser
   */


  ChatWidget.prototype.shrinkApplication = function () {
    var domNode = this.getApplicationDomNode();

    if (domNode) {
      this.addApplicationClassNames(styles$k.shrunk);

      if (domNode instanceof HTMLElement) {
        // Calculate the percentage we need to scale the element in order to shrink by 9px in each dimension
        var rect = domNode.getBoundingClientRect();
        var scaleY = 1 - 18 / rect.height;
        var scaleX = 1 - 18 / rect.width; // Add the transform

        domNode.style.transform = "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        domNode.style.webkitTransform = "scaleX(" + scaleX + " scaleY(" + scaleY + ")";
      }
    }
  };
  /**
   * Re-attach the rest of the application from the browser
   */


  ChatWidget.prototype.expandApplication = function () {
    var domNode = this.getApplicationDomNode();

    if (domNode) {
      this.removeApplicationClassNames(styles$k.shrunk);

      if (domNode instanceof HTMLElement) {
        // Reset the scaling transform (TODO: Do we need to restore the previous value?)
        domNode.style.transform = '';
        domNode.style.webkitTransform = '';
      }
    }
  };
  /**
   * Utility function to add className(s) to the application element
   */


  ChatWidget.prototype.addApplicationClassNames = function (className) {
    var _a;

    var domNode = this.getApplicationDomNode();

    if (domNode) {
      (_a = domNode.classList).add.apply(_a, className.split(' '));
    }
  };
  /**
   * Utility function to remove className(s) to the application element
   */


  ChatWidget.prototype.removeApplicationClassNames = function (className) {
    var _a;

    var domNode = this.getApplicationDomNode();

    if (domNode) {
      (_a = domNode.classList).remove.apply(_a, className.split(' '));
    }
  };

  ChatWidget.prototype.render = function () {
    var _a;

    var _this = this;

    var _b = this.props,
        recipients = _b.recipients,
        hasUnreadMessages = _b.hasUnreadMessages,
        conversation = _b.conversation,
        className = _b.className,
        collapsedClassName = _b.collapsedClassName,
        isMobile = _b.isMobile;
    /**
     * TODO: Update these docs. Conversation/Composer components will also take optional conversationId's now.
     *
     * The ChatWidget supports a few states:
     *   - Collapsed, without a Conversation present (the user doesn't have a convo, or we are lazy-loading it)
     *   - Collapsed, with a Conversation (the user has a convo, but has dimissed it or has no unreads)
     *   - Expanded, without a Conversation (the user has tried to initiate a convo, but it isn't loaded yet)
     *   - Expanded, with a Conversation (the user is actively messaging/interacting with the ChatWidget)
     */

    var widget = React__default.createElement("div", {
      className: classnames(styles$k.widget, (_a = {}, _a[styles$k.expanded] = this.state.display === 'expanded', _a), collapsedClassName && this.state.display === 'collapsed' ? collapsedClassName : undefined, className)
    }, recipients.length > 0 ? React__default.createElement(Transition, {
      native: true,
      from: {
        opacity: 0,
        transform: 'translate3d(0,100%,0)'
      },
      enter: {
        opacity: 1,
        transform: 'translate3d(0,0%,0)'
      },
      leave: {
        opacity: 0,
        transform: 'translate3d(0,100%,0)'
      }
    }, this.state.display === 'expanded' || this.state.display === 'preview' ? function (animatedStyles) {
      var _a;

      return React__default.createElement(React__default.Fragment, null, React__default.createElement(Scrolllock, {
        isActive: isMobile
      }), React__default.createElement(animated.div, {
        style: animatedStyles,
        className: classnames(styles$k.chat, (_a = {}, _a[styles$k.halfExpanded] = _this.state.display === 'preview', _a))
      }, React__default.createElement(ChatHeader, {
        recipients: recipients,
        unread: hasUnreadMessages,
        online: _this.props.online,
        rating: _this.props.rating,
        minimized: true,
        ctaIcon: CloseIcon,
        ctaText: "Close chat",
        onCtaClick: _this.collapse,
        onClick: _this.state.display === 'preview' ? _this.expand : _this.collapse,
        className: styles$k.header
      }), React__default.createElement(Conversation$1, {
        conversationId: conversation && conversation.conversationId,
        enableReadReceipts: _this.state.display === 'expanded',
        onClick: _this.state.display === 'collapsed' ? _this.expand : undefined
      }, _this.props.children), React__default.createElement(Composer$1, {
        conversationId: conversation && conversation.conversationId,
        onConversationStarted: _this.props.onConversationStarted,
        onSendMessage: _this.props.onSendMessage,
        onFocus: _this.expand,
        source: "chathead"
      })));
    } : function (animatedStyles) {
      return React__default.createElement(animated.div, {
        style: animatedStyles,
        className: classnames(styles$k.snackbar, _this.props.className)
      }, React__default.createElement(ChatHeader, {
        recipients: recipients,
        unread: hasUnreadMessages,
        online: _this.props.online,
        rating: _this.props.rating,
        minimized: false,
        ctaIcon: ChatIcon,
        ctaText: "Chat",
        onClick: _this.expand,
        onCtaClick: _this.expand
      }));
    }) : null); // The ChatWidget can optionally be rendered into a ReactPortal to allow for more control over positioning.

    var parentNode = this.props.getParent && this.props.getParent();
    var bodyNode = document.querySelector('body');
    return ReactDOM.createPortal(widget, parentNode || bodyNode);
  };

  ChatWidget.defaultProps = {
    rating: 'none'
  };
  return ChatWidget;
}(React__default.Component);

var ResponsiveChatWidgetWithFirebaseConversation = function ResponsiveChatWidgetWithFirebaseConversation(_a) {
  var conversationId = _a.conversationId,
      userId = _a.userId,
      rest = __rest(_a, ["conversationId", "userId"]);

  var isMobile = useMedia({
    maxWidth: '40em'
  });
  return React__default.createElement(FirebaseConversationQuery$1, {
    conversationId: conversationId
  }, function (_a) {
    var conversation = _a.conversation;
    return React__default.createElement(FirebaseUserQuery$1, {
      userIds: [userId]
    }, function (_a) {
      var users = _a.users; // If we have a conversation, prefer the "other" users from that conversation over the user prop

      var otherParticipants = conversation && conversation.participants.filter(function (participant) {
        return !participant.isMyself;
      });
      var recipients = otherParticipants && otherParticipants.length ? otherParticipants : users;
      var hasUnreadMessages = conversation && conversation.unreadCount > 0;
      return React__default.createElement(ChatWidget, __assign({
        recipients: recipients || [],
        hasUnreadMessages: hasUnreadMessages,
        conversation: conversation,
        conversationId: conversationId,
        userId: userId,
        isMobile: isMobile
      }, rest));
    });
  });
};

var index$1 = withChat(ResponsiveChatWidgetWithFirebaseConversation);

var styles$l = {"container":"styles_container__3kgFj","video":"styles_video__3m3HZ"};

var VideoUploadPreview =
/** @class */
function (_super) {
  __extends(VideoUploadPreview, _super);

  function VideoUploadPreview() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  VideoUploadPreview.accept = function (mimeType) {
    return mimeType.startsWith('video/');
  };

  VideoUploadPreview.getBodyType = function (_mimeType) {
    return 'VIDEO';
  };

  VideoUploadPreview.prototype.render = function () {
    var url = this.props.data.file.url || URL.createObjectURL(this.props.data.file);
    return React__default.createElement("div", {
      className: styles$l.container
    }, React__default.createElement("video", {
      className: styles$l.video,
      src: url,
      muted: true
    }), React__default.createElement("div", null, this.props.data.file.name || this.props.data.file.originalFileName || 'video'));
  };

  return VideoUploadPreview;
}(PureComponent);

var _extends$g = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$g(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Icon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$g(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$g({
    width: "24",
    height: "16",
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("title", null, "video"), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M0-4h24v24H0z"
  }), React__default.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1 1)",
    stroke: "#3D4E56",
    strokeWidth: "2"
  }, React__default.createElement("path", {
    d: "M22 2l-7 5 7 5z"
  }), React__default.createElement("rect", {
    width: "15",
    height: "14",
    rx: "2"
  }))));
});

var styles$m = {"button":"styles_button__26qHr","hidden":"styles_hidden__vCXHE"};

var styles$n = {"container":"styles_container__KnG8G","image":"styles_image__d5RCj"};

var _extends$h = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$h(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var FileIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$h(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128"
  }, props), React__default.createElement("defs", null, React__default.createElement("linearGradient", {
    id: "a"
  }, React__default.createElement("stop", {
    stopColor: "#eee"
  }), React__default.createElement("stop", {
    offset: "1",
    stopColor: "#d2d2d2"
  })), React__default.createElement("linearGradient", {
    id: "b"
  }, React__default.createElement("stop", null), React__default.createElement("stop", {
    offset: "1",
    stopOpacity: ".536"
  })), React__default.createElement("linearGradient", {
    id: "c"
  }, React__default.createElement("stop", null), React__default.createElement("stop", {
    offset: "1",
    stopColor: "#ddd",
    stopOpacity: "0"
  })), React__default.createElement("filter", {
    id: "g",
    x: "-.147",
    width: "1.294",
    y: "-.145",
    height: "1.29"
  }, React__default.createElement("feGaussianBlur", {
    stdDeviation: "1.819"
  })), React__default.createElement("filter", {
    id: "d"
  }, React__default.createElement("feGaussianBlur", {
    stdDeviation: "2.586"
  })), React__default.createElement("radialGradient", {
    xlinkHref: "#a",
    r: "44.42",
    cy: "100.32",
    cx: "81.79",
    gradientTransform: "matrix(2.0026 -1.59703 1.77733 2.2287 -279.236 23.704)",
    gradientUnits: "userSpaceOnUse",
    id: "e"
  }), React__default.createElement("radialGradient", {
    xlinkHref: "#b",
    r: "18.279",
    cy: "22.254",
    cx: "89.51",
    gradientTransform: "matrix(1 0 0 .97468 0 .44)",
    gradientUnits: "userSpaceOnUse",
    id: "f"
  }), React__default.createElement("linearGradient", {
    xlinkHref: "#c",
    y2: "25.1",
    x2: "86.82",
    y1: "14.793",
    x1: "98.33",
    gradientTransform: "matrix(.96715 0 0 .96715 .456 -.087)",
    gradientUnits: "userSpaceOnUse",
    id: "h"
  })), React__default.createElement("path", {
    transform: "matrix(.96715 0 0 .97126 1.589 2.695)",
    d: "M20.094 4.119v118h88.844V35.962l-.594-.625c.21.145.417.302.625.438L78.094 4.15c.056.08.1.17.156.25L78 4.119H20.094z",
    opacity: ".809",
    filter: "url(#d)"
  }), React__default.createElement("path", {
    d: "M19.89 2.543v114.123h85.925V33.34L75.894 2.543H19.89z",
    fill: "url(#e)",
    transform: "translate(1.132 3.31)"
  }), React__default.createElement("path", {
    transform: "matrix(1.01608 0 0 1.11224 -3.792 2.965)",
    d: "M81.698 28.31l.135-8.351c.068-6.6-.877-11.548-4.047-16.012l2.576-.031 27.5 25.615c-4.067-2.646-9.62-.791-16.861-1.026l-9.303-.195z",
    opacity: ".505",
    fill: "url(#f)",
    filter: "url(#g)"
  }), React__default.createElement("path", {
    d: "M82.748 29.122l.131-8.077c.066-6.382-2.692-10.836-5.758-15.153l29.867 30.588c-3.934-2.558-8.24-6.942-15.243-7.169l-8.997-.19z",
    fill: "#eee"
  }), React__default.createElement("path", {
    d: "M81.616 25.812l.13-8.077c.066-6.382-2.691-10.836-5.757-15.153l29.867 30.588c-3.935-2.558-8.24-6.942-15.243-7.169l-8.997-.19z",
    fill: "url(#h)",
    transform: "translate(1.132 3.31)"
  }));
});

var FileUploadPreview =
/** @class */
function (_super) {
  __extends(FileUploadPreview, _super);

  function FileUploadPreview() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FileUploadPreview.accept = function (_mimeType) {
    return true;
  };

  FileUploadPreview.getBodyType = function (_mimeType) {
    return 'FILE';
  };

  FileUploadPreview.prototype.render = function () {
    return React__default.createElement("div", {
      className: styles$n.container
    }, React__default.createElement(FileIcon, {
      className: styles$n.image
    }), React__default.createElement("div", null, this.props.data.file.name || this.props.data.file.originalFileName || 'attachment'));
  };

  return FileUploadPreview;
}(PureComponent);

var MediaUploadControlBase =
/** @class */
function (_super) {
  __extends(MediaUploadControlBase, _super);

  function MediaUploadControlBase(props) {
    var _this = _super.call(this, props) || this;

    _this.findPreview = _this.findPreview.bind(_this);
    _this.attachFile = _this.attachFile.bind(_this);
    _this.toMessage = _this.toMessage.bind(_this);
    return _this;
  }

  MediaUploadControlBase.prototype.attachFile = function (file) {
    this.props.attach({
      data: {
        file: file
      },
      previewer: this.findPreview(file.type || file.mimeType),
      toMessage: this.toMessage
    });
  };

  MediaUploadControlBase.prototype.findPreview = function (mimeType) {
    return this.props.previews.find(function (preview) {
      return preview.accept(mimeType);
    }) || FileUploadPreview;
  };

  MediaUploadControlBase.prototype.toMessage = function (data, conversation) {
    var _this = this;

    var uploadMediaPromise;
    var originalFileName = data.file.name || data.file.originalFileName;

    if (data.file.id) {
      if (this.props.handlePersistMedia) {
        uploadMediaPromise = this.props.handlePersistMedia(data.file);
      } else {
        uploadMediaPromise = Promise.resolve(data.file);
      }
    } else {
      uploadMediaPromise = this.props.handleUploadMedia(data.file);
    }

    return uploadMediaPromise.then(function (mediaFile) {
      var mimeType = mediaFile.mimeType,
          url = mediaFile.url,
          id = mediaFile.id; // Just in case someone uploads something weird

      var bodyType = _this.findPreview(mimeType).getBodyType(mimeType);

      var message = conversation.createDraftMessage();
      message.addDraftPart(bodyType, {
        mediaUrl: url,
        mediaId: id,
        originalFileName: originalFileName
      });
      return message;
    });
  };

  return MediaUploadControlBase;
}(PureComponent);

var MediaUploadControl =
/** @class */
function (_super) {
  __extends(MediaUploadControl, _super);

  function MediaUploadControl(props) {
    var _this = _super.call(this, props) || this;

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleFileChanged = _this.handleFileChanged.bind(_this);
    return _this;
  }

  MediaUploadControl.prototype.handleClick = function (event) {
    event.preventDefault();

    if (this.hiddenInput) {
      this.hiddenInput.click();
    }
  };

  MediaUploadControl.prototype.handleFileChanged = function (event) {
    var files = event.target.files;

    if (!files || files.length === 0) {
      return;
    }

    this.attachFile(files[0]);
  };

  MediaUploadControl.prototype.render = function () {
    var _this = this;

    var Glyph = this.props.icon;
    return React__default.createElement("div", {
      title: this.props.title ? this.props.title : 'Upload Media'
    }, React__default.createElement("input", {
      className: styles$m.hidden,
      type: "file",
      onChange: this.handleFileChanged,
      accept: this.props.accept.join(','),
      ref: function ref(el) {
        return _this.hiddenInput = el;
      }
    }), React__default.createElement(Glyph, {
      className: styles$m.button,
      onClick: this.handleClick
    }));
  };

  return MediaUploadControl;
}(MediaUploadControlBase);

var VideoUploadControl = function VideoUploadControl(props) {
  return React__default.createElement(MediaUploadControl, __assign({
    accept: ['video/mp4', 'video/mpeg', 'video/quicktime'],
    previews: [VideoUploadPreview],
    icon: Icon
  }, props));
};

var styles$o = {"container":"styles_container__1R8E1","image":"styles_image__27mtr"};

var ImageUploadPreview =
/** @class */
function (_super) {
  __extends(ImageUploadPreview, _super);

  function ImageUploadPreview() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ImageUploadPreview.accept = function (mimeType) {
    return mimeType.startsWith('image/');
  };

  ImageUploadPreview.getBodyType = function (_mimeType) {
    return 'IMAGE';
  };

  ImageUploadPreview.prototype.render = function () {
    var url = this.props.data.file.url || URL.createObjectURL(this.props.data.file);
    return React__default.createElement("div", {
      className: styles$o.container
    }, React__default.createElement("img", {
      className: styles$o.image,
      src: url
    }), React__default.createElement("div", null, this.props.data.file.name || this.props.data.file.originalFileName || 'image'));
  };

  return ImageUploadPreview;
}(PureComponent);

var _extends$i = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$i(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Icon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$i(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$i({
    width: "24",
    height: "22",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("title", null, "image"), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M0-1h24v24H0z"
  }), React__default.createElement("g", {
    strokeLinecap: "square",
    transform: "translate(1 1)",
    stroke: "#3D4E56",
    strokeWidth: "2"
  }, React__default.createElement("path", {
    d: "M0 15l5-4 5 4 6-7 6 5"
  }), React__default.createElement("path", {
    d: "M0 0h22v20H0z"
  }), React__default.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "2"
  }))));
});

var ImageUploadControl = function ImageUploadControl(props) {
  return React__default.createElement(MediaUploadControl, __assign({
    accept: ['image/jpg', 'image/jpeg', 'image/gif', 'image/png'],
    previews: [ImageUploadPreview],
    icon: Icon$1,
    title: "Upload Image"
  }, props));
};

var styles$p = {"container":"styles_container__BrQ5K"};

var AudioUploadPreview =
/** @class */
function (_super) {
  __extends(AudioUploadPreview, _super);

  function AudioUploadPreview() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AudioUploadPreview.accept = function (mimeType) {
    return mimeType.startsWith('audio/');
  };

  AudioUploadPreview.getBodyType = function (_mimeType) {
    return 'AUDIO';
  };

  AudioUploadPreview.prototype.render = function () {
    var url = this.props.data.file.url || URL.createObjectURL(this.props.data.file);
    return React__default.createElement("div", {
      className: styles$p.container
    }, React__default.createElement("audio", {
      src: url,
      controls: true
    }), React__default.createElement("div", null, this.props.data.file.name || this.props.data.file.originalFileName || 'audio'));
  };

  return AudioUploadPreview;
}(PureComponent);

var _extends$j = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$j(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Icon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$j(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$j({
    width: "16",
    height: "24",
    viewBox: "0 0 16 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("title", null, "mic"), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M-4 0h24v24H-4z"
  }), React__default.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#3D4E56",
    strokeWidth: "2"
  }, React__default.createElement("path", {
    d: "M8 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
  }), React__default.createElement("path", {
    d: "M15 10v2a7 7 0 0 1-14 0v-2M8 19v4M4 23h8"
  }))));
});

var styles$q = {"button":"styles_button__DlQzn","startButtonIcon":"styles_startButtonIcon__2QnvR","stopButtonIcon":"styles_stopButtonIcon__3uYxw","actions":"styles_actions__2FlDR","text":"styles_text__2VriB","hidden":"styles_hidden__FAq0k","link":"styles_link__2e7Fm"};

var _extends$k = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$k(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var StopIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties$k(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), React__default.createElement("title", null, "stop"), React__default.createElement("path", {
    "data-color": "color-2",
    fill: "red",
    strokeMiterlimit: "10",
    d: "M8 8h8v8H8z",
    className: styles["nc-icon-wrapper"] || "nc-icon-wrapper",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000"
  }));
});

var AudioUploadControlModal =
/** @class */
function (_super) {
  __extends(AudioUploadControlModal, _super);

  function AudioUploadControlModal(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      initialized: false,
      unsupported: false
    };
    _this.hiddenInput = null;
    _this.handleStartRecording = _this.handleStartRecording.bind(_this);
    _this.handleStopRecording = _this.handleStopRecording.bind(_this);
    _this.handleFileChanged = _this.handleFileChanged.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.clearRecordingState = _this.clearRecordingState.bind(_this);
    return _this;
  }

  AudioUploadControlModal.prototype.componentDidMount = function () {
    var _this = this;

    this.props.recorder.initialize().then(function () {
      return _this.setState({
        initialized: true
      });
    }).catch(function () {
      return _this.setState({
        unsupported: true
      });
    });
  };

  AudioUploadControlModal.prototype.componentWillUnmount = function () {
    this.props.recorder.close();

    if (this.timer) {
      clearInterval(this.timer);
    }
  };

  AudioUploadControlModal.prototype.handleStartRecording = function () {
    var _this = this;

    if (this.state.initialized) {
      this.props.recorder.startRecording().then(function () {
        var now = Date.now();

        _this.setState({
          startRecording: Date.now(),
          now: now
        });

        _this.timer = setInterval(function () {
          _this.setState({
            now: Date.now()
          });
        }, 1000);
      });
    }
  };

  AudioUploadControlModal.prototype.clearRecordingState = function () {
    if (this.timer) {
      clearInterval(this.timer);
      this.setState({
        now: undefined,
        startRecording: undefined
      });
      this.timer = undefined;
    }
  };

  AudioUploadControlModal.prototype.handleStopRecording = function () {
    var _this = this;

    if (this.state.initialized) {
      this.props.recorder.stopRecording().then(function (file) {
        _this.clearRecordingState();

        _this.props.onFileCompleted(file);
      }).finally(this.clearRecordingState);
    } else {
      this.clearRecordingState();
    }
  };

  AudioUploadControlModal.prototype.handleClick = function (event) {
    event.preventDefault();

    if (this.hiddenInput) {
      this.hiddenInput.click();
    }
  };

  AudioUploadControlModal.prototype.handleFileChanged = function (event) {
    var files = event.target.files;

    if (!files || files.length === 0) {
      return;
    }

    this.props.onFileCompleted(files[0]);
  };

  AudioUploadControlModal.prototype.padding = function (num) {
    if (num < 10) {
      return "0" + num;
    }

    return "" + num;
  };

  AudioUploadControlModal.prototype.getTime = function (duration) {
    var durationSeconds = duration <= 0 ? 0 : duration / 1000;
    var seconds = Math.floor(durationSeconds % 60);
    var minutes = Math.floor(durationSeconds / 60);
    return this.padding(minutes) + ":" + this.padding(seconds);
  };

  AudioUploadControlModal.prototype.render = function () {
    var _this = this;

    return React__default.createElement(SimpleModal, {
      isOpen: true,
      onRequestClose: this.props.onClose
    }, React__default.createElement(ModalContent, {
      className: styles$q.content
    }, React__default.createElement("div", {
      className: styles$q.text
    }, this.state.unsupported ? 'Recording audio not supported or not allowed, please grant permission to access microphone' : this.state.initialized ? this.state.startRecording ? this.getTime(this.state.now - this.state.startRecording) : 'Click to start recording audio' : 'Initializing'), React__default.createElement("div", {
      className: styles$q.actions
    }, !this.state.startRecording && React__default.createElement("div", {
      className: styles$q.button,
      onClick: this.handleStartRecording
    }, React__default.createElement(Icon$2, {
      className: styles$q.startButtonIcon
    })), this.state.startRecording && React__default.createElement("div", {
      className: styles$q.button,
      onClick: this.handleStopRecording
    }, React__default.createElement(StopIcon, {
      className: styles$q.stopButtonIcon
    }))), React__default.createElement("div", {
      className: styles$q.text
    }, React__default.createElement("input", {
      className: styles$q.hidden,
      type: "file",
      onChange: this.handleFileChanged,
      accept: this.props.accept.join(','),
      ref: function ref(el) {
        return _this.hiddenInput = el;
      }
    }), React__default.createElement("div", {
      className: styles$q.link,
      onClick: this.handleClick
    }, "or click here to upload an audio file."))));
  };

  return AudioUploadControlModal;
}(Component);

var styles$r = {"button":"styles_button__XuuUv"};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var vmsg_es5 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.record = record;
exports.default = exports.Form = exports.Recorder = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable */
function pad2(n) {
  n |= 0;
  return n < 10 ? "0".concat(n) : "".concat(Math.min(n, 99));
}

function inlineWorker() {
  // TODO(Kagami): Cache compiled module in IndexedDB? It works in FF
  // and Edge, see: https://github.com/mdn/webassembly-examples/issues/4
  // Though gzipped WASM module currently weights ~70kb so it should be
  // perfectly cached by the browser itself.
  function fetchAndInstantiate(url, imports) {
    if (!WebAssembly.instantiateStreaming) return fetchAndInstantiateFallback(url, imports);
    var req = fetch(url, {
      credentials: "same-origin"
    });
    return WebAssembly.instantiateStreaming(req, imports).catch(function (err) {
      // https://github.com/Kagami/vmsg/issues/11
      if (err.message && err.message.indexOf("Argument 0 must be provided and must be a Response") > 0) {
        return fetchAndInstantiateFallback(url, imports);
      } else {
        throw err;
      }
    });
  }

  function fetchAndInstantiateFallback(url, imports) {
    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      req.open("GET", url);
      req.responseType = "arraybuffer";

      req.onload = function () {
        resolve(WebAssembly.instantiate(req.response, imports));
      };

      req.onerror = reject;
      req.send();
    });
  } // Must be in sync with emcc settings!


  var TOTAL_STACK = 5 * 1024 * 1024;
  var TOTAL_MEMORY = 16 * 1024 * 1024;
  var WASM_PAGE_SIZE = 64 * 1024;
  var memory = null;
  var dynamicTop = TOTAL_STACK; // TODO(Kagami): Grow memory?

  function sbrk(increment) {
    var oldDynamicTop = dynamicTop;
    dynamicTop += increment;
    return oldDynamicTop;
  } // TODO(Kagami): LAME calls exit(-1) on internal error. Would be nice
  // to provide custom DEBUGF/ERRORF for easier debugging. Currenty
  // those functions do nothing.


  function exit(status) {
    postMessage({
      type: "internal-error",
      data: status
    });
  }

  var FFI = null;
  var ref = null;
  var pcm_l = null;

  function vmsg_init(rate) {
    ref = FFI.vmsg_init(rate);
    if (!ref) return false;
    var pcm_l_ref = new Uint32Array(memory.buffer, ref, 1)[0];
    pcm_l = new Float32Array(memory.buffer, pcm_l_ref);
    return true;
  }

  function vmsg_encode(data) {
    pcm_l.set(data);
    return FFI.vmsg_encode(ref, data.length) >= 0;
  }

  function vmsg_flush() {
    if (FFI.vmsg_flush(ref) < 0) return null;
    var mp3_ref = new Uint32Array(memory.buffer, ref + 4, 1)[0];
    var size = new Uint32Array(memory.buffer, ref + 8, 1)[0];
    var mp3 = new Uint8Array(memory.buffer, mp3_ref, size);
    var blob = new Blob([mp3], {
      type: "audio/mpeg"
    });
    FFI.vmsg_free(ref);
    ref = null;
    pcm_l = null;
    return blob;
  } // https://github.com/brion/min-wasm-fail


  function testSafariWebAssemblyBug() {
    var bin = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 6, 1, 96, 1, 127, 1, 127, 3, 2, 1, 0, 5, 3, 1, 0, 1, 7, 8, 1, 4, 116, 101, 115, 116, 0, 0, 10, 16, 1, 14, 0, 32, 0, 65, 1, 54, 2, 0, 32, 0, 40, 2, 0, 11]);
    var mod = new WebAssembly.Module(bin);
    var inst = new WebAssembly.Instance(mod, {}); // test storing to and loading from a non-zero location via a parameter.
    // Safari on iOS 11.2.5 returns 0 unexpectedly at non-zero locations

    return inst.exports.test(4) !== 0;
  }

  onmessage = function onmessage(e) {
    var msg = e.data;

    switch (msg.type) {
      case "init":
        var _msg$data = msg.data,
            wasmURL = _msg$data.wasmURL,
            shimURL = _msg$data.shimURL;
        Promise.resolve().then(function () {
          if (self.WebAssembly && !testSafariWebAssemblyBug()) {
            delete self.WebAssembly;
          }

          if (!self.WebAssembly) {
            importScripts(shimURL);
          }

          memory = new WebAssembly.Memory({
            initial: TOTAL_MEMORY / WASM_PAGE_SIZE,
            maximum: TOTAL_MEMORY / WASM_PAGE_SIZE
          });
          return {
            memory: memory,
            pow: Math.pow,
            exit: exit,
            powf: Math.pow,
            exp: Math.exp,
            sqrtf: Math.sqrt,
            cos: Math.cos,
            log: Math.log,
            sin: Math.sin,
            sbrk: sbrk
          };
        }).then(function (Runtime) {
          return fetchAndInstantiate(wasmURL, {
            env: Runtime
          });
        }).then(function (wasm) {
          FFI = wasm.instance.exports;
          postMessage({
            type: "init",
            data: null
          });
        }).catch(function (err) {
          postMessage({
            type: "init-error",
            data: err.toString()
          });
        });
        break;

      case "start":
        if (!vmsg_init(msg.data)) return postMessage({
          type: "error",
          data: "vmsg_init"
        });
        break;

      case "data":
        if (!vmsg_encode(msg.data)) return postMessage({
          type: "error",
          data: "vmsg_encode"
        });
        break;

      case "stop":
        var blob = vmsg_flush();
        if (!blob) return postMessage({
          type: "error",
          data: "vmsg_flush"
        });
        postMessage({
          type: "stop",
          data: blob
        });
        break;
    }
  };
}

var Recorder =
/*#__PURE__*/
function () {
  function Recorder() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var onStop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, Recorder);

    // Can't use relative URL in blob worker, see:
    // https://stackoverflow.com/a/22582695
    this.wasmURL = new URL(opts.wasmURL || "/static/js/vmsg.wasm", location).href;
    this.shimURL = new URL(opts.shimURL || "/static/js/wasm-polyfill.js", location).href;
    this.onStop = onStop;
    this.pitch = opts.pitch || 0;
    this.stream = null;
    this.audioCtx = null;
    this.gainNode = null;
    this.pitchFX = null;
    this.encNode = null;
    this.worker = null;
    this.workerURL = null;
    this.blob = null;
    this.blobURL = null;
    this.resolve = null;
    this.reject = null;
    Object.seal(this);
  }

  _createClass(Recorder, [{
    key: "close",
    value: function close() {
      if (this.encNode) this.encNode.disconnect();
      if (this.encNode) this.encNode.onaudioprocess = null;
      if (this.stream) this.stopTracks();
      if (this.audioCtx) this.audioCtx.close();
      if (this.worker) this.worker.terminate();
      if (this.workerURL) URL.revokeObjectURL(this.workerURL);
      if (this.blobURL) URL.revokeObjectURL(this.blobURL);
    } // Without pitch shift:
    //   [sourceNode] -> [gainNode] -> [encNode] -> [audioCtx.destination]
    //                                     |
    //                                     -> [worker]
    // With pitch shift:
    //   [sourceNode] -> [gainNode] -> [pitchFX] -> [encNode] -> [audioCtx.destination]
    //                                                  |
    //                                                  -> [worker]

  }, {
    key: "initAudio",
    value: function initAudio() {
      var _this = this;

      var getUserMedia = navigator.mediaDevices && navigator.mediaDevices.getUserMedia ? function (constraints) {
        return navigator.mediaDevices.getUserMedia(constraints);
      } : function (constraints) {
        var oldGetUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

        if (!oldGetUserMedia) {
          return Promise.reject(new Error("getUserMedia is not implemented in this browser"));
        }

        return new Promise(function (resolve, reject) {
          oldGetUserMedia.call(navigator, constraints, resolve, reject);
        });
      };
      return getUserMedia({
        audio: true
      }).then(function (stream) {
        _this.stream = stream;
        var audioCtx = _this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        var sourceNode = audioCtx.createMediaStreamSource(stream);
        var gainNode = _this.gainNode = (audioCtx.createGain || audioCtx.createGainNode).call(audioCtx);
        gainNode.gain.value = 1;
        sourceNode.connect(gainNode);
        var pitchFX = _this.pitchFX = new Jungle(audioCtx);
        pitchFX.setPitchOffset(_this.pitch);
        var encNode = _this.encNode = (audioCtx.createScriptProcessor || audioCtx.createJavaScriptNode).call(audioCtx, 0, 1, 1);
        pitchFX.output.connect(encNode);
        gainNode.connect(_this.pitch === 0 ? encNode : pitchFX.input);
      });
    }
  }, {
    key: "initWorker",
    value: function initWorker() {
      var _this2 = this;

      if (!this.stream) throw new Error("missing audio initialization"); // https://stackoverflow.com/a/19201292

      var blob = new Blob(["(", inlineWorker.toString(), ")()"], {
        type: "application/javascript"
      });
      var workerURL = this.workerURL = URL.createObjectURL(blob);
      var worker = this.worker = new Worker(workerURL);
      var wasmURL = this.wasmURL,
          shimURL = this.shimURL;
      worker.postMessage({
        type: "init",
        data: {
          wasmURL: wasmURL,
          shimURL: shimURL
        }
      });
      return new Promise(function (resolve, reject) {
        worker.onmessage = function (e) {
          var msg = e.data;

          switch (msg.type) {
            case "init":
              resolve();
              break;

            case "init-error":
              reject(new Error(msg.data));
              break;
            // TODO(Kagami): Error handling.

            case "error":
            case "internal-error":
              console.error("Worker error:", msg.data);
              if (_this2.reject) _this2.reject(msg.data);
              break;

            case "stop":
              _this2.blob = msg.data;
              _this2.blobURL = URL.createObjectURL(msg.data);
              if (_this2.onStop) _this2.onStop();
              if (_this2.resolve) _this2.resolve(_this2.blob);
              break;
          }
        };
      });
    }
  }, {
    key: "init",
    value: function init() {
      return this.initAudio().then(this.initWorker.bind(this));
    }
  }, {
    key: "startRecording",
    value: function startRecording() {
      var _this3 = this;

      if (!this.stream) throw new Error("missing audio initialization");
      if (!this.worker) throw new Error("missing worker initialization");
      this.blob = null;
      if (this.blobURL) URL.revokeObjectURL(this.blobURL);
      this.blobURL = null;
      this.resolve = null;
      this.reject = null;
      this.worker.postMessage({
        type: "start",
        data: this.audioCtx.sampleRate
      });

      this.encNode.onaudioprocess = function (e) {
        var samples = e.inputBuffer.getChannelData(0);

        _this3.worker.postMessage({
          type: "data",
          data: samples
        });
      };

      this.encNode.connect(this.audioCtx.destination);
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      var _this4 = this;

      if (!this.stream) throw new Error("missing audio initialization");
      if (!this.worker) throw new Error("missing worker initialization");
      this.encNode.disconnect();
      this.encNode.onaudioprocess = null;
      this.stopTracks();
      this.worker.postMessage({
        type: "stop",
        data: null
      });
      return new Promise(function (resolve, reject) {
        _this4.resolve = resolve;
        _this4.reject = reject;
      });
    }
  }, {
    key: "stopTracks",
    value: function stopTracks() {
      // Might be missed in Safari and old FF/Chrome per MDN.
      if (this.stream.getTracks) {
        // Hide browser's recording indicator.
        this.stream.getTracks().forEach(function (track) {
          return track.stop();
        });
      }
    }
  }]);

  return Recorder;
}();

exports.Recorder = Recorder;

var Form =
/*#__PURE__*/
function () {
  function Form() {
    var _this5 = this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var resolve = arguments.length > 1 ? arguments[1] : undefined;
    var reject = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, Form);

    this.recorder = new Recorder(opts, this.onStop.bind(this));
    this.resolve = resolve;
    this.reject = reject;
    this.backdrop = null;
    this.popup = null;
    this.recordBtn = null;
    this.stopBtn = null;
    this.timer = null;
    this.audio = null;
    this.saveBtn = null;
    this.tid = 0;
    this.start = 0;
    Object.seal(this);
    this.recorder.initAudio().then(function () {
      return _this5.drawInit();
    }).then(function () {
      return _this5.recorder.initWorker();
    }).then(function () {
      return _this5.drawAll();
    }).catch(function (err) {
      return _this5.drawError(err);
    });
  }

  _createClass(Form, [{
    key: "drawInit",
    value: function drawInit() {
      var _this6 = this;

      if (this.backdrop) return;
      var backdrop = this.backdrop = document.createElement("div");
      backdrop.className = "vmsg-backdrop";
      backdrop.addEventListener("click", function () {
        return _this6.close(null);
      });
      var popup = this.popup = document.createElement("div");
      popup.className = "vmsg-popup";
      popup.addEventListener("click", function (e) {
        return e.stopPropagation();
      });
      var progress = document.createElement("div");
      progress.className = "vmsg-progress";

      for (var i = 0; i < 3; i++) {
        var progressDot = document.createElement("div");
        progressDot.className = "vmsg-progress-dot";
        progress.appendChild(progressDot);
      }

      popup.appendChild(progress);
      backdrop.appendChild(popup);
      document.body.appendChild(backdrop);
    }
  }, {
    key: "drawTime",
    value: function drawTime(msecs) {
      var secs = Math.round(msecs / 1000);
      this.timer.textContent = pad2(secs / 60) + ":" + pad2(secs % 60);
    }
  }, {
    key: "drawAll",
    value: function drawAll() {
      var _this7 = this;

      this.drawInit();
      this.clearAll();
      var recordRow = document.createElement("div");
      recordRow.className = "vmsg-record-row";
      this.popup.appendChild(recordRow);
      var recordBtn = this.recordBtn = document.createElement("button");
      recordBtn.className = "vmsg-button vmsg-record-button";
      recordBtn.textContent = "●";
      recordBtn.addEventListener("click", function () {
        return _this7.startRecording();
      });
      recordRow.appendChild(recordBtn);
      var stopBtn = this.stopBtn = document.createElement("button");
      stopBtn.className = "vmsg-button vmsg-stop-button";
      stopBtn.style.display = "none";
      stopBtn.textContent = "■";
      stopBtn.addEventListener("click", function () {
        return _this7.stopRecording();
      });
      recordRow.appendChild(stopBtn);
      var audio = this.audio = new Audio();
      audio.autoplay = true;
      var timer = this.timer = document.createElement("span");
      timer.className = "vmsg-timer";
      timer.addEventListener("click", function () {
        if (audio.paused) {
          if (_this7.recorder.blobURL) {
            audio.src = _this7.recorder.blobURL;
          }
        } else {
          audio.pause();
        }
      });
      this.drawTime(0);
      recordRow.appendChild(timer);
      var saveBtn = this.saveBtn = document.createElement("button");
      saveBtn.className = "vmsg-button vmsg-save-button";
      saveBtn.textContent = "✓";
      saveBtn.disabled = true;
      saveBtn.addEventListener("click", function () {
        return _this7.close(_this7.recorder.blob);
      });
      recordRow.appendChild(saveBtn);
      var gainWrapper = document.createElement("div");
      gainWrapper.className = "vmsg-slider-wrapper vmsg-gain-slider-wrapper";
      var gainSlider = document.createElement("input");
      gainSlider.className = "vmsg-slider vmsg-gain-slider";
      gainSlider.setAttribute("type", "range");
      gainSlider.min = 0;
      gainSlider.max = 2;
      gainSlider.step = 0.2;
      gainSlider.value = 1;

      gainSlider.onchange = function () {
        var gain = +gainSlider.value;
        _this7.recorder.gainNode.gain.value = gain;
      };

      gainWrapper.appendChild(gainSlider);
      this.popup.appendChild(gainWrapper);
      var pitchWrapper = document.createElement("div");
      pitchWrapper.className = "vmsg-slider-wrapper vmsg-pitch-slider-wrapper";
      var pitchSlider = document.createElement("input");
      pitchSlider.className = "vmsg-slider vmsg-pitch-slider";
      pitchSlider.setAttribute("type", "range");
      pitchSlider.min = -1;
      pitchSlider.max = 1;
      pitchSlider.step = 0.2;
      pitchSlider.value = this.recorder.pitch;

      pitchSlider.onchange = function () {
        var pitch = +pitchSlider.value;

        _this7.recorder.pitchFX.setPitchOffset(pitch);

        _this7.recorder.gainNode.disconnect();

        _this7.recorder.gainNode.connect(pitch === 0 ? _this7.recorder.encNode : _this7.recorder.pitchFX.input);
      };

      pitchWrapper.appendChild(pitchSlider);
      this.popup.appendChild(pitchWrapper);
    }
  }, {
    key: "drawError",
    value: function drawError(err) {
      console.error(err);
      this.drawInit();
      this.clearAll();
      var error = document.createElement("div");
      error.className = "vmsg-error";
      error.textContent = err.toString();
      this.popup.appendChild(error);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      if (!this.popup) return;
      this.popup.innerHTML = "";
    }
  }, {
    key: "close",
    value: function close(blob) {
      if (this.audio) this.audio.pause();
      if (this.tid) clearTimeout(this.tid);
      this.recorder.close();
      this.backdrop.remove();

      if (blob) {
        this.resolve(blob);
      } else {
        this.reject(new Error("No record made"));
      }
    }
  }, {
    key: "onStop",
    value: function onStop() {
      this.recordBtn.style.display = "";
      this.stopBtn.style.display = "none";
      this.stopBtn.disabled = false;
      this.saveBtn.disabled = false;
    }
  }, {
    key: "startRecording",
    value: function startRecording() {
      this.audio.pause();
      this.start = Date.now();
      this.updateTime();
      this.recordBtn.style.display = "none";
      this.stopBtn.style.display = "";
      this.saveBtn.disabled = true;
      this.recorder.startRecording();
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      clearTimeout(this.tid);
      this.tid = 0;
      this.stopBtn.disabled = true;
      this.recorder.stopRecording();
    }
  }, {
    key: "updateTime",
    value: function updateTime() {
      var _this8 = this;

      // NOTE(Kagami): We can do this in `onaudioprocess` but that would
      // run too often and create unnecessary DOM updates.
      this.drawTime(Date.now() - this.start);
      this.tid = setTimeout(function () {
        return _this8.updateTime();
      }, 300);
    }
  }]);

  return Form;
}();

exports.Form = Form;
var shown = false;
/**
 * Record a new voice message.
 *
 * @param {Object=} opts - Options
 * @param {string=} opts.wasmURL - URL of the module
 *                                 ("/static/js/vmsg.wasm" by default)
 * @param {string=} opts.shimURL - URL of the WebAssembly polyfill
 *                                 ("/static/js/wasm-polyfill.js" by default)
 * @param {number=} opts.pitch - Initial pitch shift ([-1, 1], 0 by default)
 * @return {Promise.<Blob>} A promise that contains recorded blob when fulfilled.
 */

function record(opts) {
  return new Promise(function (resolve, reject) {
    if (shown) throw new Error("Record form is already opened");
    shown = true;
    new Form(opts, resolve, reject); // Use `.finally` once it's available in Safari and Edge.
  }).then(function (result) {
    shown = false;
    return result;
  }, function (err) {
    shown = false;
    throw err;
  });
}
/**
 * All available public items.
 */


var _default = {
  Recorder: Recorder,
  Form: Form,
  record: record
}; // Borrowed from and slightly modified:
// https://github.com/cwilso/Audio-Input-Effects/blob/master/js/jungle.js
// Copyright 2012, Google Inc.
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
//     * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
//     * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
//     * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

exports.default = _default;
var delayTime = 0.100;
var fadeTime = 0.050;
var bufferTime = 0.100;

function createFadeBuffer(context, activeTime, fadeTime) {
  var length1 = activeTime * context.sampleRate;
  var length2 = (activeTime - 2 * fadeTime) * context.sampleRate;
  var length = length1 + length2;
  var buffer = context.createBuffer(1, length, context.sampleRate);
  var p = buffer.getChannelData(0);
  var fadeLength = fadeTime * context.sampleRate;
  var fadeIndex1 = fadeLength;
  var fadeIndex2 = length1 - fadeLength; // 1st part of cycle

  for (var i = 0; i < length1; ++i) {
    var value;

    if (i < fadeIndex1) {
      value = Math.sqrt(i / fadeLength);
    } else if (i >= fadeIndex2) {
      value = Math.sqrt(1 - (i - fadeIndex2) / fadeLength);
    } else {
      value = 1;
    }

    p[i] = value;
  } // 2nd part


  for (var i = length1; i < length; ++i) {
    p[i] = 0;
  }

  return buffer;
}

function createDelayTimeBuffer(context, activeTime, fadeTime, shiftUp) {
  var length1 = activeTime * context.sampleRate;
  var length2 = (activeTime - 2 * fadeTime) * context.sampleRate;
  var length = length1 + length2;
  var buffer = context.createBuffer(1, length, context.sampleRate);
  var p = buffer.getChannelData(0); // 1st part of cycle

  for (var i = 0; i < length1; ++i) {
    if (shiftUp) // This line does shift-up transpose
      p[i] = (length1 - i) / length;else // This line does shift-down transpose
      p[i] = i / length1;
  } // 2nd part


  for (var i = length1; i < length; ++i) {
    p[i] = 0;
  }

  return buffer;
}

function Jungle(context) {
  this.context = context; // Create nodes for the input and output of this "module".

  var input = (context.createGain || context.createGainNode).call(context);
  var output = (context.createGain || context.createGainNode).call(context);
  this.input = input;
  this.output = output; // Delay modulation.

  var mod1 = context.createBufferSource();
  var mod2 = context.createBufferSource();
  var mod3 = context.createBufferSource();
  var mod4 = context.createBufferSource();
  this.shiftDownBuffer = createDelayTimeBuffer(context, bufferTime, fadeTime, false);
  this.shiftUpBuffer = createDelayTimeBuffer(context, bufferTime, fadeTime, true);
  mod1.buffer = this.shiftDownBuffer;
  mod2.buffer = this.shiftDownBuffer;
  mod3.buffer = this.shiftUpBuffer;
  mod4.buffer = this.shiftUpBuffer;
  mod1.loop = true;
  mod2.loop = true;
  mod3.loop = true;
  mod4.loop = true; // for switching between oct-up and oct-down

  var mod1Gain = (context.createGain || context.createGainNode).call(context);
  var mod2Gain = (context.createGain || context.createGainNode).call(context);
  var mod3Gain = (context.createGain || context.createGainNode).call(context);
  mod3Gain.gain.value = 0;
  var mod4Gain = (context.createGain || context.createGainNode).call(context);
  mod4Gain.gain.value = 0;
  mod1.connect(mod1Gain);
  mod2.connect(mod2Gain);
  mod3.connect(mod3Gain);
  mod4.connect(mod4Gain); // Delay amount for changing pitch.

  var modGain1 = (context.createGain || context.createGainNode).call(context);
  var modGain2 = (context.createGain || context.createGainNode).call(context);
  var delay1 = (context.createDelay || context.createDelayNode).call(context);
  var delay2 = (context.createDelay || context.createDelayNode).call(context);
  mod1Gain.connect(modGain1);
  mod2Gain.connect(modGain2);
  mod3Gain.connect(modGain1);
  mod4Gain.connect(modGain2);
  modGain1.connect(delay1.delayTime);
  modGain2.connect(delay2.delayTime); // Crossfading.

  var fade1 = context.createBufferSource();
  var fade2 = context.createBufferSource();
  var fadeBuffer = createFadeBuffer(context, bufferTime, fadeTime);
  fade1.buffer = fadeBuffer;
  fade2.buffer = fadeBuffer;
  fade1.loop = true;
  fade2.loop = true;
  var mix1 = (context.createGain || context.createGainNode).call(context);
  var mix2 = (context.createGain || context.createGainNode).call(context);
  mix1.gain.value = 0;
  mix2.gain.value = 0;
  fade1.connect(mix1.gain);
  fade2.connect(mix2.gain); // Connect processing graph.

  input.connect(delay1);
  input.connect(delay2);
  delay1.connect(mix1);
  delay2.connect(mix2);
  mix1.connect(output);
  mix2.connect(output); // Start

  var t = context.currentTime + 0.050;
  var t2 = t + bufferTime - fadeTime;
  mod1.start(t);
  mod2.start(t2);
  mod3.start(t);
  mod4.start(t2);
  fade1.start(t);
  fade2.start(t2);
  this.mod1 = mod1;
  this.mod2 = mod2;
  this.mod1Gain = mod1Gain;
  this.mod2Gain = mod2Gain;
  this.mod3Gain = mod3Gain;
  this.mod4Gain = mod4Gain;
  this.modGain1 = modGain1;
  this.modGain2 = modGain2;
  this.fade1 = fade1;
  this.fade2 = fade2;
  this.mix1 = mix1;
  this.mix2 = mix2;
  this.delay1 = delay1;
  this.delay2 = delay2;
  this.setDelay(delayTime);
}

Jungle.prototype.setDelay = function (delayTime) {
  this.modGain1.gain.setTargetAtTime(0.5 * delayTime, 0, 0.010);
  this.modGain2.gain.setTargetAtTime(0.5 * delayTime, 0, 0.010);
};

Jungle.prototype.setPitchOffset = function (mult) {
  if (mult > 0) {
    // pitch up
    this.mod1Gain.gain.value = 0;
    this.mod2Gain.gain.value = 0;
    this.mod3Gain.gain.value = 1;
    this.mod4Gain.gain.value = 1;
  } else {
    // pitch down
    this.mod1Gain.gain.value = 1;
    this.mod2Gain.gain.value = 1;
    this.mod3Gain.gain.value = 0;
    this.mod4Gain.gain.value = 0;
  }

  this.setDelay(delayTime * Math.abs(mult));
};
});

unwrapExports(vmsg_es5);
var vmsg_es5_1 = vmsg_es5.record;
var vmsg_es5_2 = vmsg_es5.Form;
var vmsg_es5_3 = vmsg_es5.Recorder;

var AudioUploadControlButton =
/** @class */
function (_super) {
  __extends(AudioUploadControlButton, _super);

  function AudioUploadControlButton(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      showModal: false
    };
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleFileCompleted = _this.handleFileCompleted.bind(_this);
    return _this;
  }

  AudioUploadControlButton.prototype.componentDidMount = function () {
    this.setState({
      recorder: this.props.recorder || this.createRecorder()
    });
  };

  AudioUploadControlButton.prototype.handleClick = function () {
    this.setState({
      showModal: true
    });
  };

  AudioUploadControlButton.prototype.handleClose = function () {
    this.setState({
      showModal: false
    });
  };

  AudioUploadControlButton.prototype.handleFileCompleted = function (file) {
    this.attachFile(file);
    this.setState({
      showModal: false
    });
  };

  AudioUploadControlButton.prototype.createRecorder = function () {
    var recorder = new vmsg_es5_3({
      wasmURL: 'https://unpkg.com/vmsg/vmsg.wasm',
      shimURL: 'https://unpkg.com/wasm-polyfill.js/wasm-polyfill.js'
    });
    return {
      initialize: function initialize() {
        return recorder.init();
      },
      startRecording: function startRecording() {
        return new Promise(function (resolve) {
          recorder.startRecording();
          resolve();
        });
      },
      stopRecording: function stopRecording() {
        return recorder.stopRecording().then(function (blob) {
          var file = blob;
          file.lastModifiedDate = new Date();
          file.name = 'audio.mp3';
          return file;
        });
      },
      close: function close() {
        return recorder.close();
      }
    };
  };

  AudioUploadControlButton.prototype.render = function () {
    var Glyph = this.props.icon;
    return React__default.createElement("div", {
      title: this.props.title ? this.props.title : 'Upload Media'
    }, this.state.recorder && this.state.showModal && React__default.createElement(AudioUploadControlModal, {
      accept: this.props.accept,
      onClose: this.handleClose,
      onFileCompleted: this.handleFileCompleted,
      recorder: this.state.recorder
    }), React__default.createElement(Glyph, {
      className: styles$r.button,
      onClick: this.handleClick
    }));
  };

  return AudioUploadControlButton;
}(MediaUploadControlBase);

var AudioUploadControl = function AudioUploadControl(props) {
  return React__default.createElement(AudioUploadControlButton, __assign({
    accept: ['audio/mp4', 'audio/mpeg'],
    previews: [AudioUploadPreview],
    icon: Icon$2,
    recorder: props.recorder,
    title: "Upload Audio"
  }, props));
};

var styles$s = {"container":"styles_container__1CbTd","image":"styles_image__WoqjM"};

var GifPreview =
/** @class */
function (_super) {
  __extends(GifPreview, _super);

  function GifPreview() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GifPreview.prototype.render = function () {
    return React__default.createElement("div", {
      className: styles$s.container
    }, React__default.createElement("img", {
      className: styles$s.image,
      src: this.props.data.url
    }));
  };

  return GifPreview;
}(PureComponent);

var styles$t = {"breakpoint-sm":"(min-width: 40em)","content":"styles_content__3dX2Z","title":"styles_title__3LBnT mt0","breakpointSm":"(min-width: 40em)"};

var GifSearchModal = function GifSearchModal(_a) {
  var isOpen = _a.isOpen,
      _onSelect = _a.onSelect,
      onRequestClose = _a.onRequestClose;
  return React__default.createElement(FancyModal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose
  }, React__default.createElement(FancyContent, {
    className: styles$t.content
  }, React__default.createElement("h1", {
    className: styles$t.title
  }, "Send Gifs"), React__default.createElement(Tenor, {
    token: "795CQZI08X25",
    onSelect: function onSelect(result) {
      _onSelect(result);

      onRequestClose();
    }
  })));
};

var _extends$l = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$l(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var GifIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$l(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$l({
    width: "24",
    height: "20",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("title", null, "Group 78"), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M0-2h24v24H0z"
  }), React__default.createElement("path", {
    d: "M1 1h22v18H1z",
    strokeLinecap: "square",
    stroke: "#3D4E56",
    strokeWidth: "2"
  }), React__default.createElement("path", {
    d: "M13 5v10M17 5v10M21 6h-4M20 10h-3M10 6H4v8h5v-4H7",
    stroke: "#3D4E56",
    strokeWidth: "2"
  })));
});

var styles$u = {"button":"styles_button__1TMju"};

var GifControl =
/** @class */
function (_super) {
  __extends(GifControl, _super);

  function GifControl(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      isModalOpen: false
    };
    _this.toMessage = _this.toMessage.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleGifChanged = _this.handleGifChanged.bind(_this);
    return _this;
  }

  GifControl.prototype.handleClick = function (_event) {
    this.setState(function (prevState) {
      return {
        isModalOpen: !prevState.isModalOpen
      };
    });
  };

  GifControl.prototype.handleGifChanged = function (result) {
    var firstMedia = result.media[0];
    this.props.attach({
      data: {
        url: firstMedia.gif.url
      },
      previewer: GifPreview,
      toMessage: this.toMessage
    });
  };

  GifControl.prototype.toMessage = function (data, conversation) {
    var message = conversation.createDraftMessage();
    message.addDraftPart('IMAGE', {
      mediaUrl: data.url
    });
    return Promise.resolve(message);
  };

  GifControl.prototype.render = function () {
    var _this = this;

    return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
      title: this.props.title ? this.props.title : 'Send GIF'
    }, React__default.createElement(GifIcon, {
      className: styles$u.button,
      onClick: this.handleClick
    })), React__default.createElement(GifSearchModal, {
      isOpen: this.state.isModalOpen,
      onSelect: this.handleGifChanged,
      onRequestClose: function onRequestClose() {
        return _this.setState({
          isModalOpen: false
        });
      }
    }));
  };

  return GifControl;
}(PureComponent);

var _extends$m = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$m(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Chat$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$m(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$m({
    width: "24",
    height: "16",
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("title", null, "video"), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M0-4h24v24H0z"
  }), React__default.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1 1)",
    stroke: "#3D4E56",
    strokeWidth: "2"
  }, React__default.createElement("path", {
    d: "M22 2l-7 5 7 5z"
  }), React__default.createElement("rect", {
    width: "15",
    height: "14",
    rx: "2"
  }))));
});

var styles$v = {"button":"styles_button__D-_gK","hidden":"styles_hidden__A7qD9"};

var StartVideoChatControl =
/** @class */
function (_super) {
  __extends(StartVideoChatControl, _super);

  function StartVideoChatControl(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleEnd = _this.handleEnd.bind(_this);
    _this.handleError = _this.handleError.bind(_this);
    _this.handleConversationChange = _this.handleConversationChange.bind(_this);
    return _this;
  }

  StartVideoChatControl.prototype.handleEnd = function () {
    this.setState({
      token: undefined
    });
  };

  StartVideoChatControl.prototype.handleError = function (error) {
    this.props.onError(error);
    this.setState({
      token: undefined
    });
  };

  StartVideoChatControl.prototype.handleClick = function (conversationId, userId) {
    var _this = this;

    this.props.startVideoChat(conversationId, userId).then(function (token) {
      return _this.setState({
        token: token
      });
    }).catch(function (error) {
      return _this.props.onError(error);
    });
  };

  StartVideoChatControl.prototype.handleConversationChange = function (event) {
    var videoChatMetadata = event.conversation.metadata.videoChat;

    if (videoChatMetadata && Object.keys(videoChatMetadata.participants).length <= 1) {
      // Looks like all other participants declined, so ending this video chat
      this.handleEnd();
    }
  };

  StartVideoChatControl.prototype.render = function () {
    var _this = this;

    return React__default.createElement(ChatConsumer, null, function (_a) {
      var authenticatedUserId = _a.authenticatedUserId;
      var conversationId = _this.props.conversationId;

      if (!conversationId || !authenticatedUserId) {
        return null;
      }

      return React__default.createElement(React__default.Fragment, null, _this.state.token && React__default.createElement(VideoChatModal$1, {
        token: _this.state.token,
        roomName: conversationId,
        monitorOnly: false,
        onLeaveVideoChat: _this.handleEnd,
        onError: _this.handleError
      }), React__default.createElement("div", {
        title: "Video Chat"
      }, React__default.createElement(Chat$1, {
        className: styles$v.button,
        onClick: function onClick() {
          return _this.handleClick(conversationId, authenticatedUserId);
        }
      })));
    });
  };

  return StartVideoChatControl;
}(Component);

var ConversationLoader =
/** @class */
function (_super) {
  __extends(ConversationLoader, _super);

  function ConversationLoader(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    _this.listen = _this.listen.bind(_this);
    _this.unlisten = _this.unlisten.bind(_this);
    _this.updateConversation = _this.updateConversation.bind(_this);
    return _this;
  }

  ConversationLoader.prototype.componentDidMount = function () {
    if (this.props.firebaseChatClient) {
      this.updateConversation(this.props, this.props.firebaseChatClient);
    }
  };

  ConversationLoader.prototype.componentWillUnmount = function () {
    if (this.state.conversation) {
      this.unlisten(this.state.conversation);
    }
  };

  ConversationLoader.prototype.componentWillReceiveProps = function (nextProps) {
    if (nextProps.firebaseChatClient) {
      this.updateConversation(nextProps, nextProps.firebaseChatClient);
    }
  };

  ConversationLoader.prototype.updateConversation = function (props, client) {
    if (this.state.conversation && this.state.conversation.conversationId == props.conversationId) {
      return;
    }

    if (this.state.conversation) {
      this.unlisten(this.state.conversation);
    }

    var nextConversation = client.getConversation(props.conversationId);
    this.listen(nextConversation);
    this.setState({
      conversation: nextConversation
    });
  };

  ConversationLoader.prototype.listen = function (conversation) {
    var _this = this;

    conversation.once('initialized', function () {
      _this.forceUpdate();
    }, this);
    conversation.on('changed', function () {
      _this.forceUpdate();
    }, this);
  };

  ConversationLoader.prototype.unlisten = function (conversation) {
    conversation.off(undefined, undefined, this);
  };

  ConversationLoader.prototype.render = function () {
    return this.props.children(this.state.conversation);
  };

  return ConversationLoader;
}(Component);

var Conversation$2 = withChat(ConversationLoader);

function truncateMessage(message, characterLimit) {
  if (characterLimit === void 0) {
    characterLimit = 85;
  }

  var concatenated = message.parts.map(function (part) {
    return part.body.text;
  }).filter(function (text) {
    return !!text;
  }).join('. ').trim();

  if (concatenated.length > characterLimit) {
    return concatenated.slice(0, characterLimit) + '...';
  } else {
    return concatenated;
  }
}

function summarizeMessage(message, characterLimit) {
  var rootPart = message.parts[0];
  var type = rootPart.type;
  var sessionOwner = message.sentBy.isMyself;
  var messagePrefix = sessionOwner ? 'You' : message.sentBy.displayName;

  switch (type) {
    case 'IMAGE':
      return messagePrefix + " sent a photo.";

    case 'VIDEO':
      return messagePrefix + " sent a video.";

    case 'OFFER':
      return messagePrefix + " sent a new offer.";

    case 'TEXT':
    case 'TEMPLATE':
    case 'TEMPLATE_TEXT':
    case 'HYPERLINK_TEXT':
    case 'TEMPLATE_CAROUSEL':
      messagePrefix = sessionOwner ? 'You: ' : '';
      return "" + messagePrefix + truncateMessage(message, characterLimit);

    default:
      return messagePrefix + " sent a new message.";
  }
}

function formatParticipants(participants) {
  return participants.filter(function (participant) {
    return !participant.isMyself;
  }).map(function (participant) {
    return participant.displayName;
  }).join(', ');
}

// Containers

export { AudioUploadControl, FirebaseAvatar as Avatar, ChatContainer as Chat, ChatConsumer, ChatContext, ExternalChatProvider as ChatProvider, index$1 as ChatWidget, Composer$1 as Composer, Conversation$1 as Conversation, Conversation$2 as ConversationLoader, GifControl, ImageUploadControl, MessageBubble, MessageBubbleImage, MessageBubbleText, MessageNewVideoChatContainer as MessageNewVideoChat, index as Notifier, StartVideoChatControl, VideoChatModal$1 as VideoChatModal, VideoUploadControl, formatParticipants, summarizeMessage, truncateMessage, withChat };
//# sourceMappingURL=index.esm.js.map
